const lang = `<?xml version="1.0" encoding="utf-8" standalone="yes"?>
<Localization language="Ukrainian" description="Українська" cultureName="uk">
  <A_WebViewer>
    <AbbreviatedDayFriday>Пт</AbbreviatedDayFriday>
    <AbbreviatedDayMonday>Пн</AbbreviatedDayMonday>
    <AbbreviatedDaySaturday>Сб</AbbreviatedDaySaturday>
    <AbbreviatedDaySunday>Нд</AbbreviatedDaySunday>
    <AbbreviatedDayThursday>Чт</AbbreviatedDayThursday>
    <AbbreviatedDayTuesday>Вт</AbbreviatedDayTuesday>
    <AbbreviatedDayWednesday>Ср</AbbreviatedDayWednesday>
    <Attachment>Вкладення:</Attachment>
    <DayFriday>П'ятниця</DayFriday>
    <DayMonday>Понеділок</DayMonday>
    <DaySaturday>Субота</DaySaturday>
    <DaySunday>Неділя</DaySunday>
    <DayThursday>Четвер</DayThursday>
    <DayTuesday>Вівторок</DayTuesday>
    <DayWednesday>Середа</DayWednesday>
    <Email>Email:</Email>
    <EmailOptions>Налаштування відправки Email</EmailOptions>
    <FirstPage>Перша сторінка</FirstPage>
    <Hours>Години</Hours>
    <LastPage>Остання сторінка</LastPage>
    <Loading>Завантаження...</Loading>
    <Message>Повідомлення:</Message>
    <Minutes>Хвилини</Minutes>
    <MonthApril>Квітень</MonthApril>
    <MonthAugust>Серпень</MonthAugust>
    <MonthDecember>Грудень</MonthDecember>
    <MonthFebruary>Лютий</MonthFebruary>
    <MonthJanuary>Січень</MonthJanuary>
    <MonthJuly>Липень</MonthJuly>
    <MonthJune>Червень</MonthJune>
    <MonthMarch>Березень</MonthMarch>
    <MonthMay>Травень</MonthMay>
    <MonthNovember>Листопад</MonthNovember>
    <MonthOctober>Жовтень</MonthOctober>
    <MonthSeptember>Вересень</MonthSeptember>
    <NextPage>Наступна сторінка</NextPage>
    <OnePage>Одна сторінка</OnePage>
    <Page>Сторінка</Page>
    <PageOf>із</PageOf>
    <PreviousPage>Попередня сторінка</PreviousPage>
    <PrintContinue>Натисніть кнопку Друк для продовження</PrintContinue>
    <PrintReport>Друкувати</PrintReport>
    <PrintToPdf>PDF</PrintToPdf>
    <PrintToXps>Друк в XPS</PrintToXps>
    <PrintWithoutPreview>Друкувати без попереднього перегляду</PrintWithoutPreview>
    <PrintWithPreview>Друкувати з попереднім переглядом</PrintWithPreview>
    <SaveReport>Зберегти</SaveReport>
    <Subject>Тема:</Subject>
    <TodayDate>Сьогодні</TodayDate>
    <WholeReport>Весь звіт</WholeReport>
  </A_WebViewer>
  <Adapters>
    <AdapterBusinessObjects>Дані з Business Objects</AdapterBusinessObjects>
    <AdapterConnection>Дані з {0}</AdapterConnection>
    <AdapterCrossTabDataSource>Дані на основі Крос-Таблиці</AdapterCrossTabDataSource>
    <AdapterCsvFiles>Дані з CSV файлів</AdapterCsvFiles>
    <AdapterDataTables>Дані з DataSet, DataTables</AdapterDataTables>
    <AdapterDataViews>Дані з DataViews</AdapterDataViews>
    <AdapterDB2Connection>Дані з IBM DB2 з'єднання</AdapterDB2Connection>
    <AdapterDBaseFiles>Дані з dBase файлів</AdapterDBaseFiles>
    <AdapterFirebirdConnection>Дані з Firebird з'єднання</AdapterFirebirdConnection>
    <AdapterInformixConnection>Дані з Informix з'єднання</AdapterInformixConnection>
    <AdapterMySQLConnection>Дані з MySQL з'єднання</AdapterMySQLConnection>
    <AdapterOdbcConnection>Дані з ODBC з'єднання</AdapterOdbcConnection>
    <AdapterOleDbConnection>Дані з OLE DB з'єднання</AdapterOleDbConnection>
    <AdapterOracleConnection>Дані з Oracle з'єднання</AdapterOracleConnection>
    <AdapterOracleODPConnection>Дані з Oracle ODP.NET з'єднання</AdapterOracleODPConnection>
    <AdapterPostgreSQLConnection>Дані з PostgreSQL з'єднання</AdapterPostgreSQLConnection>
    <AdapterSqlCeConnection>Дані з SQLCe з'єднання</AdapterSqlCeConnection>
    <AdapterSqlConnection>Дані з SQL з'єднання</AdapterSqlConnection>
    <AdapterSQLiteConnection>Дані з SQLite з'єднання</AdapterSQLiteConnection>
    <AdapterTeradataConnection>Дані з Teradata з'єднання</AdapterTeradataConnection>
    <AdapterUniDirectConnection>Дані з Однонаправленого з'єднання</AdapterUniDirectConnection>
    <AdapterUserSources>Дані з User Sources</AdapterUserSources>
    <AdapterVirtualSource>Дані з іншого Набору Даних (Data Source)</AdapterVirtualSource>
    <AdapterVistaDBConnection>Дані з VistaDB з'єднання</AdapterVistaDBConnection>
  </Adapters>
  <Buttons>
    <Add>Додати</Add>
    <AddAllColumns>Додати всі стовпчики</AddAllColumns>
    <Build>Побудова...</Build>
    <Cancel>Скасувати</Cancel>
    <Close>Закрити</Close>
    <Delete>Видалити</Delete>
    <Design>Дизайн</Design>
    <Down>Вниз</Down>
    <Duplicate>Дублювати</Duplicate>
    <Export>Експорт</Export>
    <Help>Допомога</Help>
    <LoadDataSet>Завантажити DataSet (*.data)</LoadDataSet>
    <MoveLeft>Перемістити вліво</MoveLeft>
    <MoveRight>Перемістити вправо</MoveRight>
    <No>&amp;Ні</No>
    <Ok>&amp;ОК</Ok>
    <Open>Відкрити</Open>
    <Print>Друк</Print>
    <QuickPrint>Швидкий друк</QuickPrint>
    <Remove>Видалити</Remove>
    <RemoveAll>Видалити все</RemoveAll>
    <Rename>Перейменувати</Rename>
    <RestoreDefaults>Стандартні значення</RestoreDefaults>
    <Reverse>Перевернути</Reverse>
    <Save>Зберегти</Save>
    <SaveCopy>Зберегти копію</SaveCopy>
    <SetAll>Встановити всі</SetAll>
    <Submit>Застосувати</Submit>
    <Test>Перевірка</Test>
    <Up>Вгору</Up>
    <Yes>&amp;Так</Yes>
  </Buttons>
  <Chart>
    <AddCondition>&amp;Додати умову</AddCondition>
    <AddConstantLine>Додати Постійну Лінію</AddConstantLine>
    <AddFilter>&amp;Додати фільтр</AddFilter>
    <AddSeries>Додати ряд</AddSeries>
    <AddStrip>Додати стрічку</AddStrip>
    <Area>Область</Area>
    <Axes>Осі</Axes>
    <AxisReverse>Реверс</AxisReverse>
    <AxisX>Вісь X</AxisX>
    <AxisY>Вісь Y</AxisY>
    <Bubble>Бульбашкова</Bubble>
    <Candlestick>Японські свічки</Candlestick>
    <ChartConditionsCollectionForm>Умова</ChartConditionsCollectionForm>
    <ChartFiltersCollectionForm>Фільтри</ChartFiltersCollectionForm>
    <ChartType>Тип діаграми</ChartType>
    <CheckBoxAutoRotation>Автоповорот</CheckBoxAutoRotation>
    <ClusteredBar>Лінійчата</ClusteredBar>
    <ClusteredColumn>Гістограма</ClusteredColumn>
    <Common>Основні</Common>
    <ConstantLine>Постійна Лінія</ConstantLine>
    <ConstantLinesEditorForm>Редактор Постійних Ліній</ConstantLinesEditorForm>
    <DataColumns>Стовпчики даних</DataColumns>
    <Doughnut>Кільцева</Doughnut>
    <Financial>Фінансова</Financial>
    <FullStackedArea>Нормована область</FullStackedArea>
    <FullStackedBar>Нормована лінійчата</FullStackedBar>
    <FullStackedColumn>Нормована гістограма</FullStackedColumn>
    <FullStackedLine>Нормована лінія</FullStackedLine>
    <FullStackedSpline>Нормована згладжена лінія</FullStackedSpline>
    <FullStackedSplineArea>Нормована згладжена область</FullStackedSplineArea>
    <Funnel>Воронка</Funnel>
    <FunnelWeightedSlices>Зважена воронка</FunnelWeightedSlices>
    <Gantt>Графік Гантта</Gantt>
    <GridInterlaced>Переплетена</GridInterlaced>
    <GridLines>Лінії сітки</GridLines>
    <LabelAlignment>Вирівнювання:</LabelAlignment>
    <LabelAlignmentHorizontal>Горизонтальне:</LabelAlignmentHorizontal>
    <LabelAlignmentVertical>Вертикальне:</LabelAlignmentVertical>
    <LabelAngle>Кут:</LabelAngle>
    <LabelArgumentDataColumn>Стовпчик даних аргументу:</LabelArgumentDataColumn>
    <LabelAutoRotation>Автоматичне повертання:</LabelAutoRotation>
    <LabelCloseValueDataColumn>Стовпчик закриваючих значень:</LabelCloseValueDataColumn>
    <LabelEndValueDataColumn>Стовпчик кінцевих значень:</LabelEndValueDataColumn>
    <LabelHighValueDataColumn>Стовпчик максимумів:</LabelHighValueDataColumn>
    <LabelHorizontal>Горизонтальний:</LabelHorizontal>
    <LabelLowValueDataColumn>Стовпчик мінімумів:</LabelLowValueDataColumn>
    <LabelMinorCount>Кількість проміжних ліній:</LabelMinorCount>
    <LabelOpenValueDataColumn>Стовпчик відкриваючих значень:</LabelOpenValueDataColumn>
    <Labels>Написи</Labels>
    <LabelsCenter>По центру</LabelsCenter>
    <LabelSeriesName>Назва ряду:</LabelSeriesName>
    <LabelsInside>Всередині</LabelsInside>
    <LabelsInsideBase>Всередині на початку</LabelsInsideBase>
    <LabelsInsideEnd>Всередині в кінці</LabelsInsideEnd>
    <LabelsNone>Ні</LabelsNone>
    <LabelsOutside>Зовні</LabelsOutside>
    <LabelsOutsideBase>Зовні на початку</LabelsOutsideBase>
    <LabelsOutsideEnd>Зовні в кінці</LabelsOutsideEnd>
    <LabelsTwoColumns>Два стовпчики</LabelsTwoColumns>
    <LabelTextAfter>Текст після:</LabelTextAfter>
    <LabelTextBefore>Текст попереду:</LabelTextBefore>
    <LabelTitleAlignment>Вирівнювання:</LabelTitleAlignment>
    <LabelValueDataColumn>Стовпчик даних значень:</LabelValueDataColumn>
    <LabelValueType>Тип значення:</LabelValueType>
    <LabelVertical>Вертикальний:</LabelVertical>
    <LabelVisible>Видимий:</LabelVisible>
    <Legend>Легенда</Legend>
    <LegendSpacing>Інтервал</LegendSpacing>
    <Line>Лінія</Line>
    <ListOfValues>Список Колонок</ListOfValues>
    <Marker>Маркер</Marker>
    <MoveConstantLineDown>Перемістити постійну лінію вниз</MoveConstantLineDown>
    <MoveConstantLineUp>Перемістити постійну лінію вгору</MoveConstantLineUp>
    <MoveSeriesDown>Перемістити ряд вниз</MoveSeriesDown>
    <MoveSeriesUp>Перемістити ряд вгору</MoveSeriesUp>
    <MoveStripDown>Перемістити стрічку вниз</MoveStripDown>
    <MoveStripUp>Перемістити стрічку вгору</MoveStripUp>
    <NoConditions>Немає умов</NoConditions>
    <NoFilters>Немає фільтрів</NoFilters>
    <Pie>Кругова</Pie>
    <Radar>Пелюсткова</Radar>
    <RadarArea>Пелюсткова з областю</RadarArea>
    <RadarColumn>Пелюсткова з колонками</RadarColumn>
    <RadarLine>Пелюсткова з лінією</RadarLine>
    <RadarPoint>Пелюсткова з крапками</RadarPoint>
    <Range>Діапазон</Range>
    <RangeBar>Стовпчастий діапазон</RangeBar>
    <RemoveCondition>&amp;Видалити умову</RemoveCondition>
    <RemoveConstantLine>Видалити постійну лінію</RemoveConstantLine>
    <RemoveFilter>&amp;Видалити фільтр</RemoveFilter>
    <RemoveSeries>Видалити ряд</RemoveSeries>
    <RemoveStrip>Видалити стрічку</RemoveStrip>
    <RunChartWizard>Запустити помічник &amp;діаграм</RunChartWizard>
    <Scatter>Точкова</Scatter>
    <ScatterLine>Точкова з лініями</ScatterLine>
    <ScatterSpline>Точкова зі сплайнами</ScatterSpline>
    <Series>Ряд</Series>
    <SeriesColorsCollectionForm>Сірого кольору</SeriesColorsCollectionForm>
    <SeriesEditorForm>Редактор рядів</SeriesEditorForm>
    <Serieses>Ряди</Serieses>
    <Spline>Згладжена лінія</Spline>
    <SplineArea>Згладжена область</SplineArea>
    <SplineRange>Згладжений діапазон</SplineRange>
    <StackedArea>Область з накопиченням</StackedArea>
    <StackedBar>Лінійчата з накопиченням</StackedBar>
    <StackedColumn>Гістограма з накопиченням</StackedColumn>
    <StackedLine>Лінія з накопиченням</StackedLine>
    <StackedSpline>Згладжена лінія з накопиченням</StackedSpline>
    <StackedSplineArea>Згладжена область з накопиченням</StackedSplineArea>
    <SteppedArea>Покрокова область</SteppedArea>
    <SteppedLine>Покрокова лінія</SteppedLine>
    <SteppedRange>Покроковий діапазон</SteppedRange>
    <Stock>Біржова</Stock>
    <Strip>Стрічка</Strip>
    <StripsEditorForm>Форма редагування стрічок</StripsEditorForm>
    <Style>Стиль</Style>
  </Chart>
  <ChartRibbon>
    <Axes>Осі</Axes>
    <AxesArrowStyle>Стиль стрілки</AxesArrowStyle>
    <AxesArrowStyleLines>Лінії</AxesArrowStyleLines>
    <AxesArrowStyleNone>Немає</AxesArrowStyleNone>
    <AxesArrowStyleTriangle>Трикутник</AxesArrowStyleTriangle>
    <AxesLabel>Розміщення підписів</AxesLabel>
    <AxesLabelsNone>Немає</AxesLabelsNone>
    <AxesLabelsOneLine>В одну лінія</AxesLabelsOneLine>
    <AxesLabelsTwoLines>У дві лінії</AxesLabelsTwoLines>
    <AxesReverseHorizontal>Перевернути по горизонталі</AxesReverseHorizontal>
    <AxesReverseVertical>Перевернути по вертикалі</AxesReverseVertical>
    <AxesTicks>Підписи</AxesTicks>
    <AxesTicksMajor>Основні</AxesTicksMajor>
    <AxesTicksMinor>Проміжні</AxesTicksMinor>
    <AxesTicksNone>Немає</AxesTicksNone>
    <AxesVisible>Показувати</AxesVisible>
    <AxesXAxis>Вісь X</AxesXAxis>
    <AxesXTopAxis>Верхня вісь X</AxesXTopAxis>
    <AxesYAxis>Вісь Y</AxesYAxis>
    <AxesYRightAxis>Права вісь Y</AxesYRightAxis>
    <CenterLabels>По центру</CenterLabels>
    <ChangeType>Змінити тип</ChangeType>
    <GridLines>Лінії сітки</GridLines>
    <GridLinesHorizontal>Горизонтальні лінії</GridLinesHorizontal>
    <GridLinesVertical>Вертикальні лінії</GridLinesVertical>
    <HorAlCenter>&lt;b&gt;Легенда по центру з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду по центру діаграми з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</HorAlCenter>
    <HorAlLeft>&lt;b&gt;Легенда ліворуч з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду ліворуч від діаграми з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</HorAlLeft>
    <HorAlLeftOutside>&lt;b&gt;Легенда ліворуч&lt;/b&gt;&lt;br&gt;Показувати легенду ліворуч від діаграми&lt;/br&gt;</HorAlLeftOutside>
    <HorAlRight>&lt;b&gt;Легенда праворуч з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду праворуч від діаграми з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</HorAlRight>
    <HorAlRightOutside>&lt;b&gt;Легенда праворуч&lt;/b&gt;&lt;br&gt;Показувати легенду праворуч від діаграми&lt;/br&gt;</HorAlRightOutside>
    <HorizontalMajor>&lt;b&gt;Основні&lt;/b&gt;&lt;br&gt;Показувати горизонтальні лінії основної сітки&lt;/br&gt;</HorizontalMajor>
    <HorizontalMajorMinor>&lt;b&gt;Основні та проміжні&lt;/b&gt;&lt;br&gt;Показувати горизонтальні лінії основної та проміжної сітки&lt;/br&gt;</HorizontalMajorMinor>
    <HorizontalMinor>&lt;b&gt;Проміжні&lt;/b&gt;&lt;br&gt;Показувати горизонтальні лінії проміжної сітки&lt;/br&gt;</HorizontalMinor>
    <HorizontalNone>&lt;b&gt;Немає&lt;/b&gt;&lt;br&gt;Не показувати горизонтальні лінії&lt;/br&gt;</HorizontalNone>
    <InsideBaseLabels>Біля основи, всередині</InsideBaseLabels>
    <InsideEndLabels>Біля вершини, всередині</InsideEndLabels>
    <Labels>Підписи даних</Labels>
    <Legend>Легенда</Legend>
    <LegendHorizontalAlignment>Горизонтальне розміщення</LegendHorizontalAlignment>
    <LegendMarker>Маркери</LegendMarker>
    <LegendMarkerAlignmentLeft>Ліворуч</LegendMarkerAlignmentLeft>
    <LegendMarkerAlignmentRight>Праворуч</LegendMarkerAlignmentRight>
    <LegendMarkerVisible>Показувати</LegendMarkerVisible>
    <LegendVerticalAlignment>Вертикальне розміщення</LegendVerticalAlignment>
    <LegendVisible>Показувати</LegendVisible>
    <NoneLabels>Немає</NoneLabels>
    <OutsideBaseLabels>Біля основи, зовні</OutsideBaseLabels>
    <OutsideEndLabels>Біля вершини, зовні</OutsideEndLabels>
    <OutsideLabels>Зовні</OutsideLabels>
    <ribbonBarAxis>Осі</ribbonBarAxis>
    <ribbonBarChartStyles>Стиль діаграми</ribbonBarChartStyles>
    <ribbonBarChartType>Тип діаграми</ribbonBarChartType>
    <ribbonBarLabels>Підписи</ribbonBarLabels>
    <ribbonBarLegend>Легенда</ribbonBarLegend>
    <Style>Змінити стиль</Style>
    <TwoColumnsPieLabels>Два стовпчики</TwoColumnsPieLabels>
    <VertAlBottom>&lt;b&gt;Легенда знизу з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду під діаграмою з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</VertAlBottom>
    <VertAlBottomOutside>&lt;b&gt;Легенда знизу&lt;/b&gt;&lt;br&gt;Показувати легенду під діаграмою&lt;/br&gt;</VertAlBottomOutside>
    <VertAlCenter>&lt;b&gt;Легенда по центру з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду по центру діаграми з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</VertAlCenter>
    <VertAlTop>&lt;b&gt;Легенда зверху з перекриттям&lt;/b&gt;&lt;br&gt;Показувати легенду над діаграмою з перекриттям&lt;/br&gt;&lt;br&gt;без зміни розмірів&lt;/br&gt;</VertAlTop>
    <VertAlTopOutside>&lt;b&gt;Легенда зверху&lt;/b&gt;&lt;br&gt;Показувати легенду над діаграмою&lt;/br&gt;</VertAlTopOutside>
    <VerticalMajor>&lt;b&gt;Основні&lt;/b&gt;&lt;br&gt;Показувати вертикальні лінії основної сітки&lt;/br&gt;</VerticalMajor>
    <VerticalMajorMinor>&lt;b&gt;Основні та проміжні&lt;/b&gt;&lt;br&gt;Показувати вертикальні лінії основної та проміжної сітки&lt;/br&gt;</VerticalMajorMinor>
    <VerticalMinor>&lt;b&gt;Проміжні&lt;/b&gt;&lt;br&gt;Показувати вертикальні лінії проміжної сітки&lt;/br&gt;</VerticalMinor>
    <VerticalNone>&lt;b&gt;Немає&lt;/b&gt;&lt;br&gt;Не показувати вертикальні лінії&lt;/br&gt;</VerticalNone>
  </ChartRibbon>
  <Cloud>
    <AccountSettings>Параметри облікового запису</AccountSettings>
    <ButtonShare>Поділитися</ButtonShare>
    <Cancel>Відмінити</Cancel>
    <Collection>Колекція</Collection>
    <Create>Створити</Create>
    <CreateNewCollection>Створити нову колекцію</CreateNewCollection>
    <DeleteFile>Видалити файл</DeleteFile>
    <labelCollectionName>Назва колекції:</labelCollectionName>
    <labelFileName>Назва файлу:</labelFileName>
    <labelPassword>Пароль:</labelPassword>
    <labelUserName>Ім'я користувача:</labelUserName>
    <Login>Війти</Login>
    <Open>Відкрити</Open>
    <OpenFile>Фідкрити файл</OpenFile>
    <OperationCreate>Створити '{0}'</OperationCreate>
    <OperationDelete>Видалити '{0}' з сервера</OperationDelete>
    <OperationDownload>Скачати з сервера</OperationDownload>
    <OperationGetList>Отримати список файлів з сервера</OperationGetList>
    <OperationLogin>З'єднатися з сервером</OperationLogin>
    <OperationRename>Перейменувати '{0}' в '{1}'</OperationRename>
    <OperationUpload>Відправити '{0}' на сервер</OperationUpload>
    <page>сторінка</page>
    <questionOpenThisFile>Ви дійсно хочете відкрити '{0}' файл?</questionOpenThisFile>
    <questionOverrideItem>Ви дійсно хочете перезаписати '{0}' файл?</questionOverrideItem>
    <questionRemoveItem>Ви дійсно хочете видалити '{0}' файл?</questionRemoveItem>
    <RefreshList>Оновити список</RefreshList>
    <ReportDocumentFormatNotRecognized>Формат файлу '{0}' не розпізнано як формат готового звіту!</ReportDocumentFormatNotRecognized>
    <ReportTemplateFormatNotRecognized>Формат файлу '{0}' не розпізнано як формат шаблона звіту!</ReportTemplateFormatNotRecognized>
    <Root>Основний</Root>
    <Save>Зберегти</Save>
    <SaveAccountSettings>Зберегти параметри облікового запису</SaveAccountSettings>
    <SaveFile>Зберегти файл</SaveFile>
    <ShareWindowTitleNew>Поділитися</ShareWindowTitleNew>
    <ShowAllFiles>Показати всі файли</ShowAllFiles>
  </Cloud>
  <Components>
    <StiBarCode>Штрих-код</StiBarCode>
    <StiChart>Діаграма</StiChart>
    <StiCheckBox>Прапорець</StiCheckBox>
    <StiChildBand>Дочірній</StiChildBand>
    <StiClone>Клон</StiClone>
    <StiColumnFooterBand>Підсумок стовпчика</StiColumnFooterBand>
    <StiColumnHeaderBand>Заголовок стовпчика</StiColumnHeaderBand>
    <StiComponent>Компонент</StiComponent>
    <StiContainer>Контейнер</StiContainer>
    <StiContourText>Контурний текст</StiContourText>
    <StiCrossColumn>Крос-стовпчик</StiCrossColumn>
    <StiCrossColumnTotal>Крос-підсумок по стовпчику</StiCrossColumnTotal>
    <StiCrossDataBand>Крос-дані</StiCrossDataBand>
    <StiCrossFooterBand>Крос-підсумок даних</StiCrossFooterBand>
    <StiCrossGroupFooterBand>Крос-підсумок групи</StiCrossGroupFooterBand>
    <StiCrossGroupHeaderBand>Крос-заголовок групи</StiCrossGroupHeaderBand>
    <StiCrossHeaderBand>Крос-заголовок даних</StiCrossHeaderBand>
    <StiCrossRow>Крос-рядок</StiCrossRow>
    <StiCrossRowTotal>Крос-підсумок по рядку</StiCrossRowTotal>
    <StiCrossSummary>Крос-сума</StiCrossSummary>
    <StiCrossSummaryHeader>Заголовок Крос-суми</StiCrossSummaryHeader>
    <StiCrossTab>Крос-таблиця</StiCrossTab>
    <StiCrossTitle>Крос-заголовок</StiCrossTitle>
    <StiDataBand>Дані</StiDataBand>
    <StiEmptyBand>Порожні дані</StiEmptyBand>
    <StiFooterBand>Підсумок даних</StiFooterBand>
    <StiGauge>Індикатор</StiGauge>
    <StiGroupFooterBand>Підсумок групи</StiGroupFooterBand>
    <StiGroupHeaderBand>Заголовок групи</StiGroupHeaderBand>
    <StiHeaderBand>Заголовок даних</StiHeaderBand>
    <StiHierarchicalBand>Ієрархічний бенд</StiHierarchicalBand>
    <StiHorizontalLinePrimitive>Горизонтальна лінія</StiHorizontalLinePrimitive>
    <StiImage>Зображення</StiImage>
    <StiOverlayBand>Оверлейний бенд</StiOverlayBand>
    <StiPage>Сторінка</StiPage>
    <StiPageFooterBand>Підсумок сторінки</StiPageFooterBand>
    <StiPageHeaderBand>Заголовок сторінки</StiPageHeaderBand>
    <StiPanel>Панель</StiPanel>
    <StiRectanglePrimitive>Прямокутник</StiRectanglePrimitive>
    <StiReport>Звіт</StiReport>
    <StiReportSummaryBand>Підсумок звіту</StiReportSummaryBand>
    <StiReportTitleBand>Заголовок звіту</StiReportTitleBand>
    <StiRichText>Rich-текст</StiRichText>
    <StiRoundedRectanglePrimitive>Округлений прямокутник</StiRoundedRectanglePrimitive>
    <StiShape>Геометрія</StiShape>
    <StiSubReport>Вкладений звіт</StiSubReport>
    <StiSystemText>Системний текст</StiSystemText>
    <StiTable>Таблиця</StiTable>
    <StiText>Текст</StiText>
    <StiTextInCells>Текст в клітинках</StiTextInCells>
    <StiVerticalLinePrimitive>Вертикальна лінія</StiVerticalLinePrimitive>
    <StiWinControl>Win-компонент</StiWinControl>
    <StiZipCode>Поштовий індекс</StiZipCode>
  </Components>
  <Database>
    <Connection>З'єднання</Connection>
    <Database>{0} з'єднання</Database>
    <DatabaseDB2>IBM DB2 з'єднання</DatabaseDB2>
    <DatabaseFirebird>Firebird з'єднання</DatabaseFirebird>
    <DatabaseInformix>Informix з'єднання</DatabaseInformix>
    <DatabaseMySQL>MySQL з'єднання</DatabaseMySQL>
    <DatabaseOdbc>ODBC з'єднання</DatabaseOdbc>
    <DatabaseOleDb>OLE DB з'єднання</DatabaseOleDb>
    <DatabaseOracle>Oracle з'єднання</DatabaseOracle>
    <DatabaseOracleODP>Oracle ODP.NET з'єднання</DatabaseOracleODP>
    <DatabasePostgreSQL>PostgreSQL з'єднання</DatabasePostgreSQL>
    <DatabaseSql>SQL з'єднання</DatabaseSql>
    <DatabaseSqlCe>SQLServerCE з'єднання</DatabaseSqlCe>
    <DatabaseSQLite>SQLite з'єднання</DatabaseSQLite>
    <DatabaseTeradata>Teradata з'єднання</DatabaseTeradata>
    <DatabaseUniDirect>Однонаправлене з'єднання</DatabaseUniDirect>
    <DatabaseVistaDB>VistaDB з'єднання</DatabaseVistaDB>
    <DatabaseXml>XML дані</DatabaseXml>
  </Database>
  <DesignerFx>
    <AlreadyExists>'{0}' вже існує.</AlreadyExists>
    <CanNotLoadThisReportTemplate>Неможливо завантажити шаблон звіту.</CanNotLoadThisReportTemplate>
    <CloseDataSourceEditor>Ви бажаєте закрити редактор джерела даних?</CloseDataSourceEditor>
    <CloseEditor>Ви дійсно бажаєте закрити редактор тексту?</CloseEditor>
    <CompilingReport>Компіляція звіту</CompilingReport>
    <Connecting>З'єднання з сервером</Connecting>
    <ConnectionError>Помилка з'єднання</ConnectionError>
    <ConnectionSuccessfull>З'єднання успішно встановлено</ConnectionSuccessfull>
    <Continue>Продовжити</Continue>
    <DecryptionError>Помилка: Невірно вказано пароль або файл пошкоджено.</DecryptionError>
    <EmailSuccessfullySent>Email повідомлення відправлене успішно.</EmailSuccessfullySent>
    <ErrorAtSaving>Помилка при збереженні</ErrorAtSaving>
    <ErrorCode>Помилка при збереженні. Код помилки: {0}</ErrorCode>
    <ErrorServer>Помилка при збереженні. Сервер не відповідає.</ErrorServer>
    <ExportingReport>Експорт звіту</ExportingReport>
    <LoadingCode>Завантаження коду</LoadingCode>
    <LoadingConfiguration>Завантаження параметрів</LoadingConfiguration>
    <LoadingData>Завантаження даних</LoadingData>
    <LoadingDocument>Завантаження документа</LoadingDocument>
    <LoadingImages>Завантаження зображень</LoadingImages>
    <LoadingLanguage>Завантаження локалізації</LoadingLanguage>
    <LoadingReport>Завантаження звіту</LoadingReport>
    <PreviewAs>Попередній перегляд як {0}</PreviewAs>
    <RenderingReport>Побудова звіту</RenderingReport>
    <ReportSuccessfullySaved>Звіт збережений успішно.</ReportSuccessfullySaved>
    <RetrieveError>Помилка отримання колонок</RetrieveError>
    <RetrievingColumns>Отримання колонок</RetrievingColumns>
    <SavingConfiguration>Збереження конфігурації</SavingConfiguration>
    <SavingReport>Збереження звіту</SavingReport>
    <TestConnection>Перевірка з'єднання</TestConnection>
    <TextNotFound>Вказаний текст не знайдено. Текст : {0}</TextNotFound>
  </DesignerFx>
  <Dialogs>
    <StiButtonControl>Кнопка</StiButtonControl>
    <StiCheckBoxControl>Прапорець</StiCheckBoxControl>
    <StiCheckedListBoxControl>Список із прапорцями</StiCheckedListBoxControl>
    <StiComboBoxControl>Поле зі списком</StiComboBoxControl>
    <StiDateTimePickerControl>Вибір дати</StiDateTimePickerControl>
    <StiForm>Форма</StiForm>
    <StiGridControl>Таблиця</StiGridControl>
    <StiGroupBoxControl>Група</StiGroupBoxControl>
    <StiLabelControl>Напис</StiLabelControl>
    <StiListBoxControl>Список</StiListBoxControl>
    <StiListViewControl>Список (List View)</StiListViewControl>
    <StiLookUpBoxControl>Поле зі списком з кодом</StiLookUpBoxControl>
    <StiNumericUpDownControl>Число вгору вниз</StiNumericUpDownControl>
    <StiPanelControl>Панель</StiPanelControl>
    <StiPictureBoxControl>Малюнок</StiPictureBoxControl>
    <StiRadioButtonControl>Перемикач</StiRadioButtonControl>
    <StiReportControl>Елемент керування</StiReportControl>
    <StiRichTextBoxControl>Rich Text Box</StiRichTextBoxControl>
    <StiTextBoxControl>Текстове поле</StiTextBoxControl>
    <StiTreeViewControl>Дерево</StiTreeViewControl>
  </Dialogs>
  <Editor>
    <CantFind>Дані, що задовольняють умові пошуку, не виявлені.</CantFind>
    <CollapseToDefinitions>Згорнути у визначення</CollapseToDefinitions>
    <Column>Стовпчик: {0}</Column>
    <EntireScope>&amp;З початку</EntireScope>
    <Find>Зна&amp;йти</Find>
    <FindNext>Зна&amp;йти далі</FindNext>
    <FindWhat>Знайти:</FindWhat>
    <FromCursor>Від по&amp;зиції курсору</FromCursor>
    <GotoLine>&amp;Перейти на лінію</GotoLine>
    <Line>Лінія: {0}</Line>
    <LineNumber>Номер лінії:</LineNumber>
    <LineNumberIndex>Номер лінії ({0} - {1})</LineNumberIndex>
    <MarkAll>По&amp;мітити все</MarkAll>
    <MatchCase>&amp;Враховувати регістр</MatchCase>
    <MatchWholeWord>&amp;Лише слово цілком</MatchWholeWord>
    <Outlining>Зго&amp;ртання</Outlining>
    <PromptOnReplace>Пі&amp;дтвердждення заміни</PromptOnReplace>
    <Replace>За&amp;мінити</Replace>
    <ReplaceAll>Замінити &amp;все</ReplaceAll>
    <ReplaceWith>Замінити на:</ReplaceWith>
    <Search>Шукати</Search>
    <SearchHiddenText>П&amp;рихований текст</SearchHiddenText>
    <SearchUp>Шукати в&amp;гору</SearchUp>
    <SelectionOnly>Ті&amp;льки виділене</SelectionOnly>
    <ShowAutoGeneratedCode>Показувати автоматично згенерований код</ShowAutoGeneratedCode>
    <ShowLineNumbers>Показувати номери ліній</ShowLineNumbers>
    <StopOutlining>Зупинити згортання</StopOutlining>
    <titleFind>Знайти</titleFind>
    <titleGotoLine>Перейти на лінію</titleGotoLine>
    <titleReplace>Замінити</titleReplace>
    <ToggleAllOutlining>Перемкнути все згортання</ToggleAllOutlining>
    <ToggleOutliningExpansion>&amp;Перемкнути згортання</ToggleOutliningExpansion>
    <UseRegularExpressions>Регулярні Ви&amp;рази</UseRegularExpressions>
  </Editor>
  <Errors>
    <ComponentIsNotRelease>Компонент не реалізує '{0}'</ComponentIsNotRelease>
    <ContainerIsNotValidForComponent>Контейнер {0} не підходить для компонента {1}</ContainerIsNotValidForComponent>
    <DataNotFound>Дані не знайдені</DataNotFound>
    <Error>Помилка!</Error>
    <ErrorsList>Список помилок</ErrorsList>
    <FieldRequire>Необхідно заповнити поле "{0}"</FieldRequire>
    <FileNotFound>Файл '{0}' не знайдений</FileNotFound>
    <IdentifierIsNotValid>Неприпустимий ідентифікатор '{0}'.</IdentifierIsNotValid>
    <ImpossibleFindDataSource>Не можу знайти для компонента джерело даних</ImpossibleFindDataSource>
    <NameExists>Дублююче ім'я компонента '{0}'. Імена компонентів повинні бути унікальними.</NameExists>
    <NoServices>Сервіси не знайдені в '{0}'</NoServices>
    <NotAssign>Джерело даних не вказано.</NotAssign>
    <NotCorrectFormat>Вхідний рядок у невірному форматі.</NotCorrectFormat>
    <RelationsNotFound>Зв'язки не знайдені</RelationsNotFound>
    <ReportCannotBeSaveDueToErrors>Звіт з помилками не може бути збережений!</ReportCannotBeSaveDueToErrors>
    <ServiceNotFound>'{0}' сервіс не знайдений</ServiceNotFound>
  </Errors>
  <Export>
    <AddPageBreaks>Додати розриви сторінок</AddPageBreaks>
    <AllBands>Всі бенди</AllBands>
    <AllowAddOrModifyTextAnnotations>Дозволити додавати або модифікувати текстові анотації</AllowAddOrModifyTextAnnotations>
    <AllowCopyTextAndGraphics>Дозволити копіювати текст і графіку</AllowCopyTextAndGraphics>
    <AllowEditable>Дозволити редагування:</AllowEditable>
    <AllowModifyContents>Дозволити редагування документа</AllowModifyContents>
    <AllowPrintDocument>Дозволити друкувати документ</AllowPrintDocument>
    <BandsFilter>Фільтр бендів:</BandsFilter>
    <Color>Колір</Color>
    <Compressed>Стислий</Compressed>
    <CompressToArchive>Стиснути в архів</CompressToArchive>
    <ContinuousPages>Неперервні сторінки</ContinuousPages>
    <DataAndHeadersFooters>Дані та Заголовки/Підсумки</DataAndHeadersFooters>
    <DataOnly>Тільки дані</DataOnly>
    <DigitalSignature>Цифровий підпис</DigitalSignature>
    <DigitalSignatureCertificateNotSelected>Сертифікат не вибрано</DigitalSignatureCertificateNotSelected>
    <DigitalSignatureError>Помилка цифрового підпису на кроці</DigitalSignatureError>
    <DocumentSecurity>Безпека документа</DocumentSecurity>
    <DotMatrixMode>Матричний метод</DotMatrixMode>
    <EmbeddedFonts>Вмонтувати шрифти</EmbeddedFonts>
    <EmbeddedImageData>Вбудувати зображення</EmbeddedImageData>
    <Encoding>Кодування:</Encoding>
    <EncryptionError>Помилка шифрування на кроці</EncryptionError>
    <EscapeCodes>Escape коди</EscapeCodes>
    <ExceptEditableFields>Крім редагованих полів</ExceptEditableFields>
    <ExportDataOnly>Експортувати тільки дані</ExportDataOnly>
    <ExportEachPageToSheet>Експортувати кожну сторінку на окремий лист</ExportEachPageToSheet>
    <ExportingCalculatingCoordinates>Обчислення координат</ExportingCalculatingCoordinates>
    <ExportingCreatingDocument>Створення документа</ExportingCreatingDocument>
    <ExportingFormatingObjects>Форматування об'єктів</ExportingFormatingObjects>
    <ExportingReport>Експорт звіту</ExportingReport>
    <ExportMode>Режим експорту:</ExportMode>
    <ExportModeFrame>Рамка</ExportModeFrame>
    <ExportModeTable>Таблиця</ExportModeTable>
    <ExportObjectFormatting>Експорт форматування об'єкта</ExportObjectFormatting>
    <ExportPageBreaks>Експортувати розриви сторінок</ExportPageBreaks>
    <ExportRtfTextAsImage>Експортувати Rich Text як зображення</ExportRtfTextAsImage>
    <ExportTypeBmpFile>BMP зображення...</ExportTypeBmpFile>
    <ExportTypeCalcFile>OpenDocument Calc файл...</ExportTypeCalcFile>
    <ExportTypeCsvFile>CSV файл...</ExportTypeCsvFile>
    <ExportTypeDataFile>Файл даних...</ExportTypeDataFile>
    <ExportTypeDbfFile>DBF файл...</ExportTypeDbfFile>
    <ExportTypeDifFile>Data Interchange Format (DIF) файл...</ExportTypeDifFile>
    <ExportTypeExcel2007File>Microsoft Excel 2007 файл...</ExportTypeExcel2007File>
    <ExportTypeExcelFile>Microsoft Excel файл...</ExportTypeExcelFile>
    <ExportTypeExcelXmlFile>Microsoft Excel Xml файл...</ExportTypeExcelXmlFile>
    <ExportTypeGifFile>GІF зображення...</ExportTypeGifFile>
    <ExportTypeHtml5File>HTML5 файл...</ExportTypeHtml5File>
    <ExportTypeHtmlFile>HTML файл...</ExportTypeHtmlFile>
    <ExportTypeImageFile>Файл зображення...</ExportTypeImageFile>
    <ExportTypeJpegFile>JPEG зображення...</ExportTypeJpegFile>
    <ExportTypeMetafile>Windows Metafile...</ExportTypeMetafile>
    <ExportTypeMhtFile>MHT Web архів...</ExportTypeMhtFile>
    <ExportTypePcxFile>PCX зображення...</ExportTypePcxFile>
    <ExportTypePdfFile>Adobe PDF файл...</ExportTypePdfFile>
    <ExportTypePngFile>PNG зображення...</ExportTypePngFile>
    <ExportTypePpt2007File>Microsoft PowerPoint файл...</ExportTypePpt2007File>
    <ExportTypeRtfFile>Rich Text файл...</ExportTypeRtfFile>
    <ExportTypeSvgFile>Scalable Vector Graphics (SVG) зображення...</ExportTypeSvgFile>
    <ExportTypeSvgzFile>Compressed SVG (SVGZ) зображення...</ExportTypeSvgzFile>
    <ExportTypeSylkFile>Symbolic Link (SYLK) файл...</ExportTypeSylkFile>
    <ExportTypeTiffFile>TIFF зображення...</ExportTypeTiffFile>
    <ExportTypeTxtFile>Text файл...</ExportTypeTxtFile>
    <ExportTypeWord2007File>Microsoft Word файл...</ExportTypeWord2007File>
    <ExportTypeWriterFile>OpenDocument Writer файл...</ExportTypeWriterFile>
    <ExportTypeXmlFile>XML файл...</ExportTypeXmlFile>
    <ExportTypeXpsFile>Microsoft XPS файл...</ExportTypeXpsFile>
    <GetCertificateFromCryptoUI>Отримати сертифікат з Crypto UI</GetCertificateFromCryptoUI>
    <ImageCompressionMethod>Метод компресії зображення:</ImageCompressionMethod>
    <ImageCutEdges>Обрізати краї</ImageCutEdges>
    <ImageFormat>Формат зображення:</ImageFormat>
    <ImageGrayscale>Сірий</ImageGrayscale>
    <ImageMonochrome>Монохромний</ImageMonochrome>
    <ImageQuality>Якість зображення</ImageQuality>
    <ImageResolution>Роздільна здатність зображення:</ImageResolution>
    <ImageType>Тип зображення</ImageType>
    <labelEncryptionKeyLength>Довжина ключа шифрування:</labelEncryptionKeyLength>
    <labelOwnerPassword>Пароль власника:</labelOwnerPassword>
    <labelSubjectNameString>Ім'я суб'єкта:</labelSubjectNameString>
    <labelUserPassword>Пароль користувача:</labelUserPassword>
    <MonochromeDitheringType>Тип монохромного згладжування:</MonochromeDitheringType>
    <MoreSettings>Додаткові параметри</MoreSettings>
    <MultipleFiles>Кілька файлів</MultipleFiles>
    <OpenAfterExport>Відкрити після експорту</OpenAfterExport>
    <PdfACompliance>PDF/A стандарт</PdfACompliance>
    <RemoveEmptySpaceAtBottom>Видалити порожнє місце внизу сторінки</RemoveEmptySpaceAtBottom>
    <RestrictEditing>Обмежити редагування:</RestrictEditing>
    <Scale>Масштаб:</Scale>
    <Separator>Роздільник:</Separator>
    <Settings>Налаштування</Settings>
    <SkipColumnHeaders>Пропустити заголовки стовпчиків</SkipColumnHeaders>
    <StandardPDFFonts>Стандартні PDF шрифти</StandardPDFFonts>
    <TiffCompressionScheme>Схема компресії TIFF:</TiffCompressionScheme>
    <title>Параметри експорту</title>
    <TxtBorderType>Тип границі</TxtBorderType>
    <TxtBorderTypeDouble>Unicode подвійна</TxtBorderTypeDouble>
    <TxtBorderTypeSimple>Проста</TxtBorderTypeSimple>
    <TxtBorderTypeSingle>Unicode одинарна</TxtBorderTypeSingle>
    <TxtCutLongLines>Обрізати довгі лінії</TxtCutLongLines>
    <TxtDrawBorder>Малювати границю</TxtDrawBorder>
    <TxtKillSpaceGraphLines>Видаляти порожні графічні лінії</TxtKillSpaceGraphLines>
    <TxtKillSpaceLines>Видаляти порожні лінії</TxtKillSpaceLines>
    <TxtPutFeedPageCode>Позначати кінець сторінки</TxtPutFeedPageCode>
    <Type>Тип:</Type>
    <UseDefaultSystemEncoding>Використовувати кодування за замовчуванням</UseDefaultSystemEncoding>
    <UseDigitalSignature>Використовувати цифровий підпис</UseDigitalSignature>
    <UseEscapeCodes>Використовувати Escape коди</UseEscapeCodes>
    <UseOnePageHeaderAndFooter>Використовувати одну шапку та підвал сторінки</UseOnePageHeaderAndFooter>
    <UsePageHeadersAndFooters>Використовувати шапки та підвали сторінок</UsePageHeadersAndFooters>
    <UseUnicode>Використовувати Unicode</UseUnicode>
    <X>X:</X>
    <Y>Y:</Y>
    <Zoom>Масштаб:</Zoom>
  </Export>
  <FileFilters>
    <AllFiles>Всі файли</AllFiles>
    <AllImageFiles>Всі файли зображень</AllImageFiles>
    <BitmapFiles>Bitmap файли</BitmapFiles>
    <BmpFiles>BMP зображення (*.bmp)|*.bmp</BmpFiles>
    <CalcFiles>OpenDocument Calc файли (*.ods)|*.ods</CalcFiles>
    <CsvFiles>CSV файли (*.csv)|*.csv</CsvFiles>
    <DataSetXmlData>DataSet XML дані (*.xml)|*.xml</DataSetXmlData>
    <DataSetXmlSchema>DataSet XML схема(*.xsd)|*.xsd</DataSetXmlSchema>
    <DbfFiles>DBF файли (*.dbf)|*.dbf</DbfFiles>
    <DictionaryFiles>Файли словника (*.dct)|*.dct</DictionaryFiles>
    <DifFiles>DIF файли (*.dif)|*.dif</DifFiles>
    <DllFiles>DLL файли (*.dll)|*.dll</DllFiles>
    <DocumentFiles>Файли документів (*.mdc)|*.mdc</DocumentFiles>
    <EmfFiles>Metafile (*.emf)|*.emf</EmfFiles>
    <EncryptedDocumentFiles>Шифровані файли документів (*.mdx)|*.mdx</EncryptedDocumentFiles>
    <EncryptedReportFiles>Шифровані файли звітів (*.mrx)|*.mrx</EncryptedReportFiles>
    <Excel2007Files>Файли Microsoft Excel 2007/2013 (*.xlsx)|*.xlsx</Excel2007Files>
    <ExcelFiles>Microsoft Excel файли (*.xls)|*.xls</ExcelFiles>
    <ExcelXmlFiles>Microsoft Excel XML файли (*.xls)|*.xls</ExcelXmlFiles>
    <ExeFiles>EXE файли (*.exe)|*.exe</ExeFiles>
    <GifFiles>GIF зображення (*.gif)|*.gif</GifFiles>
    <HtmlFiles>HTML файли (*.html)|*.html</HtmlFiles>
    <InheritedLanguageFiles>{0} файли для унаслідуваних звітів (*.{1})|*.{2}</InheritedLanguageFiles>
    <JpegFiles>JPEG зображення (*.jpg;*.jpeg)|*.jpg;*.jpeg</JpegFiles>
    <LanguageFiles>{0} файли (*.{1})|*.{2}</LanguageFiles>
    <LanguageForSilverlightFiles>{0} файли для Silverlight звітів (*.{1})|*.{2}</LanguageForSilverlightFiles>
    <MetaFiles>Meta Файли</MetaFiles>
    <MhtFiles>MHT Web файли архіву (*.mht)|*.mht</MhtFiles>
    <PackedDocumentFiles>Упаковані файли документів (*.mdz)|*.mdz</PackedDocumentFiles>
    <PackedReportFiles>Упаковані файли звітів (*.mrz)|*.mrz</PackedReportFiles>
    <PageFiles>Файли сторінок (*.pg)|*.pg</PageFiles>
    <PcxFiles>PCX зображення (*.pcx)|*.pcx</PcxFiles>
    <PdfFiles>Adobe PDF файли (*.pdf)|*.pdf</PdfFiles>
    <PngFiles>PNG зображення (*.png)|*.png</PngFiles>
    <Ppt2007Files>Microsoft PowerPoint 2007/2013 файли (*.pptx)|*.pptx</Ppt2007Files>
    <ReportFiles>Файли звітів (*.mrt)|*.mrt</ReportFiles>
    <RtfFiles>Текст в форматі Rich Text (*.rtf)|*.rtf</RtfFiles>
    <StandaloneReportFiles>Автономний звіт (*.exe)|*.exe</StandaloneReportFiles>
    <StylesFiles>Файли стилів (*.sts)|*.sts</StylesFiles>
    <SvgFiles>SVG зображення (*.svg)|*.svg</SvgFiles>
    <SvgzFiles>Compressed SVG зображення (*.svgz)|*.svgz</SvgzFiles>
    <SylkFiles>SYLK файли (*.slk)|*.slk</SylkFiles>
    <TiffFiles>TІFF зображення (*.tіff)|*.tіff</TiffFiles>
    <TxtFiles>Звичайний текст (*.txt)|*.txt</TxtFiles>
    <Word2007Files>Файли Microsoft Word 2007-2016 (*.docx)|*.docx</Word2007Files>
    <WriterFiles>OpenDocument Writer файли (*.odt)|*.odt</WriterFiles>
    <XmlFiles>XML файли (*.xml)|*.xml</XmlFiles>
    <XpsFiles>Microsoft XPS файли (*.xps)|*.xps</XpsFiles>
    <ZipArchives>ZIP архіви (*.zip)|*.zip</ZipArchives>
  </FileFilters>
  <Formats>
    <custom01>d</custom01>
    <custom02>D</custom02>
    <custom03>f</custom03>
    <custom04>F</custom04>
    <custom05>dd/MM/yy</custom05>
    <custom06>dd/MM/yyyy</custom06>
    <custom07>G</custom07>
    <custom08>$0.00</custom08>
    <custom09>$0</custom09>
    <custom10>c</custom10>
    <custom11>c1</custom11>
    <custom12>c2</custom12>
    <custom13>#.00</custom13>
    <custom14>#,#</custom14>
    <custom15>n</custom15>
    <custom16>n1</custom16>
    <custom17>n2</custom17>
    <custom18>(###) ### - ####</custom18>
    <date01>*d</date01>
    <date02>*D</date02>
    <date03>dd.M</date03>
    <date04>dd.M.yy</date04>
    <date05>dd.MM.yy</date05>
    <date06>dd.MMM</date06>
    <date07>dd.MMM.yy</date07>
    <date08>yyyy, MMMM</date08>
    <date09>*f</date09>
    <date10>*F</date10>
    <date11>MM.dd.yyyy</date11>
    <date12>dd/MM/yyyy</date12>
    <date13>*g</date13>
    <date14>*G</date14>
    <date15>*y</date15>
    <date16>*m</date16>
    <date17>s</date17>
    <date18>u</date18>
    <date19>*Q</date19>
    <date20>*YQ</date20>
    <date21>QI</date21>
    <date22>YQI</date22>
    <time01>t</time01>
    <time02>T</time02>
    <time03>HH:mm</time03>
    <time04>H:mm</time04>
    <time06>HH:mm:ss</time06>
  </Formats>
  <FormBand>
    <AddFilter>&amp;Додати фільтр</AddFilter>
    <AddGroup>&amp;Додати групу</AddGroup>
    <AddResult>&amp;Додати результат</AddResult>
    <AddSort>&amp;Додати сортування</AddSort>
    <And>і</And>
    <Ascending>За зростанням</Ascending>
    <Descending>За спаданням</Descending>
    <NoFilters>Немає фільтрів</NoFilters>
    <NoSort>Немає сортування</NoSort>
    <RemoveFilter>&amp;Видалити фільтр</RemoveFilter>
    <RemoveGroup>&amp;Видалити групу</RemoveGroup>
    <RemoveResult>&amp;Видалити результат</RemoveResult>
    <RemoveSort>&amp;Видалити сортування</RemoveSort>
    <SortBy>Сортувати за</SortBy>
    <ThenBy>Потім</ThenBy>
    <title>Настройка даних</title>
  </FormBand>
  <FormColorBoxPopup>
    <Color>Кольори</Color>
    <Custom>На вибір</Custom>
    <NoColor>Без кольору</NoColor>
    <Others>Інші</Others>
    <System>Система</System>
    <Web>Web</Web>
  </FormColorBoxPopup>
  <FormConditions>
    <AaBbCcYyZz>АаБбВвЯя</AaBbCcYyZz>
    <AddCondition>&amp;Додати умову</AddCondition>
    <AddLevel>Додати рівень</AddLevel>
    <AssignExpression>Призначити вираз</AssignExpression>
    <ChangeFont>Змінити шрифт</ChangeFont>
    <ComponentIsEnabled>Компонент включений</ComponentIsEnabled>
    <NoConditions>Немає умов</NoConditions>
    <RemoveCondition>&amp;Видалити умову</RemoveCondition>
    <SelectStyle>Вибір стилю</SelectStyle>
    <title>Умова</title>
  </FormConditions>
  <FormCrossTabDesigner>
    <Columns>Стовпчики:</Columns>
    <DataSource>Джерело даних:</DataSource>
    <Properties>Властивості:</Properties>
    <Rows>Рядки:</Rows>
    <Summary>Підсумки:</Summary>
    <Swap>Обміняти стовпчики / Рядки</Swap>
    <title>Редактор Крос-Звіту</title>
  </FormCrossTabDesigner>
  <FormDatabaseEdit>
    <ConnectionString>Рядок з'єднання:</ConnectionString>
    <DB2Edit>Редагування IBM DB2 з'єднання</DB2Edit>
    <DB2New>Нове IBM DB2 з'єднання</DB2New>
    <EditConnection>Редагування {0} з'єднання</EditConnection>
    <FirebirdEdit>Редагування Fіrebіrd з'єднання</FirebirdEdit>
    <FirebirdNew>Нове Fіrebіrd з'єднання</FirebirdNew>
    <InformixEdit>Редагування Informix з'єднання</InformixEdit>
    <InformixNew>Нове Informix з'єднання</InformixNew>
    <InitialCatalog>Початковий каталог:</InitialCatalog>
    <MySQLEdit>Редагування MySQL з'єднання</MySQLEdit>
    <MySQLNew>Нове MySQL з'єднання</MySQLNew>
    <NewConnection>Нове {0} з'єднання</NewConnection>
    <OdbcEdit>Редагування ODBC з'єднання</OdbcEdit>
    <OdbcNew>Нове ODBC з'єднання</OdbcNew>
    <OleDbEdit>Редагування OLE DB з'єднання</OleDbEdit>
    <OleDbNew>Нове OLE DB з'єднання</OleDbNew>
    <OracleEdit>Редагування Oracle з'єднання</OracleEdit>
    <OracleNew>Нове Oracle з'єднання</OracleNew>
    <OracleODPEdit>Редагування Oracle ODP.NET з'єднання</OracleODPEdit>
    <OracleODPNew>Нове Oracle ODP.NET з'єднання</OracleODPNew>
    <PathData>Шлях до XML даних</PathData>
    <PathSchema>Шлях до XSD схеми:</PathSchema>
    <PostgreSQLEdit>Редагування PostgreSQL з'єднання</PostgreSQLEdit>
    <PostgreSQLNew>Нове PostgreSQL з'єднання</PostgreSQLNew>
    <PromptUserNameAndPassword>Запит імені користувача та пароля</PromptUserNameAndPassword>
    <SqlCeEdit>Редагування SQLServerCE з'єднання</SqlCeEdit>
    <SqlCeNew>Нове SQLServerCE з'єднання</SqlCeNew>
    <SqlEdit>Редагування SQL з'єднання</SqlEdit>
    <SQLiteEdit>Редагування SQLite з'єднання</SQLiteEdit>
    <SQLiteNew>Створити SQLite з'эднання</SQLiteNew>
    <SqlNew>Нове SQL з'єднання</SqlNew>
    <TeradataEdit>Редагування Teradata з'єднання</TeradataEdit>
    <TeradataNew>Нове Teradata з'єднання</TeradataNew>
    <UniDirectEdit>Редагувати Однонаправлене з'єднання</UniDirectEdit>
    <UniDirectNew>Нове Однонаправлене з'єднання</UniDirectNew>
    <VistaDBEdit>Редагування VistaDB з'єднання</VistaDBEdit>
    <VistaDBNew>Нове VistaDB з'єднання</VistaDBNew>
    <XmlEdit>Редагування XML даних</XmlEdit>
    <XmlNew>Нові XML дані</XmlNew>
  </FormDatabaseEdit>
  <FormDesigner>
    <Code>Код</Code>
    <ColumnsOne>Один</ColumnsOne>
    <ColumnsThree>Три</ColumnsThree>
    <ColumnsTwo>Два</ColumnsTwo>
    <CompilingReport>Компіляція звіту</CompilingReport>
    <DockingPanels>Панелі</DockingPanels>
    <HtmlPreview>HTML перегляд</HtmlPreview>
    <labelPleaseSelectTypeOfInterface>Будь ласка, виберіть тип інтерфейсу:</labelPleaseSelectTypeOfInterface>
    <LoadImage>Завантажити зображення...</LoadImage>
    <LocalizePropertyGrid>Локалізувати властивості</LocalizePropertyGrid>
    <MarginsNarrow>Вузько</MarginsNarrow>
    <MarginsNormal>Нормально</MarginsNormal>
    <MarginsWide>Широко</MarginsWide>
    <OrderToolbars>Упорядкувати панелі інструментів</OrderToolbars>
    <Others>Інші</Others>
    <Pages>Сторінки</Pages>
    <Preview>Перегляд</Preview>
    <PropertyChange>Зміна властивості '{0}'</PropertyChange>
    <RTPreview>WinRT перегляд</RTPreview>
    <SetupToolbox>Настройка інструментарію</SetupToolbox>
    <ShowDescription>Показувати опис</ShowDescription>
    <SLPreview>Silverlight перегляд</SLPreview>
    <title>Дизайнер</title>
    <WebPreview>Flash перегляд</WebPreview>
  </FormDesigner>
  <FormDictionaryDesigner>
    <Actions>Дії</Actions>
    <AutoSort>Автосортування</AutoSort>
    <BusinessObjectEdit>Редагування бізнес-об'єкта</BusinessObjectEdit>
    <CalcColumnEdit>Зміна розрахункового стовпчика</CalcColumnEdit>
    <CalcColumnNew>Новий розрахунковий стовпчик</CalcColumnNew>
    <CategoryEdit>Зміна категорії</CategoryEdit>
    <CategoryNew>Нова &amp;категорія</CategoryNew>
    <ChildOfBusinessObject>Дочірній бізнес-об'єкт</ChildOfBusinessObject>
    <ChildSource>Підлегле джерело даних:</ChildSource>
    <ColumnEdit>Зміна стовпчика</ColumnEdit>
    <ColumnNew>Новий &amp;стовпчик</ColumnNew>
    <CsvSeparatorComma>Кома</CsvSeparatorComma>
    <CsvSeparatorOther>Інший</CsvSeparatorOther>
    <CsvSeparatorSemicolon>Крапка з комою</CsvSeparatorSemicolon>
    <CsvSeparatorSpace>Пробіл</CsvSeparatorSpace>
    <CsvSeparatorSystem>Системний роздільник</CsvSeparatorSystem>
    <CsvSeparatorTab>Табуляція</CsvSeparatorTab>
    <DatabaseEdit>Зміна бази даних</DatabaseEdit>
    <DatabaseNew>Нова база даних</DatabaseNew>
    <DataParameterEdit>Редагувати параметр</DataParameterEdit>
    <DataParameterNew>Новий параметр</DataParameterNew>
    <DataSetToBusinessObjects>DataSet у бізнес-об'єкти</DataSetToBusinessObjects>
    <DataSourceEdit>Зміна джерела даних</DataSourceEdit>
    <DataSourceNew>Нове &amp;джерело даних</DataSourceNew>
    <DataSourcesNew>Нові джерела даних</DataSourcesNew>
    <Delete>Видалити</Delete>
    <DesignTimeQueryText>Текст запиту в Дизайн-Таймі</DesignTimeQueryText>
    <DictionaryMerge>Додати словник...</DictionaryMerge>
    <DictionaryNew>Новий словник...</DictionaryNew>
    <DictionaryOpen>Відкрити словник...</DictionaryOpen>
    <DictionarySaveAs>Зберегти словник як...</DictionarySaveAs>
    <EditQuery>Змінити запит</EditQuery>
    <ExecutedSQLStatementSuccessfully>Запит SQL виконаний успішно</ExecutedSQLStatementSuccessfully>
    <ExpressionNew>Новий вираз</ExpressionNew>
    <GetColumnsFromAssembly>Взяти стовпчики зі збірки</GetColumnsFromAssembly>
    <ImportRelations>Імпортувати зв'язки</ImportRelations>
    <LabelSeparator>Роздільник:</LabelSeparator>
    <MarkUsedItems>Позначити використовувані елементи</MarkUsedItems>
    <NewBusinessObject>Новий бізнес-об'єкт</NewBusinessObject>
    <NewItem>Новий елемент</NewItem>
    <OpenAssembly>Відкрити збірку</OpenAssembly>
    <ParentSource>Головне джерело даних:</ParentSource>
    <Queries>Запити</Queries>
    <QueryNew>Новий запит</QueryNew>
    <QueryText>Текст запиту</QueryText>
    <RelationEdit>Зміна зв'язку</RelationEdit>
    <RelationNew>Новий &amp;зв'язок</RelationNew>
    <RetrieveColumns>Одержати всі стовпчики</RetrieveColumns>
    <RetrievingDatabaseInformation>Отримання інформації з бази даних...</RetrievingDatabaseInformation>
    <Run>Виконати</Run>
    <SelectTypeOfBusinessObject>Виберіть тип бізнес-об'єкта</SelectTypeOfBusinessObject>
    <SortItems>Сортувати елементи</SortItems>
    <SortOrder>Порядок</SortOrder>
    <Synchronize>Синхронізувати</Synchronize>
    <SynchronizeHint>Синхронізує вміст сховища даних і вміст словника</SynchronizeHint>
    <title>Дизайнер словника</title>
    <ValueNew>Нове значення</ValueNew>
    <VariableEdit>Редагування змінної</VariableEdit>
    <VariableNew>Нова &amp;змінна</VariableNew>
    <ViewData>Перегляд даних</ViewData>
    <ViewQuery>Переглянути результати запиту</ViewQuery>
  </FormDictionaryDesigner>
  <FormFormatEditor>
    <Boolean>Логічний</Boolean>
    <BooleanDisplay>Представлення</BooleanDisplay>
    <BooleanValue>Значення</BooleanValue>
    <Currency>Грошовий</Currency>
    <CurrencySymbol>Символ валюти</CurrencySymbol>
    <Custom>На вибір</Custom>
    <Date>Дата</Date>
    <DateTimeFormat>Формат Дати та Часу</DateTimeFormat>
    <DecimalDigits>Знаків дробової частини</DecimalDigits>
    <DecimalSeparator>Роздільник дроб. частини</DecimalSeparator>
    <FormatMask>Маска</FormatMask>
    <Formats>Формати</Formats>
    <General>Стандарт</General>
    <GroupSeparator>Роздільник групи</GroupSeparator>
    <GroupSize>Розмір групи</GroupSize>
    <nameFalse>Неправда</nameFalse>
    <nameNo>Ні</nameNo>
    <nameOff>Вимкнуто</nameOff>
    <nameOn>Увімкнуто</nameOn>
    <nameTrue>Істина</nameTrue>
    <nameYes>Так</nameYes>
    <NegativePattern>Негативний</NegativePattern>
    <Number>Числовий</Number>
    <Percentage>Процентний</Percentage>
    <PercentageSymbol>Символ процента</PercentageSymbol>
    <PositivePattern>Позитивний</PositivePattern>
    <Properties>Властивості</Properties>
    <Sample>Приклад</Sample>
    <SampleText>текст</SampleText>
    <TextFormat>Формат тексту</TextFormat>
    <Time>Час</Time>
    <title>Формат</title>
    <UseGroupSeparator>Роздільник груп розрядів</UseGroupSeparator>
    <UseLocalSetting>Регіональні налаштування</UseLocalSetting>
  </FormFormatEditor>
  <FormGlobalizationEditor>
    <AddCulture>&amp;Додати культуру</AddCulture>
    <AutoLocalizeReportOnRun>Автопереклад звіту при старті</AutoLocalizeReportOnRun>
    <GetCulture>Взяти налаштування культури зі звіту</GetCulture>
    <qnGetCulture>Ви дійсно бажаєте взяти параметри культури зі звіту та замінити поточні параметри?</qnGetCulture>
    <qnSetCulture>Ви дійсно бажаєте встановити параметри культури в компоненти звіту?</qnSetCulture>
    <RemoveCulture>&amp;Видалити культуру</RemoveCulture>
    <SetCulture>Встановити параметри культури в звіт</SetCulture>
    <title>Редактор культур</title>
  </FormGlobalizationEditor>
  <FormOptions>
    <AutoSave>Автозбереження</AutoSave>
    <AutoSaveReportToReportClass>Автоматично зберігати звіт в C# або Vb.Net Файл</AutoSaveReportToReportClass>
    <Default>За замовчуванням</Default>
    <Drawing>Відображення</Drawing>
    <DrawMarkersWhenMoving>Малювати маркери компонентів при пересуванні</DrawMarkersWhenMoving>
    <EditAfterInsert>Редагувати після створення</EditAfterInsert>
    <EnableAutoSaveMode>Дозволити режим автозбереження</EnableAutoSaveMode>
    <FillBands>Заповнювати бенди</FillBands>
    <FillComponents>Заповнювати компоненти</FillComponents>
    <FillContainers>Заповнювати контейнери</FillContainers>
    <FillCrossBands>Заповнювати крос-бенди</FillCrossBands>
    <GenerateLocalizedName>Згенерувати локалізоване ім'я</GenerateLocalizedName>
    <Grid>Сітка</Grid>
    <GridDots>Крапки</GridDots>
    <GridLines>Лінії</GridLines>
    <GridMode>Режим відображення сітки</GridMode>
    <GridSize>Крок сітки</GridSize>
    <groupAutoSaveOptions>Параметри автозбереження</groupAutoSaveOptions>
    <groupColorScheme>Будь ласка, виберіть кольорову схему інтерфейсу</groupColorScheme>
    <groupGridDrawingOptions>Параметри відображення сітки</groupGridDrawingOptions>
    <groupGridOptions>Параматри сітки</groupGridOptions>
    <groupGridSize>Розмір сітки</groupGridSize>
    <groupMainOptions>Основні параметри дизайнера</groupMainOptions>
    <groupMarkersStyle>Стиль маркерів</groupMarkersStyle>
    <groupOptionsOfQuickInfo>Параметри швидких відомостей</groupOptionsOfQuickInfo>
    <groupPleaseSelectTypeOfGui>Будь ласка, виберіть тип інтерфейсу</groupPleaseSelectTypeOfGui>
    <groupReportDisplayOptions>Параметри відображення звіту</groupReportDisplayOptions>
    <labelColorScheme>Кольорова схема:</labelColorScheme>
    <labelInfoAutoSave>Зміна параметрів автозбереження звіту</labelInfoAutoSave>
    <labelInfoDrawing>Настройка параметрів відображення</labelInfoDrawing>
    <labelInfoGrid>Як сітка використовується і відображується в звіті</labelInfoGrid>
    <labelInfoGui>Виберіть тип інтерфейсу дизайнера звітів</labelInfoGui>
    <labelInfoMain>Зміна основних параметрів дизайнера звітів</labelInfoMain>
    <labelInfoQuickInfo>Швидкі відомості на сторінці</labelInfoQuickInfo>
    <Main>Головна</Main>
    <MarkersStyle>Стиль маркерів компонентів</MarkersStyle>
    <MarkersStyleCorners>Кути</MarkersStyleCorners>
    <MarkersStyleDashedRectangle>Прямокутник</MarkersStyleDashedRectangle>
    <MarkersStyleNone>Немає</MarkersStyleNone>
    <MessageLeftRightNotValid>Ліве та праве значення не вірні!</MessageLeftRightNotValid>
    <MessageTopBottomNotValid>Верхнє та нижнє значення не вірні!</MessageTopBottomNotValid>
    <Minutes>{0} хвилин(и)</Minutes>
    <SaveReportEvery>Зберігати звіт кожні</SaveReportEvery>
    <SelectUILanguage>Виберіть мову інтерфейсу</SelectUILanguage>
    <ShowDimensionLines>Показати лінії вимірювання</ShowDimensionLines>
    <title>Параметри</title>
    <UseComponentColor>Використати кольори компонента для заповнення</UseComponentColor>
    <UseLastFormat>Використати останнє форматування</UseLastFormat>
    <ViewOptions>Вигляд</ViewOptions>
  </FormOptions>
  <FormPageSetup>
    <ApplyTo>Застосовувати до</ApplyTo>
    <Bottom>Нижнє:</Bottom>
    <Columns>Стовпчики</Columns>
    <groupColumns>Стовпчики сторінки</groupColumns>
    <groupImage>Зображення водяного знаку</groupImage>
    <groupMargins>Поля сторінки</groupMargins>
    <groupOrientation>Орієнтація сторінки</groupOrientation>
    <groupPaper>Розмір сторінки</groupPaper>
    <groupPaperSource>Джерело сторінки</groupPaperSource>
    <groupText>Текст водяного знаку</groupText>
    <Height>Висота:</Height>
    <labelAngle>Кут:</labelAngle>
    <labelColumnGaps>Проміжок між стовпчиками:</labelColumnGaps>
    <labelColumnWidth>Ширина одного стовпчика:</labelColumnWidth>
    <labelImageAlignment>Вирівнювання зображення:</labelImageAlignment>
    <labelImageTransparency>Прозорість зображення:</labelImageTransparency>
    <labelInfoColumns>Настройка стовпчиків сторінки</labelInfoColumns>
    <labelInfoPaper>Зміна розмірів та орієнтації поточної сторінки</labelInfoPaper>
    <labelInfoUnit>Поля сторінки вказуються в поточних одиницях виміру звіту</labelInfoUnit>
    <labelInfoWatermark>Настройка параметрів виводу водяного знаку</labelInfoWatermark>
    <labelMultipleFactor>Масштаб:</labelMultipleFactor>
    <labelPaperSourceOfFirstPage>Джерело паперу для першої сторінки:</labelPaperSourceOfFirstPage>
    <labelPaperSourceOfOtherPages>Джерело паперу для інших сторінок:</labelPaperSourceOfOtherPages>
    <labelSelectColor>Вибір кольору:</labelSelectColor>
    <labelSelectFont>Вибір шрифту:</labelSelectFont>
    <labelSelectImage>Вибір зображення:</labelSelectImage>
    <labelText>Текст:</labelText>
    <Left>Ліве:</Left>
    <Margins>Границі</Margins>
    <NumberOfColumns>Кількість стовпчиків:</NumberOfColumns>
    <Orientation>Орієнтація</Orientation>
    <PageOrientationLandscape>Альбомна</PageOrientationLandscape>
    <PageOrientationPortrait>Портретна</PageOrientationPortrait>
    <Paper>Папір:</Paper>
    <RebuildReport>Перебудувати звіт</RebuildReport>
    <Right>Праве:</Right>
    <ScaleContent>Масштабувати вміст</ScaleContent>
    <Size>Розмір:</Size>
    <title>Властивості сторінки</title>
    <Top>Верхнє:</Top>
    <Width>Ширина:</Width>
  </FormPageSetup>
  <FormReportSetup>
    <groupDates>Дата створення та дата останньої зміни звіту</groupDates>
    <groupDescription>Опис звіту</groupDescription>
    <groupMainParameters>Параметри, що впливають на побудову звіту</groupMainParameters>
    <groupNames>Назва, псевдонім та автор звіту</groupNames>
    <groupScript>Скриптова мова Вашого звіту</groupScript>
    <groupUnits>У вказаних одиницях будуть вимірюватися всі розміри і координати в звіті</groupUnits>
    <labelInfoDescription>Інформація про звіт</labelInfoDescription>
    <labelInfoMain>Зміна основних параметрів звіту</labelInfoMain>
    <labelNumberOfPass>Кількість проходів у звіті:</labelNumberOfPass>
    <labelReportCacheMode>Режим кешування звіту:</labelReportCacheMode>
    <ReportChanged>Дата останньої зміни звіту</ReportChanged>
    <ReportCreated>Дата створення звіту</ReportCreated>
    <title>Параметри звіту</title>
  </FormReportSetup>
  <FormRichTextEditor>
    <Bullets>Маркери</Bullets>
    <FontName>Шрифт</FontName>
    <FontSize>Розмір шрифту</FontSize>
    <Insert>Вставити вираз</Insert>
    <title>Rich редактор</title>
  </FormRichTextEditor>
  <FormStyleDesigner>
    <Add>Додати новий стиль</Add>
    <ApplyStyleCollectionToReportComponents>Застосувати колекцію стилів до компонентів звіту</ApplyStyleCollectionToReportComponents>
    <ApplyStyles>Застосувати стилі</ApplyStyles>
    <CreateStyleCollection>Створити колекцію стилів</CreateStyleCollection>
    <CreateStylesCollection>Створити колекцію стилів</CreateStylesCollection>
    <CreateStylesFromColor>Створити стиль з обраного кольору</CreateStylesFromColor>
    <Duplicate>Дублювати стиль</Duplicate>
    <GetStyle>Створити стиль на основі вибраних компонентів</GetStyle>
    <MoreStyles>Більше стилів</MoreStyles>
    <Open>Відкрити стиль</Open>
    <qnApplyStyleCollection>Ви дійсно бажаєте застосувати колекцію стилів до компонентів звіту?</qnApplyStyleCollection>
    <Remove>Видалити стиль</Remove>
    <RemoveExistingStyles>Видалити поточні стилі</RemoveExistingStyles>
    <Save>Зберегти стиль</Save>
    <Style>Стиль</Style>
    <StyleCollectionsNotFound>Колекції стилів не знайдені!</StyleCollectionsNotFound>
    <title>Редактор стилів</title>
  </FormStyleDesigner>
  <FormSystemTextEditor>
    <Condition>Умова</Condition>
    <LabelDataBand>Дані:</LabelDataBand>
    <LabelDataColumn>Стовпчик:</LabelDataColumn>
    <LabelShowInsteadNullValues>Показати замість Null значень:</LabelShowInsteadNullValues>
    <LabelSummaryFunction>Функція:</LabelSummaryFunction>
    <pageExpression>Вираз:</pageExpression>
    <pageSummary>Підсумок</pageSummary>
    <pageSystemVariable>Системна змінна</pageSystemVariable>
    <RunningTotal>Наростаючий підсумок</RunningTotal>
    <SummaryRunning>Діапазон розрахунку</SummaryRunning>
    <SummaryRunningByColumn>Стовпчик</SummaryRunningByColumn>
    <SummaryRunningByPage>Сторінка</SummaryRunningByPage>
    <SummaryRunningByReport>Звіт</SummaryRunningByReport>
  </FormSystemTextEditor>
  <FormTitles>
    <ChartWizardForm>Майстер діаграм</ChartWizardForm>
    <ConditionEditorForm>Умова</ConditionEditorForm>
    <ConnectionSelectForm>Виберіть тип з'єднання</ConnectionSelectForm>
    <ContainerSelectForm>Виберіть контейнер</ContainerSelectForm>
    <DataAdapterServiceSelectForm>Виберіть тип даних</DataAdapterServiceSelectForm>
    <DataRelationSelectForm>Виберіть зв'язок</DataRelationSelectForm>
    <DataSetName>Уведіть назву DataSet</DataSetName>
    <DataSourceSelectForm>Виберіть джерело даних</DataSourceSelectForm>
    <DataSourcesNewForm>Нові джерела даних</DataSourcesNewForm>
    <DataStoreViewerForm>Сховище даних</DataStoreViewerForm>
    <DesignerApplication>Дизайнер звітів</DesignerApplication>
    <EventEditorForm>Редактор подій</EventEditorForm>
    <ExpressionEditorForm>Редактор виразів</ExpressionEditorForm>
    <GroupConditionForm>Умова групування</GroupConditionForm>
    <InteractionDrillDownPageSelectForm>Виберіть сторінку деталізації</InteractionDrillDownPageSelectForm>
    <MasterComponentSelectForm>Виберіть головну компоненту</MasterComponentSelectForm>
    <PageAddForm>Додавання сторінки</PageAddForm>
    <PageSizeForm>Розмір сторінки</PageSizeForm>
    <PagesManagerForm>Менеджер сторінок</PagesManagerForm>
    <PromptForm>Введіть інформацію щоб зареєструватися в БД</PromptForm>
    <ServiceSelectForm>Виберіть сервіси</ServiceSelectForm>
    <SqlExpressionsForm>Sql вираз</SqlExpressionsForm>
    <SubReportPageSelectForm>Виберіть сторінку вкладеного звіту</SubReportPageSelectForm>
    <TextEditorForm>Редактор тексту</TextEditorForm>
    <ViewDataForm>Перегляд даних</ViewDataForm>
    <ViewerApplication>Перегляд звітів</ViewerApplication>
  </FormTitles>
  <FormViewer>
    <Bookmarks>Закладки</Bookmarks>
    <Close>Закрити</Close>
    <CollapseAll>Згорнути всі</CollapseAll>
    <CompressedDocumentFile>Упакований файл документу</CompressedDocumentFile>
    <ContextMenu>Контекстне меню</ContextMenu>
    <DocumentFile>Файл документу...</DocumentFile>
    <Editor>Редактор</Editor>
    <EncryptedDocumentFile>Зашифрований файл документу</EncryptedDocumentFile>
    <ExpandAll>Розгорнути всі</ExpandAll>
    <Export>Експорт...</Export>
    <Find>Знайти</Find>
    <FirstPage>Перша сторінка</FirstPage>
    <FullScreen>На весь екран</FullScreen>
    <GoToPage>Перейти на сторінку</GoToPage>
    <HorScrollBar>Горизонтальна смуга прокручування</HorScrollBar>
    <JumpToPage>Перейти на сторінку</JumpToPage>
    <LabelPageN>Сторінка:</LabelPageN>
    <LastPage>Остання сторінка</LastPage>
    <NextPage>Наступна сторінка</NextPage>
    <Open>Відкрити</Open>
    <PageControl>Керування сторінкою</PageControl>
    <PageDelete>Видалити сторінку</PageDelete>
    <PageDesign>Редагувати сторінку...</PageDesign>
    <PageNew>Нова сторінка</PageNew>
    <PageNofM>Сторінка {0} із {1}</PageNofM>
    <PageNumber>Номер сторінки</PageNumber>
    <PageofM>з {0}</PageofM>
    <PageSize>Розмір сторінки...</PageSize>
    <PageViewModeContinuous>Безперервний</PageViewModeContinuous>
    <PageViewModeMultiplePages>Кілька сторінок</PageViewModeMultiplePages>
    <PageViewModeSinglePage>Одна сторінка</PageViewModeSinglePage>
    <Parameters>Параметри</Parameters>
    <PrevPage>Попередня сторінка</PrevPage>
    <Print>Друк</Print>
    <qnPageDelete>Видалити поточну сторінку?</qnPageDelete>
    <Save>Зберегти</Save>
    <SendEMail>Відправити по Emaіl...</SendEMail>
    <StatusBar>Панель статусу</StatusBar>
    <Thumbnails>Ескізи</Thumbnails>
    <title>Попередній перегляд</title>
    <titlePageSettings>Настройки сторінки</titlePageSettings>
    <Toolbar>Панель інструментів</Toolbar>
    <ToolEditor>Редактор</ToolEditor>
    <ToolFind>Пошук</ToolFind>
    <ToolHand>Рука</ToolHand>
    <ToolSelect>Вибір</ToolSelect>
    <VerScrollBar>Вертикальна смуга прокручування</VerScrollBar>
    <ViewMode>Режим відображення</ViewMode>
    <Zoom>Масштаб</Zoom>
    <ZoomIn>Збільшити</ZoomIn>
    <ZoomMultiplePages>Кілька сторінок</ZoomMultiplePages>
    <ZoomOnePage>Одна сторінка</ZoomOnePage>
    <ZoomOut>Зменшити</ZoomOut>
    <ZoomPageWidth>По ширині сторінки</ZoomPageWidth>
    <ZoomTwoPages>Дві сторінки</ZoomTwoPages>
    <ZoomXXPages>{0} X {1} сторінок</ZoomXXPages>
    <ZoomXXPagesCancel>Відмінити</ZoomXXPagesCancel>
  </FormViewer>
  <FormViewerFind>
    <Close>Закрити</Close>
    <FindNext>Знайти далі</FindNext>
    <FindPrevious>Знайти попередній</FindPrevious>
    <FindWhat>Знайти:</FindWhat>
    <title>Знайти</title>
  </FormViewerFind>
  <Gui>
    <barname_cancel>Скасувати</barname_cancel>
    <barname_caption>Нова панель інструментів</barname_caption>
    <barname_msginvalidname>Ім'я панелі не може бути порожнім.</barname_msginvalidname>
    <barname_name>&amp;Ім'я панелі:</barname_name>
    <barname_ok>OK</barname_ok>
    <barrename_caption>Перейменувати панель інструментів</barrename_caption>
    <barsys_autohide_tooltip>Приховувати автоматично</barsys_autohide_tooltip>
    <barsys_close_tooltip>Закрити</barsys_close_tooltip>
    <barsys_customize_tooltip>Настройка</barsys_customize_tooltip>
    <colorpicker_morecolors>&amp;Інші кольори...</colorpicker_morecolors>
    <colorpicker_nofill>&amp;Без заповнення</colorpicker_nofill>
    <colorpicker_standardcolorslabel>Стандартні кольори</colorpicker_standardcolorslabel>
    <colorpicker_themecolorslabel>Кольори тем</colorpicker_themecolorslabel>
    <colorpickerdialog_bluelabel>&amp;Синій:</colorpickerdialog_bluelabel>
    <colorpickerdialog_cancelbutton>Скасувати</colorpickerdialog_cancelbutton>
    <colorpickerdialog_caption>Кольори</colorpickerdialog_caption>
    <colorpickerdialog_colormodellabel>Модель кольору:</colorpickerdialog_colormodellabel>
    <colorpickerdialog_currentcolorlabel>поточна</colorpickerdialog_currentcolorlabel>
    <colorpickerdialog_customcolorslabel>Кольори:</colorpickerdialog_customcolorslabel>
    <colorpickerdialog_greenlabel>&amp;Зелений:</colorpickerdialog_greenlabel>
    <colorpickerdialog_newcolorlabel>Новий</colorpickerdialog_newcolorlabel>
    <colorpickerdialog_okbutton>OK</colorpickerdialog_okbutton>
    <colorpickerdialog_redlabel>&amp;Червоний:</colorpickerdialog_redlabel>
    <colorpickerdialog_rgblabel>RGB</colorpickerdialog_rgblabel>
    <colorpickerdialog_standardcolorslabel>Кольори:</colorpickerdialog_standardcolorslabel>
    <colorpickerdialog_tabcustom>Вибірково</colorpickerdialog_tabcustom>
    <colorpickerdialog_tabstandard>Стандартні</colorpickerdialog_tabstandard>
    <cust_btn_close>Закрити</cust_btn_close>
    <cust_btn_delete>Видалити</cust_btn_delete>
    <cust_btn_keyboard>&amp;Клавіатура...</cust_btn_keyboard>
    <cust_btn_new>&amp;Нова...</cust_btn_new>
    <cust_btn_rename>&amp;Перейменувати...</cust_btn_rename>
    <cust_btn_reset>&amp;Скинути...</cust_btn_reset>
    <cust_btn_resetusage>&amp;Скинути мої користувацькі дані</cust_btn_resetusage>
    <cust_caption>Настройка</cust_caption>
    <cust_cbo_fade>Поступова зміна</cust_cbo_fade>
    <cust_cbo_none>(Немає)</cust_cbo_none>
    <cust_cbo_random>Випадково</cust_cbo_random>
    <cust_cbo_slide>Сковзання</cust_cbo_slide>
    <cust_cbo_system>Поточне системне </cust_cbo_system>
    <cust_cbo_unfold>Відкрити</cust_cbo_unfold>
    <cust_chk_delay>Показувати повне меню після короткої паузи</cust_chk_delay>
    <cust_chk_fullmenus>Завжди показувати повне меню</cust_chk_fullmenus>
    <cust_chk_showsk>Показувати &amp;комбінації клавіш в підказках</cust_chk_showsk>
    <cust_chk_showst>Показувати &amp;підказки в панелях інструментів</cust_chk_showst>
    <cust_lbl_cats>Кате&amp;горії:</cust_lbl_cats>
    <cust_lbl_cmds>Коман&amp;ди:</cust_lbl_cmds>
    <cust_lbl_cmdsins>Для того, щоб додати команду на панель, виберіть категорію та перетягніть команду з цього прямокутника на панель.</cust_lbl_cmdsins>
    <cust_lbl_menuan>Анімація меню:</cust_lbl_menuan>
    <cust_lbl_other>Інше:</cust_lbl_other>
    <cust_lbl_pmt>Персоналізовані меню та панелі інструментів</cust_lbl_pmt>
    <cust_lbl_tlbs>Пан&amp;елі інструментів:</cust_lbl_tlbs>
    <cust_mnu_addremove>&amp;Додати або видалити кнопки</cust_mnu_addremove>
    <cust_mnu_cust>Настройка...</cust_mnu_cust>
    <cust_mnu_reset>Скинути панель</cust_mnu_reset>
    <cust_mnu_tooltip>Параметри панелі</cust_mnu_tooltip>
    <cust_msg_delete>Ви впевнені, що хочете видалити панель &lt;barname&gt;?</cust_msg_delete>
    <cust_pm_begingroup>Розпочати групу</cust_pm_begingroup>
    <cust_pm_delete>Видалити</cust_pm_delete>
    <cust_pm_name>Ім'я:</cust_pm_name>
    <cust_pm_reset>Скинути</cust_pm_reset>
    <cust_pm_stydef>Стандартний стиль</cust_pm_stydef>
    <cust_pm_styimagetext>Зображення та текст (завжди)</cust_pm_styimagetext>
    <cust_pm_stytextonly>Тільки текст (завжди)</cust_pm_stytextonly>
    <cust_tab_commands>Команди</cust_tab_commands>
    <cust_tab_options>Параметри</cust_tab_options>
    <cust_tab_toolbars>Панелі інструментів</cust_tab_toolbars>
    <mdisysmenu_close>Закрити</mdisysmenu_close>
    <mdisysmenu_maximize>Максимізувати</mdisysmenu_maximize>
    <mdisysmenu_minimize>Мінімізувати</mdisysmenu_minimize>
    <mdisysmenu_move>Перемістити</mdisysmenu_move>
    <mdisysmenu_next>Наступне</mdisysmenu_next>
    <mdisysmenu_restore>Відновити</mdisysmenu_restore>
    <mdisysmenu_size>Розмір</mdisysmenu_size>
    <mdisystt_close>Закрити</mdisystt_close>
    <mdisystt_minimize>Мінімізувати</mdisystt_minimize>
    <mdisystt_restore>Відновити</mdisystt_restore>
    <monthcalendar_clearbutton>Очистити</monthcalendar_clearbutton>
    <monthcalendar_todaybutton>Сьогодні</monthcalendar_todaybutton>
    <navbar_navpaneoptions>Параметри на&amp;вігаційної зони...</navbar_navpaneoptions>
    <navbar_showfewerbuttons>Показати &amp;менше кнопок</navbar_showfewerbuttons>
    <navbar_showmorebuttons>Показати &amp;більше кнопок</navbar_showmorebuttons>
    <navPaneCollapseTooltip>Звернути навігаційну зону</navPaneCollapseTooltip>
    <navPaneExpandTooltip>Розширити навігаційну зону</navPaneExpandTooltip>
    <sys_custombar>За вибором</sys_custombar>
    <sys_morebuttons>Більше кнопок</sys_morebuttons>
  </Gui>
  <HelpComponents>
    <StiBarCode>Компонент використовується для відображення в звіті штрих-кодів. Дані для кодування штрих-коду встановлюються у вигляді текстового рядка. Рядок може містити будь-які символи, але тільки дозволені символи для вказаного типу штрих-коду будуть показуватися.</StiBarCode>
    <StiChart>Цей компонент використовується для відображення діаграм у звіті. Доступно багато різних типів діаграм.</StiChart>
    <StiCheckBox>Компонент для відображення прапорців у звіті. Він може змінювати свій зовнішній вигляд в залежності від умови, яка може приймати два значення: "увімкнено" або "вимкнено".</StiCheckBox>
    <StiChildBand>Дочірній бенд використовується для виводу більш ніж одного бэнду для одного рядка даних.</StiChildBand>
    <StiClone>Цей компонент використовується для клонування частини звіту в інше місце звіту. Клонування може бути застосовано тільки до компонента «Панель».</StiClone>
    <StiColumnFooterBand>Цей бенд використовується для виводу підсумка стовпчиків даних і виводиться під кожним стовпчиком.</StiColumnFooterBand>
    <StiColumnHeaderBand>Цей бенд використовується для виводу заголовку стовпчиків даних і виводиться над кожним стовпчиком.</StiColumnHeaderBand>
    <StiContainer>Це прямокутна ділянка, де можуть бути розміщені інші компоненти, в тому числі й бенди. При переміщенні контейнера компоненти розміщені в ньому будуть також переміщені. Контейнер може розміщуватися як на бенді, так и на сторінці.</StiContainer>
    <StiCrossDataBand>Цей бенд з’єднаний з джерелом даних. Бенд виводиться стільки разів, скільки рядків у зв’язаному джерелі даних. Бенд виводиться зліва направо.</StiCrossDataBand>
    <StiCrossFooterBand>Бенд використовується для виводу підсумку для бенда «крос-дані». Підсумок виводиться одразу після всіх рядків бенда «крос-дані». Бенд виводиться зліва направо.</StiCrossFooterBand>
    <StiCrossGroupFooterBand>Бенд використовується для виводу підсумку групи. Он розміщується після бенда «крос-дані». Кожен бенд «крос-підсумок групи» належить до певного крос-заголовку групи. Бенд «крос-підсумок групи виводиться зліва направо.</StiCrossGroupFooterBand>
    <StiCrossGroupHeaderBand>Цей бенд є основним для підготовки звітів з групуванням, коли використовується бенд «крос-дані». Неможливо створити крос-групування без цього бенда. Бенд «крос-заголовок групи виводиться зліва направо.</StiCrossGroupHeaderBand>
    <StiCrossHeaderBand>Бенд використовується для виводу заголовку для бенда «крос-дані». Заголовок виводиться перед виводом рядків бенда «крос-дані». Бенд «крос-заголовок» виводиться зліва направо.</StiCrossHeaderBand>
    <StiCrossTab>Крос компонент використовується для представлення структурованих даних у вигляді таблиці.</StiCrossTab>
    <StiDataBand>Бенд «дані» з’єднаний з джерелом даних і виводиться стільки разів, скільки рядків у зв’язаному з ним джерелі даних.</StiDataBand>
    <StiEmptyBand>Бенд використовується для заповнення вільного простору в нижній частині сторінки.</StiEmptyBand>
    <StiFooterBand>Бенд використовується для виводу підсумку для бенда «дані». Підсумок виводиться одразу ж після всіх рядків бенду «дані».</StiFooterBand>
    <StiGroupFooterBand>Бенд використовується для виводу підсумку групи. Він розміщується після бенда «дані». Кожен бенд «підсумок групи» належить до конкретного заголовку групи.</StiGroupFooterBand>
    <StiGroupHeaderBand>Це основний бенд для створення звітів з групуванням. Компоненти для відображення інформації по групі розміщуються на бенде заголовку групи. Це може бути назва групи, дати, умови групування і т.д. Бенд «заголовок групи» виводиться один раз на початку кожної групи.</StiGroupHeaderBand>
    <StiHeaderBand>Бенд використовується для виводу заголовку для бенда «дані». Заголовок виводиться перед виводом рядків бенда «дані».</StiHeaderBand>
    <StiHierarchicalBand>Бенд виводиться стільки разів, скільки рядків у зв’язаному джерелі даних. Дані виводяться у вигляді дерева.</StiHierarchicalBand>
    <StiHorizontalLinePrimitive>Геометричний примітив - горизонтальна лінія. Використовується для візуального оформлення звітів.</StiHorizontalLinePrimitive>
    <StiImage>Цей компонент використовується для виводу зображень. Підтримуються наступні графічні формати: BMP, JPG, JPEG, GIF, TIFF, PNG, ICO, WMF, EMF.</StiImage>
    <StiOverlayBand>Цей бенд використовується для виводу водяних знаків на сторінці.</StiOverlayBand>
    <StiPageFooterBand>Бенд «підсумок сторінки» використовується для виводу інформації у нижній частині кожної сторінки, і призначений для виводу номерів сторінок, дат та іншої допоміжної інформації.</StiPageFooterBand>
    <StiPageHeaderBand>Бэнд використовується для виводу заголовку сторінки. Він виводиться у верхній частині кожної сторінки, і призначений для виводу номерів сторінок, дат та іншої допоміжної інформації.</StiPageHeaderBand>
    <StiPanel>Це прямокутна область, де можуть бути розміщені інші компоненти, у том числі й бенди. При переміщенні панелі компоненти, що розміщені на ній, також будуть переміщені. Панель може розміщуватись як на бенді, так і на сторінці.</StiPanel>
    <StiRectanglePrimitive>Геометричний примітив - прямокутник, використовується для візуального оформлення звітів. Лівий верхній кут прямокутника може знаходитися в області одного бенда, а правий нижній кут - в області іншого бенда.</StiRectanglePrimitive>
    <StiReportSummaryBand>Цей бенд використовується для виводу підсумку по всьому звіту. Бенд виводиться один раз у кінці звіту.</StiReportSummaryBand>
    <StiReportTitleBand>Цей бенд використовується для виводу назви звіту. Він виводиться на початку звіту перед іншими бендами.</StiReportTitleBand>
    <StiRichText>Компонент для виводу і редагування тексту RTF. Підтримує завантаження і збереження файлів і форматі RTF.</StiRichText>
    <StiRoundedRectanglePrimitive>Геометричний примітив - закруглений прямокутник. Цей примітив аналогічний примітиву «прямокутник» за виключенням того, що має закруглені кути. Примітив підтримується не всіма видами експорту.</StiRoundedRectanglePrimitive>
    <StiShape>Компонент призначено для відображення різних геометричних примітивів, таких як стрілки, лінії, прямокутники, трикутники.</StiShape>
    <StiSubReport>Цей компонент використовується для виводу додаткових даних у різних місцях звіту.</StiSubReport>
    <StiTable>Цей компонент представляє собою набор елементів даних, організованих у вигляді таблиці.</StiTable>
    <StiText>Основний компонент для виводу текстової інформації у звіті.</StiText>
    <StiTextInCells>Компонент для виводу тексту в вигляді клітинок. Зазвичай використовується при друкові бланків.</StiTextInCells>
    <StiVerticalLinePrimitive>Геометричний примітив - вертикальна лінія, використовується для візуального оформлення звітів. Вертикальна лінія може починатися в області одного бенда, а закінчуватися в області іншого бенда.</StiVerticalLinePrimitive>
    <StiWinControl>Компонент призначений для відображення візуальних елементів курування .Net Framework.</StiWinControl>
    <StiZipCode>Компонент призначений для виводу поштового індексу.</StiZipCode>
  </HelpComponents>
  <HelpDesigner>
    <Align>Зміна розміщення вибраних компонентів.</Align>
    <AlignBottom>Вирівняти вміст компонента по нижньому краю.</AlignBottom>
    <AlignCenter>Вирівняти вміст компонента по центру по горизонталі.</AlignCenter>
    <AlignComponentBottom>Дозволяє вирівнювати виділені компоненти горизонтально вздовж нижнього краю виділених компонентів.</AlignComponentBottom>
    <AlignComponentCenter>Дозволяє вирівнювати виділені компоненти горизонтально вздовж центру виділених компонентів.</AlignComponentCenter>
    <AlignComponentLeft>Дозволяє вирівнювати виділені компоненти вертикально по лівому краю виділених компонентів.</AlignComponentLeft>
    <AlignComponentMiddle>Дозволяє вирівнювати виділені компоненти вертикально по центру виділених компонентів.</AlignComponentMiddle>
    <AlignComponentRight>Дозволяє вирівнювати виділені компоненти вертикально вздовж правого краю виділених компонентів.</AlignComponentRight>
    <AlignComponentTop>Дозволяє вирівнювати виділені компоненти горизонтально вздовж верхнього краю виділених компонентів.</AlignComponentTop>
    <AlignLeft>Вирівняти вміст компонента по лівому краю.</AlignLeft>
    <AlignMiddle>Вирівняти вміст компонента по центру по вертикалі.</AlignMiddle>
    <AlignRight>Вирівняти вміст компонента по правому краю.</AlignRight>
    <AlignToGrid>Вирівняти виділені компоненти по вузлах сітки.</AlignToGrid>
    <AlignTop>Вирівняти вміст компонента по верхньому краю.</AlignTop>
    <AlignWidth>Вирівняти вміст компонента по ширині.</AlignWidth>
    <Angle>Повернути компонент.</Angle>
    <AngleWatermark>Кут повороту тексту водяного знаку.</AngleWatermark>
    <Background>Змінити задній фон виділених компонентів.</Background>
    <biConditions>Змінити умови виділених компонентів.</biConditions>
    <BorderColor>Змінити колір границі виділених компонентів.</BorderColor>
    <BorderSidesAll>Встановити границю у виділених компонентів з усіх боків.</BorderSidesAll>
    <BorderSidesBottom>Встановити границю у виділених компонентів знизу.</BorderSidesBottom>
    <BorderSidesLeft>Встановити границю у виділених компонентів ліворуч.</BorderSidesLeft>
    <BorderSidesNone>Скинути границю у виділених компонентів з усіх боків.</BorderSidesNone>
    <BorderSidesRight>Встановити границю у виділених компонентів праворуч.</BorderSidesRight>
    <BorderSidesTop>Встановити границю у виділених компонентів зверху.</BorderSidesTop>
    <BorderStyle>Змінити стиль границі у виділених компонентів.</BorderStyle>
    <BringToFront>Перемістити виділені компоненти на передній план.</BringToFront>
    <CenterHorizontally>Центрує виділені компоненти по вертикалі.</CenterHorizontally>
    <CenterVertically>Центрує виділені компоненти по горизонталі.</CenterVertically>
    <Close>Закрити дизайнер звітів.</Close>
    <Columns>Розбити сторінку на стовпчики.</Columns>
    <ComponentSize>Змінити розмір виділених компонентів.</ComponentSize>
    <CopyStyle>Копіювати стиль</CopyStyle>
    <CopyToClipboard>Скопіювати до буферу обміну</CopyToClipboard>
    <CurrencySymbol>Вибрати символ валюти.</CurrencySymbol>
    <DataStore>Показати дані, зареєстровані для звіту.</DataStore>
    <DateTimeFormat>Вибрати формат дати і часу для виділених компонентів.</DateTimeFormat>
    <DockingPanels>Настройки панелі.</DockingPanels>
    <DockStyleBottom>Пристикувати виділені компоненти до нижнього краю.</DockStyleBottom>
    <DockStyleFill>Пристикувати виділені компоненти до всіх країв одразу.</DockStyleFill>
    <DockStyleLeft>Пристикувати виділені компоненти до лівого краю.</DockStyleLeft>
    <DockStyleNone>Не пристиковувати виділені компоненти.</DockStyleNone>
    <DockStyleRight>Пристикувати виділені компоненти до правого краю.</DockStyleRight>
    <DockStyleTop>Пристикувати виділені компоненти до верхнього краю.</DockStyleTop>
    <FontGrow>Збільшити розмір шрифту тексту.</FontGrow>
    <FontName>Шрифт тексту.</FontName>
    <FontNameWatermark>Шрифт тексту водяного знаку.</FontNameWatermark>
    <FontShrink>Зменшити розмір шрифту тексту.</FontShrink>
    <FontSize>Розмір шрифту.</FontSize>
    <FontSizeWatermark>Змінити розмір шрифту.</FontSizeWatermark>
    <FontStyleBold>Зробити текст жирним.</FontStyleBold>
    <FontStyleBoldWatermark>Зробити текст водяного знаку жирним.</FontStyleBoldWatermark>
    <FontStyleItalic>Зробити текст курсивним.</FontStyleItalic>
    <FontStyleItalicWatermark>Зробити текст водяного знаку курсивним.</FontStyleItalicWatermark>
    <FontStyleUnderline>Зробити текст підкресленим.</FontStyleUnderline>
    <FontStyleUnderlineWatermark>Зробити текст водяного знаку підкресленим.</FontStyleUnderlineWatermark>
    <FormatBoolean>Цей формат використовується для форматування значень логічного типу.</FormatBoolean>
    <FormatCurrency>Відображувати дані як дані грошового типу.</FormatCurrency>
    <FormatCustom>Цей тип використовується для відображення значень у відповідності з вимогами клієнта. Цей тип дозволяє задавати форматування даних у форматі маски.</FormatCustom>
    <FormatDate>Відображувати дані у вигляді дати. Формат дати залежить від регіональних параметрів.</FormatDate>
    <FormatGeneral>Відображувати дані без певного формату.</FormatGeneral>
    <FormatNumber>Відображувати дані у числовому форматі.</FormatNumber>
    <FormatPercentage>Відображувати дані у відсотках. Число помножується на 100 для перетворення у відсотки.</FormatPercentage>
    <FormatTime>Відображувати дані як час. Формат часу залежить від регіональних параметрів.</FormatTime>
    <FormNew>Створити нову діалогову форму.</FormNew>
    <GridMode>Показувати сітку з ліній або крапок.</GridMode>
    <ImageAlignment>Розміщення водяного знаку на сторінці.</ImageAlignment>
    <ImageTransparency>Змінити прозорість зображення.</ImageTransparency>
    <Link>Зв'язати виділені компоненти з контейнерами, в яких вони знаходяться.</Link>
    <LoadImage>Завантажити зображення для водяного знаку з файла.</LoadImage>
    <Lock>Блокування виділених компонентів. The component cannot be moved and resized.</Lock>
    <MainMenu>Натисніть тут щоб побачити список можливих операцій зі звітом, у тому числі операцій відкриття, закриття і попереднього перегляду.</MainMenu>
    <MakeHorizontalSpacingEqual>Дозволяє встановити рівні відстані по горизонталі між вибраними компонентами.</MakeHorizontalSpacingEqual>
    <MakeVerticalSpacingEqual>Дозволяє встановити рівні відстані по вертикалі між вибраними компонентами.</MakeVerticalSpacingEqual>
    <Margins>Виберіть розміри полів у поточної сторінки.</Margins>
    <menuCheckIssues>Перевірка для пошуку помилок, попереджень та отримання рекомендацій</menuCheckIssues>
    <menuDesignerOptions>Установка параметрів дизайнера звітів.</menuDesignerOptions>
    <menuEditClearContents>Очистити вміст вибраних текстових компонентів.</menuEditClearContents>
    <menuEditCopy>Копіювати вибрані компоненти в буфер обміну.</menuEditCopy>
    <menuEditCut>Вирізати вибрані компоненти і скопіювати їх у буфер обміну.</menuEditCut>
    <menuEditDelete>Видалити вибрані компоненти.</menuEditDelete>
    <menuEditPaste>Вставити вміст буфера обміну в звіт.</menuEditPaste>
    <menuFAQPage>Зайдіть на веб-сторінку з питаннями, що часто задають.</menuFAQPage>
    <menuGlobalizationStrings>Викликати редактор рядків перекладу для поточного звіту.</menuGlobalizationStrings>
    <menuHelpAboutProgramm>Отримати інформацію про версію генератора звітів і версію .Net Framework.</menuHelpAboutProgramm>
    <menuHomePage>Перейти на домашню сторінку продукту.</menuHomePage>
    <menuPageOptions>Встановити основні параметри поточної сторінки. Всі параметри сторінки можуть бути змінені за допомогою панелі властивостей.</menuPageOptions>
    <menuPagesManager>Запуск менеджера сторінок. Це дозволяє переміщувати, видаляти та створювати нові сторінки.</menuPagesManager>
    <menuPreviewSettings>Викликати редактор параметрів попереднього перегляду поточного звіту. Установки будуть застосовуватися тільки при перегляді цього звіту.</menuPreviewSettings>
    <menuPrint>Виберіть принтер, кількість копій та інші параметри друку перед початком друку.</menuPrint>
    <menuPrintPreview>Попередній перегляд перед друком.</menuPrintPreview>
    <menuPrintQuick>Роздрукувати звіт безпосередньо на принтер за замовчуванням. Діалогова форма друку не показується.</menuPrintQuick>
    <menuReportOptions>Встановити основні параметри звіту. Всі параметри можуть бути змінені за допомогою панелі властивостей.</menuReportOptions>
    <menuStyleDesigner>Викликати дизайнер стилів поточного звіту.</menuStyleDesigner>
    <menuSupport>Перейти на сторінку підтримки, щоб задати питання.</menuSupport>
    <menuViewAlignToGrid>Вирівняти по сітці.</menuViewAlignToGrid>
    <menuViewNormal>Нормальний режим перегляду.</menuViewNormal>
    <menuViewPageBreakPreview>Перегляд сторінки в режимі відображення границь сегментів сторінки.</menuViewPageBreakPreview>
    <menuViewQuickInfo>Показувати інформацію про компонент: ім'я, псевдонім, вміст, події та ін.</menuViewQuickInfo>
    <menuViewShowGrid>Увімкнути лінії сітки, по яким можна вирівняти компоненти звіту.</menuViewShowGrid>
    <menuViewShowHeaders>Показувати заголовки бендів.</menuViewShowHeaders>
    <menuViewShowOrder>Показувати порядок розміщення компонентів на сторінці.</menuViewShowOrder>
    <menuViewShowRulers>Показувати розмірні лінійки.</menuViewShowRulers>
    <MoveBackward>Переміщення компонента на один рівень вище у порядку розміщення компонентів на сторінці.</MoveBackward>
    <MoveForward>Переміщення компонента на один рівень нижче у порядку розміщення компонентів на сторінці.</MoveForward>
    <Orientation>Перемикання між книжною та альбомною орієнтацією сторінки.</Orientation>
    <PageDelete>Видалити поточну сторінку зі звіту.</PageDelete>
    <PageNew>Створити нову сторінку.</PageNew>
    <PageSetup>Показати діалог настройки параметрів сторінки.</PageSetup>
    <PageSize>Вибрати розміри для поточної сторінки звіту.</PageSize>
    <PagesManager>Запускає менеджер сторінок.</PagesManager>
    <PressF1>Натисніть F1 для довідки</PressF1>
    <Redo>Повторити раніше відмінені зміни в дизайнері звітів.</Redo>
    <ReportNew>Створити новий звіт.</ReportNew>
    <ReportOpen>Відкрити звіт у дизайнері.</ReportOpen>
    <ReportPreview>Попередній перегляд звіту, що редагується.</ReportPreview>
    <ReportSave>Зберегти звіт, що редагується.</ReportSave>
    <SelectAll>Вибрати всі компоненти на сторінці.</SelectAll>
    <SelectUILanguage>Вибрати мову інтерфейсу.</SelectUILanguage>
    <SendToBack>Перемістити вибрані компоненти на задній план відносно інших компонентів.</SendToBack>
    <ServicesConfigurator>Запустити конфігуратор сервісів.</ServicesConfigurator>
    <Shadow>Показувати тінь компонента.</Shadow>
    <ShowBehind>Показувати текст водяного знаку позаду сторінки.</ShowBehind>
    <ShowImageBehind>Показувати зображення водяного знаку позаду сторінки.</ShowImageBehind>
    <ShowToolbox>Показувати інструментарій.</ShowToolbox>
    <StimulsoftHelp>Допомога Stimulsoft</StimulsoftHelp>
    <StyleDesigner>Запустити редактор стилів.</StyleDesigner>
    <TellMeMore>Докладніше</TellMeMore>
    <Text>Текст водяного знаку.</Text>
    <TextBrush>Змінити колір тексту.</TextBrush>
    <TextBrushWatermark>Змінити колір тексту водяного знаку.</TextBrushWatermark>
    <TextColor>Змінити колір тексту.</TextColor>
    <TextFormat>Вибрати формат відображення значень.</TextFormat>
    <ToolbarStyle>Застосувати вибраний стиль для всіх вибраних компонентів.</ToolbarStyle>
    <Undo>Відмінити останні зміни в дизайнері звітів.</Undo>
    <WordWrap>Переносити текст.</WordWrap>
    <Zoom>Вибрати масштаб відображення звіту в дизайнері.</Zoom>
  </HelpDesigner>
  <HelpDialogs>
    <StiButtonControl>Представляє елемент керування "кнопка".</StiButtonControl>
    <StiCheckBoxControl>Представляє елемент керування "прапорець", який користувач може встановлювати або знімати.</StiCheckBoxControl>
    <StiCheckedListBoxControl>Представляє об'єкт список, у якому прапорець відображується зліва від кожного елемента.</StiCheckedListBoxControl>
    <StiComboBoxControl>Представляє елемент керування, призначений для вибору значення, з випадаючим списком, який можна відображувати і приховувати натисканням кнопки зі стрілкою, що належить цьому елементу керування.</StiComboBoxControl>
    <StiDateTimePickerControl>Представляє елемент керування, який дозволяє вибрати дату і час та показати їх у вказаному форматі.</StiDateTimePickerControl>
    <StiGridControl>Представляє елемент керування "сітка", що складається зі стовпчиків та рядків.</StiGridControl>
    <StiGroupBoxControl>Представляє елемент керування, який створює контейнер з границею і заголовком для інших елементів.</StiGroupBoxControl>
    <StiLabelControl>Текстова мітка для відображення тексту на формі. Забезпечує підтримку клавіш доступу.</StiLabelControl>
    <StiListBoxControl>Містить список елементів для вибору.</StiListBoxControl>
    <StiListViewControl>Представляє елемент керування, що відображує список елементів даних.</StiListViewControl>
    <StiLookUpBoxControl>Містить список елементів для вибору.</StiLookUpBoxControl>
    <StiNumericUpDownControl>Представляє елемент керування, що відображує числові значення.</StiNumericUpDownControl>
    <StiPanelControl>Елемент "панель" використовується для розміщення і організації об'єктів.</StiPanelControl>
    <StiPictureBoxControl>Представляє елемент керування для показу зображення.</StiPictureBoxControl>
    <StiRadioButtonControl>Представляє перемикач, що дозволяє користувачу вибрати тільки одне з попередньо встановлених значень.</StiRadioButtonControl>
    <StiRichTextBoxControl>Представляє елемент керування для відображення та редагування тексту з розширеними можливостями форматування.</StiRichTextBoxControl>
    <StiTextBoxControl>Представляє елемент керування для відображення та редагування тексту.</StiTextBoxControl>
    <StiTreeViewControl>Представляє елемент керування для відображення ієрархічних даних у вигляді дерева з можливістю розгортання та згортання елементів.</StiTreeViewControl>
  </HelpDialogs>
  <HelpViewer>
    <AddPageBreaks>Додати роздільники сторінок.</AddPageBreaks>
    <AllowAddOrModifyTextAnnotations>Дозволити додавати або змінювати примітки.</AllowAddOrModifyTextAnnotations>
    <AllowCopyTextAndGraphics>Дозволити копіювати текст і графіку.</AllowCopyTextAndGraphics>
    <AllowEditable>Дозволяє змінювати тільки компоненти з увімкненою властивістю "Редагований".</AllowEditable>
    <AllowModifyContents>Дозволити редагування документа.</AllowModifyContents>
    <AllowPrintDocument>Дозволити друк документа.</AllowPrintDocument>
    <Bookmarks>Показує панель закладок, що служить для швидкої навігації по звіту за допомогою закладок.</Bookmarks>
    <BorderType>Тип границі компонентів: проста - формування границь компонентів символами +, -, |. Unicode одинарна - формування границь компонентів одинарними символами псевдографіки, Unicode подвійна - формування границь компонентів подвійними символами псевдографіки.</BorderType>
    <Close>Закрити попередній перегляд.</Close>
    <CloseDotMatrix>Закрити попередній перегляд для матричних принтерів.</CloseDotMatrix>
    <Compressed>Стиснення кінцевого документа. Рекомендується завжди вмикати стиснення файлу.</Compressed>
    <CompressToArchive>Упакувати всі файли і папки в ZIP архів.</CompressToArchive>
    <ContinuousPages>Режим розташування сторінок звіту у вигляді вертикальної стрічки.</ContinuousPages>
    <CurrentPage>Обробка поточної сторінки, тобто якщо обрано цей параметр, то оброблятися буде виділена сторінка звіту.</CurrentPage>
    <CutEdges>Обрізати границі сторінок звіту.</CutEdges>
    <CutLongLines>Обрізати довгі лінії (рядки тексту) по границях компонента.</CutLongLines>
    <DigitalSignature>Цифровий підпис файлу.</DigitalSignature>
    <DitheringType>Тип монохромного змішування: Ні - без дезірінга, Ordered, FloydSt - з дезірінгом.</DitheringType>
    <DotMatrixMode>Цей режим дозволяє побачити, як звіт буде виглядати, якщо надрукувати його на матричний принтер.</DotMatrixMode>
    <DrawBorder>Формування границь компонентів символами графіки.</DrawBorder>
    <Edit>Редагувати елементи звіту.</Edit>
    <EmbeddedFonts>Вбудувати файли шрифтів у файл PDF.</EmbeddedFonts>
    <EmbeddedImageData>Вбудувати зображення безпосередньо в HTML файл.</EmbeddedImageData>
    <Encoding>Кодування тексту звіту після експорту.</Encoding>
    <EncodingData>Кодування файлу даних.</EncodingData>
    <EncryptionKeyLength>Довжина ключа шифрування для документа. Чим більше довжина, тим складніше розшифрувати документ, і відповідно безпека документа вище.</EncryptionKeyLength>
    <ExportDataOnly>Експорт тільки бендів Дані (компонент Таблиця, бенд Дерево).</ExportDataOnly>
    <ExportEachPageToSheet>Експортувати кожну сторінку звіту на окремий лист в Excel.</ExportEachPageToSheet>
    <ExportMode>Застосувати умову фільтрації при експорті. Тільки дані - експортуватимуться тільки бенди Дані (компонент Таблиця, бенд Дерево), Дані та Заголовки/Підсумки - експортуватимуться бенди Дані (компонент Таблиця, бенд Дерево) та їх заголовки/підсумки, за наявності, Всі бенди - експортуватимуться всі бенди звіту.</ExportMode>
    <ExportModeHtml>Cпособ розмітки HTML сторінки.</ExportModeHtml>
    <ExportModeRtf>Представлення даних звіту після експорту. Таблиця - звіт буде представлено у вигляді таблиці, де кожен компонент звіту - клітинка в таблиці. Рамка - кожен компонент буде являти собою окрему рамку, але взаємозв'язків між ними не буде.</ExportModeRtf>
    <ExportObjectFormatting>Застосовувати форматування до експорту з бендів Дані (компонент Таблиця, бенд Дерево).</ExportObjectFormatting>
    <ExportPageBreaks>Відобразити границі сторінок звіту на сторінці в Excel.</ExportPageBreaks>
    <ExportRtfTextAsImage>Конвертація Rtf тексту в картинку при експорті. Якщо параметр вимкнено, то RichText при експорті розкладається на більш прості примітиви, підтримувані форматом PDF. RichText зі складним форматуванням (вкладені зображення, таблиці) не завжди може бути перетворений коректно. У цьому випадку рекомендується увімкнути цей параметр.</ExportRtfTextAsImage>
    <Find>Пошук тексту в звіті.</Find>
    <FullScreen>Повноекранний перегляд звіту.</FullScreen>
    <GetCertificateFromCryptoUI>Використання інтерфейсу системної бібліотеки криптографії.</GetCertificateFromCryptoUI>
    <ImageCompressionMethod>Метод стиснення: JPEG - це стиснення з втратами, Flate - стиснення без втрат, Simple, Ordered, FloydSt. - зображення в монохромному режимі.</ImageCompressionMethod>
    <ImageFormat>Формат зображень в кінцевому файлі.</ImageFormat>
    <ImageQuality>Дозволяє вибрати співвідношення якість зображення/розмір файлу. Чим вища якість, тим більше розмір вихідного файлу.</ImageQuality>
    <ImageQualityPdf>Параметр доступний тільки при стисканні JPEG і дозволяє вибрати співвідношення якість зображення/розмір файлу. Чим вища якість, тим більший розмір вихідного файлу.</ImageQualityPdf>
    <ImageResolution>Кількість пікселів на дюйм зображення. Чим більша дана кількість пікселів, тим вище чіткість зображення і легкість сприйняття, але й розмір вихідного файлу набагато більший.</ImageResolution>
    <ImageType>Колірна схема зображення: колір - зображення після експорту буде повністю відповідати зображенню у формі перегляду; сірий - зображення після експорту буде сірого відтінку; монохромний - зображення буде суто чорно-біле. При цьому слід враховувати, що монохромні зображення мають три режими: None, Ordered, FloydSt.</ImageType>
    <KillSpaceLines>Видалити порожні лінії (рядки) в документі.</KillSpaceLines>
    <MultipleFiles>Кожна сторінка звіту окремим файлом.</MultipleFiles>
    <Open>Відкрити раніше збережений звіт.</Open>
    <OpenAfterExport>Автоматичне відкриття створеного документа (після завершення експорту) програмою, встановленою за замовчуванням для цих типів файлів.</OpenAfterExport>
    <OwnerPassword>Пароль доступу до операцій з файлом.</OwnerPassword>
    <PageAll>Обробка всіх сторінок звіту.</PageAll>
    <PageDelete>Видалити вибрану сторінку звіту.</PageDelete>
    <PageDesign>Змінити вибрану сторінку в дизайнері звітів.</PageDesign>
    <PageFirst>Перейти на першу сторінку звіту.</PageFirst>
    <PageGoTo>Перейти на вказану сторінку звіту.</PageGoTo>
    <PageLast>Перейти на останню сторінку звіту.</PageLast>
    <PageNew>Добавити нову сторінку в кінець звіту.</PageNew>
    <PageNext>Перейти на наступну сторінку звіту.</PageNext>
    <PagePrevious>Перейти на попередню сторінку звіту.</PagePrevious>
    <PageSize>Змінити параметри сторінки звіту.</PageSize>
    <Parameters>Відображення панелі параметрів звіту.</Parameters>
    <PdfACompliance>Підтримка стандарту довгострокового архівного зберігання електронних документів.</PdfACompliance>
    <Print>Надрукувати звіт.</Print>
    <PutFeedPageCode>Розділяти сторінки в кінцевому документі за допомогою спеціального символу.</PutFeedPageCode>
    <RangePages>Номери сторінок, які необхідно обробити. Вказати можна одну сторінку, список сторінок (використовуючи коми як роздільник), а також, вказати діапазон, задавши початкову сторінку діапазону, роздільник "-" і кінцеву сторінку діапазону. Для прикладу: 1,3,5-12.</RangePages>
    <RemoveEmptySpaceAtBottom>Мінімізувати порожнє місце внизу сторінки.</RemoveEmptySpaceAtBottom>
    <RestrictEditing>Обмежити редагування в документі Word.</RestrictEditing>
    <Save>Зберегти звіт для подальшого використання.</Save>
    <ScaleHtml>Розмір (масштаб) сторінок звіту та елементів звіту після експорту.</ScaleHtml>
    <ScaleImage>Розмір (масштаб) звіту після експорту. Чим менше масштаб, тим більше кількість пікселів на дюйм і навпаки.</ScaleImage>
    <SendEMail>Надіслати звіт по Email.</SendEMail>
    <Separator>Символ-роздільник даних у файлі CSV.</Separator>
    <SkipColumnHeaders>Увімкнути/вимкнути заголовки колонок.</SkipColumnHeaders>
    <StandardPdfFonts>14 стандартних шрифтів Adobe. Якщо цей параметр увімкнено, то в PDF файлі після експорту будуть використані тільки стандартні 14 шрифтів, і всі шрифти звіту будуть перетворені в них.</StandardPdfFonts>
    <SubjectNameString>Ідентифікатор сертифіката. Ідентифікатор - це ім'я власника сертифіката (повний рядок) або частина імені (частина рядка).</SubjectNameString>
    <Thumbnails>Відображення панелі ескізів, яку можна використовувати для швидкої навігації по звіту за допомогою маленьких зображень кожної сторінки.</Thumbnails>
    <TiffCompressionScheme>Схема стиснення для файлів TIFF.</TiffCompressionScheme>
    <ToolEditor>Цей інструмент дозволяє редагувати вміст текстових компонентів безпосередньо у вікні перегляду звіту.</ToolEditor>
    <TypeExport>Тип файлу, в який буде перетворено звіт.</TypeExport>
    <UseDefaultSystemEncoding>Використовувати кодування системи за замовчуванням або задати кодування за стандартом.</UseDefaultSystemEncoding>
    <UseOnePageHeaderAndFooter>Визначити бенди Заголовок сторінки і Підсумок сторінки як верхній і нижній колонтитул документа в MS Word.</UseOnePageHeaderAndFooter>
    <UsePageHeadersAndFooters>Визначити бенди Заголовок сторінки і Підсумок сторінки як верхній і нижній колонтитул документа в MS Word.</UsePageHeadersAndFooters>
    <UserPassword>Пароль необхідний для відкриття документа.</UserPassword>
    <UseUnicode>Розширена підтримка кодування символів. Впливає на внутрішнє кодування символів всередині PDF файлу і покращує копіювання тексту з PDF файлу.</UseUnicode>
    <ViewModeContinuous>Показувати всі сторінки звіту у вигляді вертикальної стрічки.</ViewModeContinuous>
    <ViewModeMultiplePages>Показувати стільки сторінок звіту, скільки вміщується у вікні перегляду.</ViewModeMultiplePages>
    <ViewModeSinglePage>Показувати тільки одну сторінку у вікні перегляду.</ViewModeSinglePage>
    <ZoomMultiplePages>Встановити такий масштаб відображення звіту, щоб вибрана кількість сторінок вмістилась у вікні перегляду.</ZoomMultiplePages>
    <ZoomOnePage>Встановити такий масштаб відображення звіту, щоб висота поточної сторінки займала всю доступну висоту вікна перегляду.</ZoomOnePage>
    <ZoomPageWidth>Встановити такий масштаб відображення звіту, щоб ширина поточної сторінки займала всю доступну ширину вікна перегляду.</ZoomPageWidth>
    <ZoomTwoPages>Встановити такий масштаб відображення звіту, щоб у вікні перегляду відображувалися дві сторінки поряд.</ZoomTwoPages>
    <ZoomTxt>Розмір (масштаб) звіту: X - змінити масштаб по горизонталі, Y - змінити масштаб по вертикалі.</ZoomTxt>
  </HelpViewer>
  <MainMenu>
    <menuCheckIssues>Перевірити</menuCheckIssues>
    <menuContextClone>Клонувати...</menuContextClone>
    <menuContextDesign>Редагувати...</menuContextDesign>
    <menuContextTextFormat>Формат...</menuContextTextFormat>
    <menuConvertToCheckBox>Перетворити в Прапорець</menuConvertToCheckBox>
    <menuConvertToImage>Перетворити в зображення</menuConvertToImage>
    <MenuConvertToRichText>Перетворити в Rich текст</MenuConvertToRichText>
    <menuConvertToText>Перетворити в текст</menuConvertToText>
    <menuDeleteColumn>Видалити стовпчик</menuDeleteColumn>
    <menuDeleteRow>Видалити рядок</menuDeleteRow>
    <menuEdit>&amp;Редагування</menuEdit>
    <menuEditBusinessObjectFromDataSetNew>Новий бізнес-об'єкт з набору даних...</menuEditBusinessObjectFromDataSetNew>
    <menuEditBusinessObjectNew>Новий бізнес-об'єкт...</menuEditBusinessObjectNew>
    <menuEditCalcColumnNew>Новий розрахунковий стовпчик...</menuEditCalcColumnNew>
    <menuEditCantRedo>Не можна повторити</menuEditCantRedo>
    <menuEditCantUndo>Не можна скасувати</menuEditCantUndo>
    <menuEditCategoryNew>Нова категорія...</menuEditCategoryNew>
    <menuEditClearContents>Очистити вміст</menuEditClearContents>
    <menuEditColumnNew>Новий стовпчик...</menuEditColumnNew>
    <menuEditConnectionNew>Нове з'єднання...</menuEditConnectionNew>
    <menuEditCopy>&amp;Копіювати</menuEditCopy>
    <menuEditCut>&amp;Вирізати</menuEditCut>
    <menuEditDataParameterNew>Новий параметр...</menuEditDataParameterNew>
    <menuEditDataSourceNew>Нове джерело даних...</menuEditDataSourceNew>
    <menuEditDataSourcesNew>Нові джерела даних...</menuEditDataSourcesNew>
    <menuEditDelete>&amp;Видалити</menuEditDelete>
    <menuEditEdit>Редагувати</menuEditEdit>
    <menuEditImportRelations>Імпортувати зв'язки...</menuEditImportRelations>
    <menuEditPaste>Вст&amp;авити</menuEditPaste>
    <menuEditRedo>Пов&amp;торити</menuEditRedo>
    <menuEditRedoText>Пов&amp;торити {0}</menuEditRedoText>
    <menuEditRelationNew>Новий зв'язок...</menuEditRelationNew>
    <menuEditRemoveUnused>Видалити невикористовувані елементи</menuEditRemoveUnused>
    <menuEditSelectAll>В&amp;ідмітити все</menuEditSelectAll>
    <menuEditSynchronize>Синхронізувати</menuEditSynchronize>
    <menuEditUndo>&amp;Скасувати</menuEditUndo>
    <menuEditUndoText>&amp;Скасувати {0}</menuEditUndoText>
    <menuEditVariableNew>Нова змінна...</menuEditVariableNew>
    <menuEditViewData>Перегляд даних...</menuEditViewData>
    <menuFile>&amp;Файл</menuFile>
    <menuFileClose>&amp;Закрити</menuFileClose>
    <menuFileExit>В&amp;ихід</menuFileExit>
    <menuFileExportXMLSchema>Експортувати XML схему...</menuFileExportXMLSchema>
    <menuFileFormNew>Створити форму</menuFileFormNew>
    <menuFileImportXMLSchema>Імпортувати XML схему...</menuFileImportXMLSchema>
    <menuFileMerge>Додати...</menuFileMerge>
    <menuFileMergeXMLSchema>Додати XML схему...</menuFileMergeXMLSchema>
    <menuFileNew>Ство&amp;рити</menuFileNew>
    <menuFileOpen>&amp;Відкрити...</menuFileOpen>
    <menuFilePageDelete>Видалити сторінку</menuFilePageDelete>
    <menuFilePageNew>Створити сторінку</menuFilePageNew>
    <menuFilePageOpen>Відкрити сторінку...</menuFilePageOpen>
    <menuFilePageSaveAs>Зберегти сторінку як...</menuFilePageSaveAs>
    <menuFilePageSetup>Властивості сторінки...</menuFilePageSetup>
    <menuFileRecentDocuments>Останні документи</menuFileRecentDocuments>
    <menuFileRecentLocations>Останні розміщення</menuFileRecentLocations>
    <menuFileReportNew>Ство&amp;рити звіт...</menuFileReportNew>
    <menuFileReportOpen>&amp;Відкрити звіт...</menuFileReportOpen>
    <menuFileReportOpenFromGoogleDocs>Відкрити звіт з Google Docs...</menuFileReportOpenFromGoogleDocs>
    <menuFileReportPreview>Попе&amp;редній перегляд...</menuFileReportPreview>
    <menuFileReportSave>&amp;Зберегти звіт</menuFileReportSave>
    <menuFileReportSaveAs>З&amp;берегти звіт як...</menuFileReportSaveAs>
    <menuFileReportSaveAsToGoogleDocs>Зберегти звіт в Google Docs...</menuFileReportSaveAsToGoogleDocs>
    <menuFileReportSetup>Властивості звіту...</menuFileReportSetup>
    <menuFileReportWizardNew>Створити звіт з &amp;Майстром...</menuFileReportWizardNew>
    <menuFileSave>&amp;Зберегти</menuFileSave>
    <menuFileSaveAs>Зберегти як...</menuFileSaveAs>
    <menuHelp>Допомога</menuHelp>
    <menuHelpAboutProgramm>Про програму...</menuHelpAboutProgramm>
    <menuHelpContents>Зміст...</menuHelpContents>
    <menuHelpFAQPage>Питання, що часто задають</menuHelpFAQPage>
    <menuHelpHowToRegister>Реєстрація</menuHelpHowToRegister>
    <menuHelpProductHomePage>Домашня сторінка</menuHelpProductHomePage>
    <menuHelpSupport>Підтримка</menuHelpSupport>
    <menuInsertColumnToLeft>Вставити стовпчик ліворуч</menuInsertColumnToLeft>
    <menuInsertColumnToRight>Вставити стовпчик праворуч</menuInsertColumnToRight>
    <menuInsertRowAbove>Вставити рядок вище</menuInsertRowAbove>
    <menuInsertRowBelow>Вставити рядок нижче</menuInsertRowBelow>
    <menuJoinCells>Об'єднати клітинки</menuJoinCells>
    <menuSelectColumn>Вибрати стовпчик</menuSelectColumn>
    <menuSelectRow>Вибрати рядок</menuSelectRow>
    <menuTable>Таблиця</menuTable>
    <menuTools>Се&amp;рвіс</menuTools>
    <menuToolsDataStore>Сховище даних...</menuToolsDataStore>
    <menuToolsDictionary>Словник...</menuToolsDictionary>
    <menuToolsOptions>Параметри...</menuToolsOptions>
    <menuToolsPagesManager>Менеджер сторінок...</menuToolsPagesManager>
    <menuToolsServicesConfigurator>Конфігуратор сервісів...</menuToolsServicesConfigurator>
    <menuToolsStyleDesigner>Редактор стилів...</menuToolsStyleDesigner>
    <menuView>&amp;Вигляд</menuView>
    <menuViewAlignToGrid>Прив'язувати до сітки</menuViewAlignToGrid>
    <menuViewLockDockingPanels>Закріпити панелі</menuViewLockDockingPanels>
    <menuViewLockToolbars>Заблокувати панелі</menuViewLockToolbars>
    <menuViewNormal>&amp;Звичайний</menuViewNormal>
    <menuViewOptions>Параметри</menuViewOptions>
    <menuViewPageBreakPreview>&amp;Розмітка сторінки</menuViewPageBreakPreview>
    <menuViewQuickInfo>Швидкі відомості</menuViewQuickInfo>
    <menuViewQuickInfoNone>Не показувати</menuViewQuickInfoNone>
    <menuViewQuickInfoOverlay>Показувати поверх компонентів</menuViewQuickInfoOverlay>
    <menuViewQuickInfoShowAliases>Показувати аліаси</menuViewQuickInfoShowAliases>
    <menuViewQuickInfoShowComponentsNames>Показувати імена компонентів</menuViewQuickInfoShowComponentsNames>
    <menuViewQuickInfoShowContent>Показувати вміст</menuViewQuickInfoShowContent>
    <menuViewQuickInfoShowEvents>Показувати події</menuViewQuickInfoShowEvents>
    <menuViewQuickInfoShowFields>Показувати поля</menuViewQuickInfoShowFields>
    <menuViewQuickInfoShowFieldsOnly>Показувати тільки поля</menuViewQuickInfoShowFieldsOnly>
    <menuViewShowGrid>Сітка</menuViewShowGrid>
    <menuViewShowHeaders>Заголовки</menuViewShowHeaders>
    <menuViewShowOrder>Показувати порядок</menuViewShowOrder>
    <menuViewShowRulers>Лінійка</menuViewShowRulers>
    <menuViewToolbars>Панелі &amp;інструментів</menuViewToolbars>
  </MainMenu>
  <Panels>
    <Dictionary>Словник</Dictionary>
    <Messages>Повідомлення</Messages>
    <Properties>Властивості</Properties>
    <ReportTree>Дерево звіту</ReportTree>
  </Panels>
  <Password>
    <gbPassword>Шифрування файлу</gbPassword>
    <lbPasswordLoad>Введіть пароль для відкриття цього файлу</lbPasswordLoad>
    <lbPasswordSave>Пароль:</lbPasswordSave>
    <PasswordNotEntered>Пароль не введено</PasswordNotEntered>
    <StiLoadPasswordForm>Шифрування документа</StiLoadPasswordForm>
    <StiSavePasswordForm>Пароль</StiSavePasswordForm>
  </Password>
  <PlacementComponent>
    <MoveLeftFreeSpace>Переміщує компонент у ліву частину вільного простору, збільшуючи його висоту до висоти вільного простору.</MoveLeftFreeSpace>
    <MoveRightFreeSpace>Переміщує компонент у праву частину вільного простору, збільшуючи його висоту до висоти вільного простору.</MoveRightFreeSpace>
  </PlacementComponent>
  <PropertyCategory>
    <AppearanceCategory>Оформлення</AppearanceCategory>
    <ArgumentCategory>Аргумент</ArgumentCategory>
    <BarCodeAdditionalCategory>Штрих-код, додаткові</BarCodeAdditionalCategory>
    <BarCodeCategory>Штрих-код</BarCodeCategory>
    <BehaviorCategory>Поведінка</BehaviorCategory>
    <CellCategory>Клітинка</CellCategory>
    <ChartAdditionalCategory>Діаграма, додаткові</ChartAdditionalCategory>
    <ChartCategory>Діаграма</ChartCategory>
    <CheckCategory>Прапорець</CheckCategory>
    <ColorsCategory>Кольори</ColorsCategory>
    <ColumnsCategory>Стовпчики</ColumnsCategory>
    <ControlCategory>Керування</ControlCategory>
    <ControlsEventsCategory>Події елементів керування</ControlsEventsCategory>
    <CrossTabCategory>Крос-таблиця</CrossTabCategory>
    <DataCategory>Дані</DataCategory>
    <DescriptionCategory>Опис</DescriptionCategory>
    <DesignCategory>Редагування</DesignCategory>
    <DisplayCategory>Відображення</DisplayCategory>
    <ExportCategory>Експорт</ExportCategory>
    <ExportEventsCategory>Експортувати події</ExportEventsCategory>
    <FooterTableCategory>Підсумок таблиці</FooterTableCategory>
    <HeaderTableCategory>Заголовок таблиці</HeaderTableCategory>
    <HierarchicalCategory>Ієрархія</HierarchicalCategory>
    <ImageAdditionalCategory>Зображення, додаткові</ImageAdditionalCategory>
    <ImageCategory>Зображення</ImageCategory>
    <MainCategory>Основні</MainCategory>
    <MarkerCategory>Маркер</MarkerCategory>
    <MiscCategory>Інші</MiscCategory>
    <MouseEventsCategory>Миша</MouseEventsCategory>
    <NavigationCategory>Навігація</NavigationCategory>
    <NavigationEventsCategory>Навігація</NavigationEventsCategory>
    <OptionsCategory>Параметри</OptionsCategory>
    <PageAdditionalCategory>Сторінка, додаткові</PageAdditionalCategory>
    <PageCategory>Сторінка</PageCategory>
    <PageColumnBreakCategory>Розрив сторінки та стовпчика</PageColumnBreakCategory>
    <ParametersCategory>Параметри</ParametersCategory>
    <PositionCategory>Розташування</PositionCategory>
    <PrimitiveCategory>Примітиви</PrimitiveCategory>
    <PrintEventsCategory>Друк</PrintEventsCategory>
    <RenderEventsCategory>Побудова</RenderEventsCategory>
    <ShapeCategory>Форма</ShapeCategory>
    <SubReportCategory>Вкладений звіт</SubReportCategory>
    <TableCategory>Таблиця</TableCategory>
    <TextAdditionalCategory>Текст, додаткові</TextAdditionalCategory>
    <TextCategory>Текст</TextCategory>
    <TitleCategory>Заголовок</TitleCategory>
    <ValueCategory>Значення</ValueCategory>
    <ValueCloseCategory>Закриваюче значення</ValueCloseCategory>
    <ValueEndCategory>Кінцеве значення</ValueEndCategory>
    <ValueEventsCategory>Значення</ValueEventsCategory>
    <ValueHighCategory>Максимум</ValueHighCategory>
    <ValueLowCategory>Мінімум</ValueLowCategory>
    <ValueOpenCategory>Відкриваюче значення</ValueOpenCategory>
    <WeightCategory>Вага</WeightCategory>
    <WinControlCategory>Win компонент</WinControlCategory>
    <ZipCodeCategory>Поштовий індекс</ZipCodeCategory>
  </PropertyCategory>
  <PropertyColor>
    <AliceBlue>Акварельно-синій</AliceBlue>
    <AntiqueWhite>Білий-антик</AntiqueWhite>
    <Aqua>Ціан акварельний</Aqua>
    <Aquamarine>Аквамарин</Aquamarine>
    <Azure>Блакитний</Azure>
    <Beige>Бежевий</Beige>
    <Bisque>Ясно-коричневий</Bisque>
    <Black>Чорний</Black>
    <BlanchedAlmond>Блідо-мигдальний</BlanchedAlmond>
    <Blue>Синій</Blue>
    <BlueViolet>Синьо-фіолетовий</BlueViolet>
    <Brown>Коричневий</Brown>
    <BurlyWood>Деревний</BurlyWood>
    <CadetBlue>Сіро-синій</CadetBlue>
    <Chartreuse>Зеленувато-жовтий</Chartreuse>
    <Chocolate>Шоколадний</Chocolate>
    <Coral>Кораловий</Coral>
    <CornflowerBlue>Волошковий</CornflowerBlue>
    <Cornsilk>Шовковий відтінок</Cornsilk>
    <Crimson>Малиновий</Crimson>
    <Cyan>Ціан</Cyan>
    <DarkBlue>Темно-синій</DarkBlue>
    <DarkCyan>Ціан темний</DarkCyan>
    <DarkGoldenrod>Темно-золотавий</DarkGoldenrod>
    <DarkGray>Темно-сірий</DarkGray>
    <DarkGreen>Темно-зелений</DarkGreen>
    <DarkKhaki>Хакі темний</DarkKhaki>
    <DarkMagenta>Фуксин темний</DarkMagenta>
    <DarkOliveGreen>Темно-маслиново-зелений</DarkOliveGreen>
    <DarkOrange>Темно-жовтогарячий</DarkOrange>
    <DarkOrchid>Орхідея темний</DarkOrchid>
    <DarkRed>Темно-червоний</DarkRed>
    <DarkSalmon>Лосось темний</DarkSalmon>
    <DarkSeaGreen>Морська хвиля темний</DarkSeaGreen>
    <DarkSlateBlue>Темно-грифельно-синій</DarkSlateBlue>
    <DarkSlateGray>Темно-грифельно-сірий</DarkSlateGray>
    <DarkTurquoise>Темно-бірюзовий</DarkTurquoise>
    <DarkViolet>Темно-фіолетовий</DarkViolet>
    <DeepPink>Насичено-рожевий</DeepPink>
    <DeepSkyBlue>Насичено-небесно-голубий</DeepSkyBlue>
    <DimGray>Тьмяно-сірий</DimGray>
    <DodgerBlue>Сіро-синій</DodgerBlue>
    <Firebrick>Цегельний</Firebrick>
    <FloralWhite>Квітка біла</FloralWhite>
    <ForestGreen>Зелений ліс</ForestGreen>
    <Fuchsia>Фуксія</Fuchsia>
    <Gainsboro>Сріблисто-сірий</Gainsboro>
    <GhostWhite>Прозоро-білий</GhostWhite>
    <Gold>Золотий</Gold>
    <Goldenrod>Золотавий</Goldenrod>
    <Gray>Сірий</Gray>
    <Green>Зелений</Green>
    <GreenYellow>Зелено-жовтий</GreenYellow>
    <Honeydew>Медяний</Honeydew>
    <HotPink>Тепло-рожевий</HotPink>
    <IndianRed>Кіновар</IndianRed>
    <Indigo>Індіго</Indigo>
    <Ivory>Слонова кістка</Ivory>
    <Khaki>Хакі</Khaki>
    <Lavender>Блідо-ліловий</Lavender>
    <LavenderBlush>Голубий із червоним відливом</LavenderBlush>
    <LawnGreen>Зелена галявина</LawnGreen>
    <LemonChiffon>Лимонний</LemonChiffon>
    <LightBlue>Голубий</LightBlue>
    <LightCoral>Світло-кораловий</LightCoral>
    <LightCyan>Ціан світлий</LightCyan>
    <LightGoldenrodYellow>Світло-золотавий</LightGoldenrodYellow>
    <LightGray>Ясно-сірий</LightGray>
    <LightGreen>Ясно-зелений</LightGreen>
    <LightPink>Ясно-рожевий</LightPink>
    <LightSalmon>Лосось світлий</LightSalmon>
    <LightSeaGreen>Колір морської хвилі світлий</LightSeaGreen>
    <LightSkyBlue>Світло-небесно-голубий</LightSkyBlue>
    <LightSlateGray>Світло-грифельно-синій</LightSlateGray>
    <LightSteelBlue>Голубий зі сталевим відтінком</LightSteelBlue>
    <LightYellow>Ясно-жовтий</LightYellow>
    <Lime>Зеленувато-лимонний</Lime>
    <LimeGreen>Лимонно-зелений</LimeGreen>
    <Linen>Лляний</Linen>
    <Magenta>Фуксин</Magenta>
    <Maroon>Темно-бордовий</Maroon>
    <MediumAquamarine>Нейтрально-аквамариновий</MediumAquamarine>
    <MediumBlue>Нейтрально-синій</MediumBlue>
    <MediumOrchid>Орхідея нейтральний</MediumOrchid>
    <MediumPurple>Нейтрально-пурпурний</MediumPurple>
    <MediumSeaGreen>Кольори морської хвилі нейтральний</MediumSeaGreen>
    <MediumSlateBlue>Нейтрально-грифельно-синій</MediumSlateBlue>
    <MediumSpringGreen>Нейтрально-весняно-зелений</MediumSpringGreen>
    <MediumTurquoise>Нейтрально-бірюзовий</MediumTurquoise>
    <MediumVioletRed>Нейтрально-фіолетово-червоний</MediumVioletRed>
    <MidnightBlue>Північно-синій</MidnightBlue>
    <MintCream>М'ятний крем</MintCream>
    <MistyRose>Тьмяно-рожевий</MistyRose>
    <Moccasin>Замша світлий</Moccasin>
    <NavajoWhite>Білий-навахо</NavajoWhite>
    <Navy>Ультрамарин</Navy>
    <OldLace>Старе мереживо</OldLace>
    <Olive>Маслиновий</Olive>
    <OliveDrab>Тьмяно-маслиновий</OliveDrab>
    <Orange>Жовтогарячий</Orange>
    <OrangeRed>Оранжево-червоний</OrangeRed>
    <Orchid>Орхідея</Orchid>
    <PaleGoldenrod>Блідо-золотавий</PaleGoldenrod>
    <PaleGreen>Блідо-зелений</PaleGreen>
    <PaleTurquoise>Блідо-бірюзовий</PaleTurquoise>
    <PaleVioletRed>Блідо-червоно-фіолетовий</PaleVioletRed>
    <PapayaWhip>Пряжене молоко</PapayaWhip>
    <PeachPuff>Персиковий</PeachPuff>
    <Peru>Нейтрально-коричневий</Peru>
    <Pink>Рожевий</Pink>
    <Plum>Сливовий</Plum>
    <PowderBlue>Синій з пороховим відтінком</PowderBlue>
    <Purple>Пурпурний</Purple>
    <Red>Червоний</Red>
    <RosyBrown>Рожево-коричневий</RosyBrown>
    <RoyalBlue>Королівський синій</RoyalBlue>
    <SaddleBrown>Шкіряно-коричневий</SaddleBrown>
    <Salmon>Лосось</Salmon>
    <SandyBrown>Піщано-коричневий</SandyBrown>
    <SeaGreen>Кольори морської хвилі</SeaGreen>
    <SeaShell>Перламутровий</SeaShell>
    <Sienna>Охра</Sienna>
    <Silver>Срібний</Silver>
    <SkyBlue>Небесно-голубий</SkyBlue>
    <SlateBlue>Грифельно-синій</SlateBlue>
    <SlateGray>Грифельно-сірий</SlateGray>
    <Snow>Білосніжний</Snow>
    <SpringGreen>Весняно-зелений</SpringGreen>
    <SteelBlue>Синій зі сталевим відтінком</SteelBlue>
    <Tan>Рудувато-коричневий</Tan>
    <Teal>Ціан нейтральний</Teal>
    <Thistle>Блідо-бузковий</Thistle>
    <Tomato>Томатний</Tomato>
    <Transparent>Прозорий</Transparent>
    <Turquoise>Бірюзовий</Turquoise>
    <Violet>Фіолетовий</Violet>
    <Wheat>Пшеничний</Wheat>
    <White>Білий</White>
    <WhiteSmoke>Димчасто-білий</WhiteSmoke>
    <Yellow>Жовтий</Yellow>
    <YellowGreen>Жовто-зелений</YellowGreen>
  </PropertyColor>
  <PropertyEnum>
    <boolFalse>Ні</boolFalse>
    <boolTrue>Так</boolTrue>
    <BorderStyleFixed3D>Тривимірна</BorderStyleFixed3D>
    <BorderStyleFixedSingle>Одинарна</BorderStyleFixedSingle>
    <BorderStyleNone>Немає</BorderStyleNone>
    <ChartAxesTicksAll>Всі</ChartAxesTicksAll>
    <ChartAxesTicksMajor>Основні</ChartAxesTicksMajor>
    <ChartAxesTicksNone>Немає</ChartAxesTicksNone>
    <ChartGridLinesAll>Всі</ChartGridLinesAll>
    <ChartGridLinesMajor>Основні</ChartGridLinesMajor>
    <ChartGridLinesNone>Немає</ChartGridLinesNone>
    <ComboBoxStyleDropDown>Випадаючий список</ComboBoxStyleDropDown>
    <ComboBoxStyleDropDownList>Тільки список</ComboBoxStyleDropDownList>
    <ComboBoxStyleSimple>Простий</ComboBoxStyleSimple>
    <ContentAlignmentBottomCenter>Знизу по центру</ContentAlignmentBottomCenter>
    <ContentAlignmentBottomLeft>Знизу лівруч</ContentAlignmentBottomLeft>
    <ContentAlignmentBottomRight>Знизу праворуч</ContentAlignmentBottomRight>
    <ContentAlignmentMiddleCenter>Посередині по центру</ContentAlignmentMiddleCenter>
    <ContentAlignmentMiddleLeft>Посередині лівруч</ContentAlignmentMiddleLeft>
    <ContentAlignmentMiddleRight>Посередині праворуч</ContentAlignmentMiddleRight>
    <ContentAlignmentTopCenter>Зверху по центру</ContentAlignmentTopCenter>
    <ContentAlignmentTopLeft>Зверху лівруч</ContentAlignmentTopLeft>
    <ContentAlignmentTopRight>Зверху праворуч</ContentAlignmentTopRight>
    <DataGridLineStyleNone>Немає</DataGridLineStyleNone>
    <DataGridLineStyleSolid>Суцільна</DataGridLineStyleSolid>
    <DateTimePickerFormatCustom>На вибір</DateTimePickerFormatCustom>
    <DateTimePickerFormatLong>Довгий</DateTimePickerFormatLong>
    <DateTimePickerFormatShort>Короткий</DateTimePickerFormatShort>
    <DateTimePickerFormatTime>Час</DateTimePickerFormatTime>
    <DialogResultAbort>Перервати</DialogResultAbort>
    <DialogResultCancel>Відмінити</DialogResultCancel>
    <DialogResultIgnore>Ігнорувати</DialogResultIgnore>
    <DialogResultNo>Ні</DialogResultNo>
    <DialogResultNone>Не зазначено</DialogResultNone>
    <DialogResultOK>Гаразд</DialogResultOK>
    <DialogResultRetry>Повторити</DialogResultRetry>
    <DialogResultYes>Так</DialogResultYes>
    <DockStyleBottom>До нижнього краю</DockStyleBottom>
    <DockStyleFill>Заповнити все</DockStyleFill>
    <DockStyleLeft>До лівого краю</DockStyleLeft>
    <DockStyleNone>Не стикувати</DockStyleNone>
    <DockStyleRight>До правого краю</DockStyleRight>
    <DockStyleTop>До верхнього краю</DockStyleTop>
    <DuplexDefault>За замовчуванням</DuplexDefault>
    <DuplexHorizontal>Горизонтальний</DuplexHorizontal>
    <DuplexSimplex>Симплекс</DuplexSimplex>
    <DuplexVertical>Вертикальний</DuplexVertical>
    <FormStartPositionCenterParent>По центру головного вікна</FormStartPositionCenterParent>
    <FormStartPositionCenterScreen>По центру екрана</FormStartPositionCenterScreen>
    <FormStartPositionManual>Ручний</FormStartPositionManual>
    <FormStartPositionWindowsDefaultBounds>Границі за замовчуванням</FormStartPositionWindowsDefaultBounds>
    <FormStartPositionWindowsDefaultLocation>Положення за замовчуванням</FormStartPositionWindowsDefaultLocation>
    <FormWindowStateMaximized>Розгортати</FormWindowStateMaximized>
    <FormWindowStateMinimized>Згортати</FormWindowStateMinimized>
    <FormWindowStateNormal>Нормальне</FormWindowStateNormal>
    <HorizontalAlignmentCenter>По центру</HorizontalAlignmentCenter>
    <HorizontalAlignmentLeft>По лівому краю</HorizontalAlignmentLeft>
    <HorizontalAlignmentRight>По правому краю</HorizontalAlignmentRight>
    <HotkeyPrefixHide>Не показувати</HotkeyPrefixHide>
    <HotkeyPrefixNone>Ігнорувати</HotkeyPrefixNone>
    <HotkeyPrefixShow>Показувати</HotkeyPrefixShow>
    <LeftRightAlignmentLeft>З лівої сторони</LeftRightAlignmentLeft>
    <LeftRightAlignmentRight>Із правої сторони</LeftRightAlignmentRight>
    <PictureBoxSizeModeAutoSize>Авто розмір</PictureBoxSizeModeAutoSize>
    <PictureBoxSizeModeCenterImage>Центрувати зображення</PictureBoxSizeModeCenterImage>
    <PictureBoxSizeModeNormal>Нормальний</PictureBoxSizeModeNormal>
    <PictureBoxSizeModeStretchImage>Розтягувати</PictureBoxSizeModeStretchImage>
    <RightToLeftInherit>Успадковувати</RightToLeftInherit>
    <RightToLeftNo>Ні</RightToLeftNo>
    <RightToLeftYes>Так</RightToLeftYes>
    <SelectionModeMultiExtended>Мульти розширений</SelectionModeMultiExtended>
    <SelectionModeMultiSimple>Мульти простий</SelectionModeMultiSimple>
    <SelectionModeNone>Немає</SelectionModeNone>
    <SelectionModeOne>Один</SelectionModeOne>
    <StiAngleAngle0>Кут нахилу - 0 градусів</StiAngleAngle0>
    <StiAngleAngle180>Кут нахилу - 180 градусів</StiAngleAngle180>
    <StiAngleAngle270>Кут нахилу - 270 градусів</StiAngleAngle270>
    <StiAngleAngle45>Кут нахилу - 45 градусів</StiAngleAngle45>
    <StiAngleAngle90>Кут нахилу - 90 градусів</StiAngleAngle90>
    <StiArrowStyleArc>Дуга</StiArrowStyleArc>
    <StiArrowStyleArcAndCircle>Дуга та круг</StiArrowStyleArcAndCircle>
    <StiArrowStyleCircle>Круг</StiArrowStyleCircle>
    <StiArrowStyleLines>Лінії</StiArrowStyleLines>
    <StiArrowStyleNone>Немає</StiArrowStyleNone>
    <StiArrowStyleTriangle>Трикутник</StiArrowStyleTriangle>
    <StiBorderSidesAll>З усіх боків</StiBorderSidesAll>
    <StiBorderSidesBottom>Знизу</StiBorderSidesBottom>
    <StiBorderSidesLeft>Ліворуч</StiBorderSidesLeft>
    <StiBorderSidesNone>Немає</StiBorderSidesNone>
    <StiBorderSidesRight>Праворуч</StiBorderSidesRight>
    <StiBorderSidesTop>Зверху</StiBorderSidesTop>
    <StiBorderStyleBump>Втиснена</StiBorderStyleBump>
    <StiBorderStyleEtched>Опукла</StiBorderStyleEtched>
    <StiBorderStyleFlat>Плоский</StiBorderStyleFlat>
    <StiBorderStyleNone>Немає</StiBorderStyleNone>
    <StiBorderStyleRaised>Рельєфний</StiBorderStyleRaised>
    <StiBorderStyleRaisedInner>Рельєфний усередині</StiBorderStyleRaisedInner>
    <StiBorderStyleRaisedOuter>Рельєфний зовні</StiBorderStyleRaisedOuter>
    <StiBorderStyleSunken>Запалий</StiBorderStyleSunken>
    <StiBorderStyleSunkenInner>Запалий усередині</StiBorderStyleSunkenInner>
    <StiBorderStyleSunkenOuter>Запалий зовні</StiBorderStyleSunkenOuter>
    <StiBrushTypeGlare>Пензлик відблиску</StiBrushTypeGlare>
    <StiBrushTypeGradient0>Градієнтний пензлик, Кут 0</StiBrushTypeGradient0>
    <StiBrushTypeGradient180>Градієнтний пензлик, Кут 180</StiBrushTypeGradient180>
    <StiBrushTypeGradient270>Градієнтний пензлик, Кут 270</StiBrushTypeGradient270>
    <StiBrushTypeGradient45>Градієнтний пензлик, Кут 45</StiBrushTypeGradient45>
    <StiBrushTypeGradient90>Градієнтний пензлик, Кут 90</StiBrushTypeGradient90>
    <StiBrushTypeSolid>Суцільний пензлик</StiBrushTypeSolid>
    <StiCalculationModeCompilation>Компіляція</StiCalculationModeCompilation>
    <StiCalculationModeInterpretation>Інтерпретація</StiCalculationModeInterpretation>
    <StiCapStyleArrow>Стрілка</StiCapStyleArrow>
    <StiCapStyleDiamond>Ромбовидна стрілка</StiCapStyleDiamond>
    <StiCapStyleNone>Немає стрілки</StiCapStyleNone>
    <StiCapStyleOpen>Відкрита стрілка</StiCapStyleOpen>
    <StiCapStyleOval>Овальна стрілка</StiCapStyleOval>
    <StiCapStyleSquare>Квадратна стрілка</StiCapStyleSquare>
    <StiCapStyleStealth>Увігнута стрілка</StiCapStyleStealth>
    <StiChartTitleDockBottom>Нижній</StiChartTitleDockBottom>
    <StiChartTitleDockLeft>Лівий</StiChartTitleDockLeft>
    <StiChartTitleDockRight>Правий</StiChartTitleDockRight>
    <StiChartTitleDockTop>Верхній</StiChartTitleDockTop>
    <StiCheckStyleCheck>Прапорець</StiCheckStyleCheck>
    <StiCheckStyleCheckRectangle>Прямокутник з прапорцем</StiCheckStyleCheckRectangle>
    <StiCheckStyleCross>Хрестик</StiCheckStyleCross>
    <StiCheckStyleCrossCircle>Перекреслене коло</StiCheckStyleCrossCircle>
    <StiCheckStyleCrossRectangle>Перекреслений прямокутник</StiCheckStyleCrossRectangle>
    <StiCheckStyleDotCircle>Коло з крапкою</StiCheckStyleDotCircle>
    <StiCheckStyleDotRectangle>Прямокутник з крапкою</StiCheckStyleDotRectangle>
    <StiCheckStyleNone>Немає</StiCheckStyleNone>
    <StiCheckStyleNoneCircle>Порожнє коло</StiCheckStyleNoneCircle>
    <StiCheckStyleNoneRectangle>Порожній прямокутник</StiCheckStyleNoneRectangle>
    <StiCheckSumNo>Ні</StiCheckSumNo>
    <StiCheckSumYes>Так</StiCheckSumYes>
    <StiCode11CheckSumAuto>Авто</StiCode11CheckSumAuto>
    <StiCode11CheckSumNone>Немає</StiCode11CheckSumNone>
    <StiCode11CheckSumOneDigit>Одна цифра</StiCode11CheckSumOneDigit>
    <StiCode11CheckSumTwoDigits>Дві цифри</StiCode11CheckSumTwoDigits>
    <StiColorScaleTypeColor2>Двоколірна шкала</StiColorScaleTypeColor2>
    <StiColorScaleTypeColor3>Триколірна шкала</StiColorScaleTypeColor3>
    <StiColumnDirectionAcrossThenDown>Вправо потім униз</StiColumnDirectionAcrossThenDown>
    <StiColumnDirectionDownThenAcross>Униз потім вправо</StiColumnDirectionDownThenAcross>
    <StiCrossHorAlignmentCenter>По центру</StiCrossHorAlignmentCenter>
    <StiCrossHorAlignmentLeft>Вліво</StiCrossHorAlignmentLeft>
    <StiCrossHorAlignmentNone>Немає</StiCrossHorAlignmentNone>
    <StiCrossHorAlignmentRight>Вправо</StiCrossHorAlignmentRight>
    <StiDateTimeTypeDate>Дата</StiDateTimeTypeDate>
    <StiDateTimeTypeDateAndTime>Дата та час</StiDateTimeTypeDateAndTime>
    <StiDateTimeTypeTime>Час</StiDateTimeTypeTime>
    <StiDockStyleBottom>Знизу</StiDockStyleBottom>
    <StiDockStyleFill>Заповнення</StiDockStyleFill>
    <StiDockStyleLeft>Зліва</StiDockStyleLeft>
    <StiDockStyleNone>Немає</StiDockStyleNone>
    <StiDockStyleRight>Справа</StiDockStyleRight>
    <StiDockStyleTop>Зверху</StiDockStyleTop>
    <StiDrillDownModeMultiPage>Кілька сторінок</StiDrillDownModeMultiPage>
    <StiDrillDownModeSinglePage>Одна сторінка</StiDrillDownModeSinglePage>
    <StiEanSupplementTypeFiveDigit>П'ять цифр</StiEanSupplementTypeFiveDigit>
    <StiEanSupplementTypeNone>Ні</StiEanSupplementTypeNone>
    <StiEanSupplementTypeTwoDigit>Дві цифри</StiEanSupplementTypeTwoDigit>
    <StiEmptySizeModeAlignFooterToBottom>Вирівнювати підвал по нижньому краю</StiEmptySizeModeAlignFooterToBottom>
    <StiEmptySizeModeAlignFooterToTop>Вирівнювати підвал по верхньому краю</StiEmptySizeModeAlignFooterToTop>
    <StiEmptySizeModeDecreaseLastRow>Зменшувати висоту останнього рядка</StiEmptySizeModeDecreaseLastRow>
    <StiEmptySizeModeIncreaseLastRow>Збільшувати висоту останнього рядка</StiEmptySizeModeIncreaseLastRow>
    <StiEnumeratorTypeABC>АБВ</StiEnumeratorTypeABC>
    <StiEnumeratorTypeArabic>Арабський</StiEnumeratorTypeArabic>
    <StiEnumeratorTypeNone>Нема</StiEnumeratorTypeNone>
    <StiEnumeratorTypeRoman>Роман</StiEnumeratorTypeRoman>
    <StiFilterConditionBeginningWith>починається з</StiFilterConditionBeginningWith>
    <StiFilterConditionBetween>між</StiFilterConditionBetween>
    <StiFilterConditionContaining>містить</StiFilterConditionContaining>
    <StiFilterConditionEndingWith>закінчується на</StiFilterConditionEndingWith>
    <StiFilterConditionEqualTo>дорівнює</StiFilterConditionEqualTo>
    <StiFilterConditionGreaterThan>більше ніж</StiFilterConditionGreaterThan>
    <StiFilterConditionGreaterThanOrEqualTo>більше ніж або дорівнює</StiFilterConditionGreaterThanOrEqualTo>
    <StiFilterConditionIsNotNull>не дорівнює null</StiFilterConditionIsNotNull>
    <StiFilterConditionIsNull>дорівнює null</StiFilterConditionIsNull>
    <StiFilterConditionLessThan>менше ніж</StiFilterConditionLessThan>
    <StiFilterConditionLessThanOrEqualTo>менше ніж або дорівнює</StiFilterConditionLessThanOrEqualTo>
    <StiFilterConditionNotBetween>не між</StiFilterConditionNotBetween>
    <StiFilterConditionNotContaining>не містить</StiFilterConditionNotContaining>
    <StiFilterConditionNotEqualTo>не дорівнює</StiFilterConditionNotEqualTo>
    <StiFilterDataTypeBoolean>Логічний</StiFilterDataTypeBoolean>
    <StiFilterDataTypeDateTime>Дата</StiFilterDataTypeDateTime>
    <StiFilterDataTypeExpression>Вираз</StiFilterDataTypeExpression>
    <StiFilterDataTypeNumeric>Числовий</StiFilterDataTypeNumeric>
    <StiFilterDataTypeString>Рядок</StiFilterDataTypeString>
    <StiFilterEngineReportEngine>Ядро генератора</StiFilterEngineReportEngine>
    <StiFilterEngineSQLQuery>SQL запит</StiFilterEngineSQLQuery>
    <StiFilterItemArgument>Аргумент</StiFilterItemArgument>
    <StiFilterItemExpression>Вираз</StiFilterItemExpression>
    <StiFilterItemValue>Значення</StiFilterItemValue>
    <StiFilterItemValueClose>Значення, що закриває</StiFilterItemValueClose>
    <StiFilterItemValueEnd>Кінцеве значення</StiFilterItemValueEnd>
    <StiFilterItemValueHigh>Максимум</StiFilterItemValueHigh>
    <StiFilterItemValueLow>Мінімум</StiFilterItemValueLow>
    <StiFilterItemValueOpen>Значення, що відкриває</StiFilterItemValueOpen>
    <StiFilterModeAnd>І</StiFilterModeAnd>
    <StiFilterModeOr>Або</StiFilterModeOr>
    <StiFormStartModeOnEnd>На завершення</StiFormStartModeOnEnd>
    <StiFormStartModeOnPreview>На попередній перегляд</StiFormStartModeOnPreview>
    <StiFormStartModeOnStart>На старті</StiFormStartModeOnStart>
    <StiGroupSortDirectionAscending>За зростанням</StiGroupSortDirectionAscending>
    <StiGroupSortDirectionDescending>За спаданням</StiGroupSortDirectionDescending>
    <StiGroupSortDirectionNone>Немає</StiGroupSortDirectionNone>
    <StiHorAlignmentCenter>По центру</StiHorAlignmentCenter>
    <StiHorAlignmentLeft>По лівому краю</StiHorAlignmentLeft>
    <StiHorAlignmentRight>По правому краю</StiHorAlignmentRight>
    <StiImageProcessingDuplicatesTypeGlobalHide>Приховати глобально</StiImageProcessingDuplicatesTypeGlobalHide>
    <StiImageProcessingDuplicatesTypeGlobalMerge>З'єднати глобально</StiImageProcessingDuplicatesTypeGlobalMerge>
    <StiImageProcessingDuplicatesTypeGlobalRemoveImage>Видалити зображення глобально</StiImageProcessingDuplicatesTypeGlobalRemoveImage>
    <StiImageProcessingDuplicatesTypeHide>Приховати</StiImageProcessingDuplicatesTypeHide>
    <StiImageProcessingDuplicatesTypeMerge>З'єднати</StiImageProcessingDuplicatesTypeMerge>
    <StiImageProcessingDuplicatesTypeNone>Немає</StiImageProcessingDuplicatesTypeNone>
    <StiImageProcessingDuplicatesTypeRemoveImage>Видалити зображення</StiImageProcessingDuplicatesTypeRemoveImage>
    <StiImageRotationFlipHorizontal>Перевернути по горизонталі</StiImageRotationFlipHorizontal>
    <StiImageRotationFlipVertical>Перевернути по горизонталі</StiImageRotationFlipVertical>
    <StiImageRotationNone>Немає</StiImageRotationNone>
    <StiImageRotationRotate180>Повернути на 180°</StiImageRotationRotate180>
    <StiImageRotationRotate90CCW>Повернути на 90° проти годинникової стрілки</StiImageRotationRotate90CCW>
    <StiImageRotationRotate90CW>Повернути на 90° за годинниковою стрілкою</StiImageRotationRotate90CW>
    <StiKeepDetailsKeepDetailsTogether>Тримати деталі разом</StiKeepDetailsKeepDetailsTogether>
    <StiKeepDetailsKeepFirstDetailTogether>Тримати першу деталь</StiKeepDetailsKeepFirstDetailTogether>
    <StiKeepDetailsKeepFirstRowTogether>Тримати перший рядок</StiKeepDetailsKeepFirstRowTogether>
    <StiKeepDetailsNone>Ні</StiKeepDetailsNone>
    <StiLabelsPlacementNone>Немає</StiLabelsPlacementNone>
    <StiLabelsPlacementOneLine>В одну лінію</StiLabelsPlacementOneLine>
    <StiLabelsPlacementTwoLines>У дві лінії</StiLabelsPlacementTwoLines>
    <StiLegendDirectionBottomToTop>Знизу Вверх</StiLegendDirectionBottomToTop>
    <StiLegendDirectionLeftToRight>Зліва направо</StiLegendDirectionLeftToRight>
    <StiLegendDirectionRightToLeft>Справа наліво</StiLegendDirectionRightToLeft>
    <StiLegendDirectionTopToBottom>Згори вниз</StiLegendDirectionTopToBottom>
    <StiLegendHorAlignmentCenter>По центру</StiLegendHorAlignmentCenter>
    <StiLegendHorAlignmentLeft>Ліворуч</StiLegendHorAlignmentLeft>
    <StiLegendHorAlignmentLeftOutside>Ліворуч за межами</StiLegendHorAlignmentLeftOutside>
    <StiLegendHorAlignmentRight>Праворуч</StiLegendHorAlignmentRight>
    <StiLegendHorAlignmentRightOutside>Праворуч за межами</StiLegendHorAlignmentRightOutside>
    <StiLegendVertAlignmentBottom>Знизу</StiLegendVertAlignmentBottom>
    <StiLegendVertAlignmentBottomOutside>Знизу за межами</StiLegendVertAlignmentBottomOutside>
    <StiLegendVertAlignmentCenter>По центру</StiLegendVertAlignmentCenter>
    <StiLegendVertAlignmentTop>Зверху</StiLegendVertAlignmentTop>
    <StiLegendVertAlignmentTopOutside>Зверху за межами</StiLegendVertAlignmentTopOutside>
    <StiMarkerAlignmentLeft>Ліворуч</StiMarkerAlignmentLeft>
    <StiMarkerAlignmentRight>Праворуч</StiMarkerAlignmentRight>
    <StiMarkerTypeCircle>Коло</StiMarkerTypeCircle>
    <StiMarkerTypeHexagon>Шестикутник</StiMarkerTypeHexagon>
    <StiMarkerTypeRectangle>Прямокутник</StiMarkerTypeRectangle>
    <StiMarkerTypeStar5>Зірка з 5 променями</StiMarkerTypeStar5>
    <StiMarkerTypeStar6>Зірка з 6 променями</StiMarkerTypeStar6>
    <StiMarkerTypeStar7>Зірка з 7 променями</StiMarkerTypeStar7>
    <StiMarkerTypeStar8>Зірка з 8 променями</StiMarkerTypeStar8>
    <StiMarkerTypeTriangle>Трикутник</StiMarkerTypeTriangle>
    <StiNestedFactorHigh>Високий</StiNestedFactorHigh>
    <StiNestedFactorLow>Низький</StiNestedFactorLow>
    <StiNestedFactorNormal>Нормальний</StiNestedFactorNormal>
    <StiNumberOfPassDoublePass>Подвійний прохід</StiNumberOfPassDoublePass>
    <StiNumberOfPassSinglePass>Одинарний прохід</StiNumberOfPassSinglePass>
    <StiOrientationHorizontal>Горизонтальна</StiOrientationHorizontal>
    <StiOrientationHorizontalRight>Горизонтальний (праворуч)</StiOrientationHorizontalRight>
    <StiOrientationVertical>Вертикальна</StiOrientationVertical>
    <StiPageOrientationLandscape>Альбом</StiPageOrientationLandscape>
    <StiPageOrientationPortrait>Портрет</StiPageOrientationPortrait>
    <StiPenStyleDash>Штрихована</StiPenStyleDash>
    <StiPenStyleDashDot>Штрихпунктирна</StiPenStyleDashDot>
    <StiPenStyleDashDotDot>Штрихпунктирна з двома крапками</StiPenStyleDashDotDot>
    <StiPenStyleDot>Пунктирна</StiPenStyleDot>
    <StiPenStyleDouble>Подвійна</StiPenStyleDouble>
    <StiPenStyleNone>Немає</StiPenStyleNone>
    <StiPenStyleSolid>Суцільна</StiPenStyleSolid>
    <StiPlesseyCheckSumModulo10>Modulo10</StiPlesseyCheckSumModulo10>
    <StiPlesseyCheckSumModulo11>Modulo11</StiPlesseyCheckSumModulo11>
    <StiPlesseyCheckSumNone>Немає</StiPlesseyCheckSumNone>
    <StiPreviewModeDotMatrix>Матричний</StiPreviewModeDotMatrix>
    <StiPreviewModeStandard>Стандартний</StiPreviewModeStandard>
    <StiPreviewModeStandardAndDotMatrix>Стандартний та Матричний</StiPreviewModeStandardAndDotMatrix>
    <StiPrintOnEvenOddPagesTypeIgnore>Ігнорувати</StiPrintOnEvenOddPagesTypeIgnore>
    <StiPrintOnEvenOddPagesTypePrintOnEvenPages>Друкувати на парних сторінках</StiPrintOnEvenOddPagesTypePrintOnEvenPages>
    <StiPrintOnEvenOddPagesTypePrintOnOddPages>Друкувати на непарних сторінках</StiPrintOnEvenOddPagesTypePrintOnOddPages>
    <StiPrintOnTypeAllPages>Всі сторінки</StiPrintOnTypeAllPages>
    <StiPrintOnTypeExceptFirstAndLastPage>Крім першої й останньої сторінки</StiPrintOnTypeExceptFirstAndLastPage>
    <StiPrintOnTypeExceptFirstPage>Крім першої сторінки</StiPrintOnTypeExceptFirstPage>
    <StiPrintOnTypeExceptLastPage>Крім останньої сторінки</StiPrintOnTypeExceptLastPage>
    <StiPrintOnTypeOnlyFirstAndLastPage>Тільки перша й остання сторінка</StiPrintOnTypeOnlyFirstAndLastPage>
    <StiPrintOnTypeOnlyFirstPage>Тільки перша сторінка</StiPrintOnTypeOnlyFirstPage>
    <StiPrintOnTypeOnlyLastPage>Тільки остання сторінка</StiPrintOnTypeOnlyLastPage>
    <StiProcessAtEndOfPage>В кінці сторінки</StiProcessAtEndOfPage>
    <StiProcessAtEndOfReport>В кінці звіту</StiProcessAtEndOfReport>
    <StiProcessAtNone>Ні</StiProcessAtNone>
    <StiProcessingDuplicatesTypeBasedOnTagHide>Приховати базуючись на властивості Тег</StiProcessingDuplicatesTypeBasedOnTagHide>
    <StiProcessingDuplicatesTypeBasedOnTagMerge>Об'єднати базуючись на властивості Тег</StiProcessingDuplicatesTypeBasedOnTagMerge>
    <StiProcessingDuplicatesTypeBasedOnTagRemoveText>Видалити текст базуючись на властивості Тег</StiProcessingDuplicatesTypeBasedOnTagRemoveText>
    <StiProcessingDuplicatesTypeBasedOnValueAndTagHide>Приховати базуючись на Значенні та властивості Тег</StiProcessingDuplicatesTypeBasedOnValueAndTagHide>
    <StiProcessingDuplicatesTypeBasedOnValueAndTagMerge>Об'єднати базуючись на Значенні та властивості Тег</StiProcessingDuplicatesTypeBasedOnValueAndTagMerge>
    <StiProcessingDuplicatesTypeBasedOnValueRemoveText>Видалити текст базуючись на Значенні</StiProcessingDuplicatesTypeBasedOnValueRemoveText>
    <StiProcessingDuplicatesTypeGlobalBasedOnValueAndTagHide>Сховати глобально в залежності від Значення і властивості Тег</StiProcessingDuplicatesTypeGlobalBasedOnValueAndTagHide>
    <StiProcessingDuplicatesTypeGlobalBasedOnValueAndTagMerge>Об'єднати глобально в залежності від Значення і властивості Тег</StiProcessingDuplicatesTypeGlobalBasedOnValueAndTagMerge>
    <StiProcessingDuplicatesTypeGlobalBasedOnValueRemoveText>Видалити глобально в залежності від Значення</StiProcessingDuplicatesTypeGlobalBasedOnValueRemoveText>
    <StiProcessingDuplicatesTypeGlobalHide>Приховати глобально</StiProcessingDuplicatesTypeGlobalHide>
    <StiProcessingDuplicatesTypeGlobalMerge>З'єднати глобально</StiProcessingDuplicatesTypeGlobalMerge>
    <StiProcessingDuplicatesTypeGlobalRemoveText>Видалити текст глобально</StiProcessingDuplicatesTypeGlobalRemoveText>
    <StiProcessingDuplicatesTypeHide>Сховати</StiProcessingDuplicatesTypeHide>
    <StiProcessingDuplicatesTypeMerge>З'єднати</StiProcessingDuplicatesTypeMerge>
    <StiProcessingDuplicatesTypeNone>Немає</StiProcessingDuplicatesTypeNone>
    <StiProcessingDuplicatesTypeRemoveText>Забрати текст</StiProcessingDuplicatesTypeRemoveText>
    <StiRadarStyleXFCircle>Коло</StiRadarStyleXFCircle>
    <StiRadarStyleXFPolygon>Багатокутник</StiRadarStyleXFPolygon>
    <StiReportCacheModeAuto>Авто</StiReportCacheModeAuto>
    <StiReportCacheModeOff>Вимкнено</StiReportCacheModeOff>
    <StiReportCacheModeOn>Увімкнено</StiReportCacheModeOn>
    <StiReportUnitTypeCentimeters>Сантиметри</StiReportUnitTypeCentimeters>
    <StiReportUnitTypeHundredthsOfInch>Соті дюйма</StiReportUnitTypeHundredthsOfInch>
    <StiReportUnitTypeInches>Дюйми</StiReportUnitTypeInches>
    <StiReportUnitTypeMillimeters>Міліметри</StiReportUnitTypeMillimeters>
    <StiReportUnitTypePixels>Пікселі</StiReportUnitTypePixels>
    <StiRestrictionsAll>Всі</StiRestrictionsAll>
    <StiRestrictionsAllowChange>Дозволяти зміни</StiRestrictionsAllowChange>
    <StiRestrictionsAllowDelete>Дозволяти видалення</StiRestrictionsAllowDelete>
    <StiRestrictionsAllowMove>Дозволяти переміщення</StiRestrictionsAllowMove>
    <StiRestrictionsAllowResize>Дозволяти зміну розміру</StiRestrictionsAllowResize>
    <StiRestrictionsAllowSelect>Дозволяти вибір</StiRestrictionsAllowSelect>
    <StiRestrictionsNone>Немає</StiRestrictionsNone>
    <StiSeriesLabelsValueTypeArgument>Аргумент</StiSeriesLabelsValueTypeArgument>
    <StiSeriesLabelsValueTypeArgumentValue>Аргумент - Значення</StiSeriesLabelsValueTypeArgumentValue>
    <StiSeriesLabelsValueTypeSeriesTitle>Назва ряду</StiSeriesLabelsValueTypeSeriesTitle>
    <StiSeriesLabelsValueTypeSeriesTitleArgument>Назва ряду - Аргумент</StiSeriesLabelsValueTypeSeriesTitleArgument>
    <StiSeriesLabelsValueTypeSeriesTitleValue>Назва ряду - Значення</StiSeriesLabelsValueTypeSeriesTitleValue>
    <StiSeriesLabelsValueTypeTag>Тег</StiSeriesLabelsValueTypeTag>
    <StiSeriesLabelsValueTypeValue>Значення</StiSeriesLabelsValueTypeValue>
    <StiSeriesLabelsValueTypeValueArgument>Значення - Аргумент</StiSeriesLabelsValueTypeValueArgument>
    <StiSeriesLabelsValueTypeWeight>Вага</StiSeriesLabelsValueTypeWeight>
    <StiSeriesSortDirectionAscending>За зростанням</StiSeriesSortDirectionAscending>
    <StiSeriesSortDirectionDescending>За спаданням</StiSeriesSortDirectionDescending>
    <StiSeriesSortTypeArgument>Аргумент</StiSeriesSortTypeArgument>
    <StiSeriesSortTypeNone>Немає</StiSeriesSortTypeNone>
    <StiSeriesSortTypeValue>Значення</StiSeriesSortTypeValue>
    <StiSeriesYAxisLeftYAxis>Ліва Y Вісь</StiSeriesYAxisLeftYAxis>
    <StiSeriesYAxisRightYAxis>Права Y Вісь</StiSeriesYAxisRightYAxis>
    <StiShapeDirectionDown>Вниз</StiShapeDirectionDown>
    <StiShapeDirectionLeft>Вліво</StiShapeDirectionLeft>
    <StiShapeDirectionRight>Вправо</StiShapeDirectionRight>
    <StiShapeDirectionUp>Нагору</StiShapeDirectionUp>
    <StiShiftModeDecreasingSize>При зменшенні розміру</StiShiftModeDecreasingSize>
    <StiShiftModeIncreasingSize>При збільшенні розміру</StiShiftModeIncreasingSize>
    <StiShiftModeNone>Немає</StiShiftModeNone>
    <StiShiftModeOnlyInWidthOfComponent>Тільки в межах ширини компонента</StiShiftModeOnlyInWidthOfComponent>
    <StiShowSeriesLabelsFromChart>З діаграми</StiShowSeriesLabelsFromChart>
    <StiShowSeriesLabelsFromSeries>З ряду</StiShowSeriesLabelsFromSeries>
    <StiShowSeriesLabelsNone>Немає</StiShowSeriesLabelsNone>
    <StiShowXAxisBoth>Обидві</StiShowXAxisBoth>
    <StiShowXAxisBottom>Нижня</StiShowXAxisBottom>
    <StiShowXAxisCenter>По центру</StiShowXAxisCenter>
    <StiShowYAxisBoth>Обидві</StiShowYAxisBoth>
    <StiShowYAxisCenter>По центру</StiShowYAxisCenter>
    <StiShowYAxisLeft>Ліва</StiShowYAxisLeft>
    <StiSortDirectionAsc>За зростанням</StiSortDirectionAsc>
    <StiSortDirectionDesc>За спаданням</StiSortDirectionDesc>
    <StiSortDirectionNone>Не сортувати</StiSortDirectionNone>
    <StiSortTypeByDisplayValue>за відображуваним значенням</StiSortTypeByDisplayValue>
    <StiSortTypeByValue>за значенням</StiSortTypeByValue>
    <StiSqlSourceTypeStoredProcedure>Збережена процедура</StiSqlSourceTypeStoredProcedure>
    <StiSqlSourceTypeTable>Таблиця</StiSqlSourceTypeTable>
    <StiStyleComponentTypeAny>Будь-який</StiStyleComponentTypeAny>
    <StiStyleComponentTypeChart>Діаграма</StiStyleComponentTypeChart>
    <StiStyleComponentTypeCheckBox>Прапорець</StiStyleComponentTypeCheckBox>
    <StiStyleComponentTypeCrossTab>Крос-таблиця</StiStyleComponentTypeCrossTab>
    <StiStyleComponentTypeImage>Зображення</StiStyleComponentTypeImage>
    <StiStyleComponentTypePrimitive>Примітив</StiStyleComponentTypePrimitive>
    <StiStyleComponentTypeText>Текст</StiStyleComponentTypeText>
    <StiStyleConditionTypeComponentName>Назва компонента</StiStyleConditionTypeComponentName>
    <StiStyleConditionTypeComponentType>Тип компонента</StiStyleConditionTypeComponentType>
    <StiStyleConditionTypeLocation>Розташування</StiStyleConditionTypeLocation>
    <StiStyleConditionTypePlacement>Розміщення</StiStyleConditionTypePlacement>
    <StiStyleTypeAuto>Автоматично</StiStyleTypeAuto>
    <StiStyleTypeManual>Вручну</StiStyleTypeManual>
    <StiSummaryValuesAllValues>Додати Значення</StiSummaryValuesAllValues>
    <StiSummaryValuesSkipNulls>Пропустити нули(null)</StiSummaryValuesSkipNulls>
    <StiSummaryValuesSkipZerosAndNulls>Пропустити нулі та нули(null)</StiSummaryValuesSkipZerosAndNulls>
    <StiTablceCellTypeCheckBox>Прапорець</StiTablceCellTypeCheckBox>
    <StiTablceCellTypeImage>Картинка</StiTablceCellTypeImage>
    <StiTablceCellTypeRichText>Rich текст</StiTablceCellTypeRichText>
    <StiTablceCellTypeText>Текст</StiTablceCellTypeText>
    <StiTableAutoWidthNone>Ні</StiTableAutoWidthNone>
    <StiTableAutoWidthPage>Сторінка</StiTableAutoWidthPage>
    <StiTableAutoWidthTable>Таблиця</StiTableAutoWidthTable>
    <StiTableAutoWidthTypeFullTable>Повна таблиця</StiTableAutoWidthTypeFullTable>
    <StiTableAutoWidthTypeLastColumns>Останній стовпчик</StiTableAutoWidthTypeLastColumns>
    <StiTableAutoWidthTypeNone>Ні</StiTableAutoWidthTypeNone>
    <StiTextHorAlignmentCenter>По центру</StiTextHorAlignmentCenter>
    <StiTextHorAlignmentLeft>По лівому краю</StiTextHorAlignmentLeft>
    <StiTextHorAlignmentRight>По правому краю</StiTextHorAlignmentRight>
    <StiTextHorAlignmentWidth>По ширині</StiTextHorAlignmentWidth>
    <StiTextPositionCenterBottom>Центровано внизу</StiTextPositionCenterBottom>
    <StiTextPositionCenterTop>Центровано зверху</StiTextPositionCenterTop>
    <StiTextPositionLeftBottom>Зліва внизу</StiTextPositionLeftBottom>
    <StiTextPositionLeftTop>Зліва зверху</StiTextPositionLeftTop>
    <StiTextPositionRightBottom>Справа внизу</StiTextPositionRightBottom>
    <StiTextPositionRightTop>Справа зверху</StiTextPositionRightTop>
    <StiTextQualityStandard>Стандартна</StiTextQualityStandard>
    <StiTextQualityTypographic>Типографічна</StiTextQualityTypographic>
    <StiTextQualityWysiwyg>Wysiwyg - Що бачиш, те маєш</StiTextQualityWysiwyg>
    <StiTitlePositionInside>Всередині</StiTitlePositionInside>
    <StiTitlePositionOutside>Зовні</StiTitlePositionOutside>
    <StiTypeModeList>Список</StiTypeModeList>
    <StiTypeModeNullableValue>Значення з null</StiTypeModeNullableValue>
    <StiTypeModeRange>Діапазон</StiTypeModeRange>
    <StiTypeModeValue>Значення</StiTypeModeValue>
    <StiVertAlignmentBottom>По нижньому краю</StiVertAlignmentBottom>
    <StiVertAlignmentCenter>По центру</StiVertAlignmentCenter>
    <StiVertAlignmentTop>По верхньому краю</StiVertAlignmentTop>
    <StiViewModeNormal>Звичайний</StiViewModeNormal>
    <StiViewModePageBreakPreview>Розмітка сторінки</StiViewModePageBreakPreview>
    <StringAlignmentCenter>По центру</StringAlignmentCenter>
    <StringAlignmentFar>Удалині</StringAlignmentFar>
    <StringAlignmentNear>Поблизу</StringAlignmentNear>
    <StringTrimmingCharacter>Символ</StringTrimmingCharacter>
    <StringTrimmingEllipsisCharacter>Символ Еліпсис</StringTrimmingEllipsisCharacter>
    <StringTrimmingEllipsisPath>Шлях Еліпсис</StringTrimmingEllipsisPath>
    <StringTrimmingEllipsisWord>Слово Еліпсис</StringTrimmingEllipsisWord>
    <StringTrimmingNone>Не підганяти</StringTrimmingNone>
    <StringTrimmingWord>Слово</StringTrimmingWord>
  </PropertyEnum>
  <PropertyEvents>
    <AfterPrintEvent>Після друку</AfterPrintEvent>
    <AfterSelectEvent>Після вибору</AfterSelectEvent>
    <BeforePrintEvent>Перед друком</BeforePrintEvent>
    <BeginRenderEvent>Початок побудови</BeginRenderEvent>
    <CheckedChangedEvent>Зміна відмітки</CheckedChangedEvent>
    <ClickEvent>Натискання</ClickEvent>
    <ClosedFormEvent>Після закриття</ClosedFormEvent>
    <ClosingFormEvent>Перед закриттям</ClosingFormEvent>
    <ColumnBeginRenderEvent>Початок побудови стовпчика</ColumnBeginRenderEvent>
    <ColumnEndRenderEvent>Кінець побудови стовпчика</ColumnEndRenderEvent>
    <ConnectedEvent>Після з'єднання</ConnectedEvent>
    <ConnectingEvent>Перед з'єднанням</ConnectingEvent>
    <Disconnected>Після від'єднання</Disconnected>
    <DisconnectedEvent>Після роз'єднання</DisconnectedEvent>
    <Disconnecting>Перед від'єднанням</Disconnecting>
    <DisconnectingEvent>Перед роз'єднанням</DisconnectingEvent>
    <DoubleClickEvent>Подвійне натискання</DoubleClickEvent>
    <EndRenderEvent>Кінець побудови</EndRenderEvent>
    <EnterEvent>Одержання вибору</EnterEvent>
    <ExportedEvent>Експортовано</ExportedEvent>
    <ExportingEvent>Експортування</ExportingEvent>
    <GetArgumentEvent>Отримати аргумент</GetArgumentEvent>
    <GetBookmarkEvent>Отримати закладку</GetBookmarkEvent>
    <GetCollapsedEvent>Отримати згортання</GetCollapsedEvent>
    <GetCrossValueEvent>Отримати крос-значення</GetCrossValueEvent>
    <GetCutPieListEvent>Отримати список висунутих сегментів</GetCutPieListEvent>
    <GetCuttedPieListEvent>Взяти список висунитих сегментів</GetCuttedPieListEvent>
    <GetDataUrlEvent>Взяти гіперпосилання на дані</GetDataUrlEvent>
    <GetDisplayCrossValueEvent>Отримати відображуване крос-значення</GetDisplayCrossValueEvent>
    <GetDrillDownReportEvent>Отримати звіт деталізації</GetDrillDownReportEvent>
    <GetExcelSheetEvent>Отримати сторінку Excel</GetExcelSheetEvent>
    <GetExcelValueEvent>Отримати Excel значення</GetExcelValueEvent>
    <GetHyperlinkEvent>Отримати гіперпосилання</GetHyperlinkEvent>
    <GetImageDataEvent>Отримати зображення</GetImageDataEvent>
    <GetImageURLEvent>Отримати гіперпосилання на зображення</GetImageURLEvent>
    <GetListOfArgumentsEvent>Отримати список аргументів</GetListOfArgumentsEvent>
    <GetListOfHyperlinksEvent>Отримати список гіперпосилань</GetListOfHyperlinksEvent>
    <GetListOfTagsEvent>Отримати список тегів</GetListOfTagsEvent>
    <GetListOfToolTipsEvent>Отримати список підказок</GetListOfToolTipsEvent>
    <GetListOfValuesEndEvent>Отримати список кінцевих значень</GetListOfValuesEndEvent>
    <GetListOfValuesEvent>Отримати список значень</GetListOfValuesEvent>
    <GetListOfWeights>Отримати список вагових значень</GetListOfWeights>
    <GetListOfWeightsEvent>Отримати список вагових значень</GetListOfWeightsEvent>
    <GetSummaryExpressionEvent>Отримати вираз підсумку</GetSummaryExpressionEvent>
    <GetTagEvent>Отримати тег</GetTagEvent>
    <GetTitleEvent>Отримати заголовок</GetTitleEvent>
    <GetToolTipEvent>Отримати підказку</GetToolTipEvent>
    <GetValueEndEvent>Отримати кінцеве значення</GetValueEndEvent>
    <GetValueEvent>Отримати значення</GetValueEvent>
    <GetWeightEvent>Отримати вагу</GetWeightEvent>
    <LeaveEvent>Перехід вибору</LeaveEvent>
    <LoadFormEvent>При відкритті</LoadFormEvent>
    <MouseDownEvent>Натискання миші вниз</MouseDownEvent>
    <MouseEnterEvent>Миша всередині</MouseEnterEvent>
    <MouseLeaveEvent>Миша назовні</MouseLeaveEvent>
    <MouseMoveEvent>Переміщення миші</MouseMoveEvent>
    <MouseUpEvent>Натискання миші нагору</MouseUpEvent>
    <NewAutoSeriesEvent>Новий авторяд</NewAutoSeriesEvent>
    <PositionChangedEvent>Зміна позиції</PositionChangedEvent>
    <PrintedEvent>Надруковано</PrintedEvent>
    <PrintingEvent>Друк</PrintingEvent>
    <ProcessCellEvent>Обробка клітинки</ProcessCellEvent>
    <ProcessChartEvent>Обробка Діаграми</ProcessChartEvent>
    <RenderingEvent>Побудова</RenderingEvent>
    <SelectedIndexChangedEvent>Зміна індексу</SelectedIndexChangedEvent>
    <StateRestoreEvent>Відновлення стану</StateRestoreEvent>
    <StateSaveEvent>Збереження стану</StateSaveEvent>
    <ValueChangedEvent>Зміна значення</ValueChangedEvent>
  </PropertyEvents>
  <PropertyHatchStyle>
    <BackwardDiagonal>Задня діагональ</BackwardDiagonal>
    <Cross>Перетинання</Cross>
    <DarkDownwardDiagonal>Темна нижня горизонталь</DarkDownwardDiagonal>
    <DarkHorizontal>Темна горизонталь</DarkHorizontal>
    <DarkUpwardDiagonal>Темна верхня горизонталь</DarkUpwardDiagonal>
    <DarkVertical>Темна вертикаль</DarkVertical>
    <DashedDownwardDiagonal>Пунктирна нижня діагональ</DashedDownwardDiagonal>
    <DashedHorizontal>Пунктирна горизонталь</DashedHorizontal>
    <DashedUpwardDiagonal>Пунктирна верхня діагональ</DashedUpwardDiagonal>
    <DashedVertical>Пунктирна вертикаль</DashedVertical>
    <DiagonalBrick>Діагональна цегла</DiagonalBrick>
    <DiagonalCross>Діагональне перетинання</DiagonalCross>
    <Divot>Дерен</Divot>
    <DottedDiamond>Точковий алмаз</DottedDiamond>
    <DottedGrid>Точкова сітка</DottedGrid>
    <ForwardDiagonal>Передня діагональ</ForwardDiagonal>
    <Horizontal>Горизонталь</Horizontal>
    <HorizontalBrick>Горизонтальна цегла</HorizontalBrick>
    <LargeCheckerBoard>Більша шахматка</LargeCheckerBoard>
    <LargeConfetti>Велике конфетті</LargeConfetti>
    <LargeGrid>Більша сітка</LargeGrid>
    <LightDownwardDiagonal>Світла нижня діагональ</LightDownwardDiagonal>
    <LightHorizontal>Світла горизонталь</LightHorizontal>
    <LightUpwardDiagonal>Світла верхня діагональ</LightUpwardDiagonal>
    <LightVertical>Світла вертикаль</LightVertical>
    <NarrowHorizontal>Вузька горизонталь</NarrowHorizontal>
    <NarrowVertical>Вузька вертикаль</NarrowVertical>
    <OutlinedDiamond>Обкреслений алмаз</OutlinedDiamond>
    <Percent05>Відсотки 05</Percent05>
    <Percent10>Відсотки 10</Percent10>
    <Percent20>Відсотки 20</Percent20>
    <Percent25>Відсотки 25</Percent25>
    <Percent30>Відсотки 30</Percent30>
    <Percent40>Відсотки 40</Percent40>
    <Percent50>Відсотки 50</Percent50>
    <Percent60>Відсотки 60</Percent60>
    <Percent70>Відсотки 70</Percent70>
    <Percent75>Відсотки 75</Percent75>
    <Percent80>Відсотки 80</Percent80>
    <Percent90>Відсотки 90</Percent90>
    <Plaid>Шотландка</Plaid>
    <Shingle>Дранка</Shingle>
    <SmallCheckerBoard>Маленька шахматка</SmallCheckerBoard>
    <SmallConfetti>Маленьке конфетті</SmallConfetti>
    <SmallGrid>Маленька сітка</SmallGrid>
    <SolidDiamond>Заповнений алмаз</SolidDiamond>
    <Sphere>Сфера</Sphere>
    <Trellis>Трельяж</Trellis>
    <Vertical>Вертикаль</Vertical>
    <Weave>Переплетіння</Weave>
    <WideDownwardDiagonal>Широка нижня діагональ</WideDownwardDiagonal>
    <WideUpwardDiagonal>Широка верхня діагональ</WideUpwardDiagonal>
    <ZigZag>Зигзаг</ZigZag>
  </PropertyHatchStyle>
  <PropertyMain>
    <AcceptsReturn>Приймати Returns</AcceptsReturn>
    <AcceptsTab>Приймати Tabs</AcceptsTab>
    <AddClearZone>Добавляти поля</AddClearZone>
    <Advanced>Розширенний</Advanced>
    <AggregateFunction>Агрегатна функція</AggregateFunction>
    <AggregateFunctions>Агрегатні функції</AggregateFunctions>
    <Alias>Псевдонім</Alias>
    <Alignment>Вирівнювання</Alignment>
    <AllowApplyBorderColor>Дозволити використовувати колір границі</AllowApplyBorderColor>
    <AllowApplyBrush>Дозволити використовувати заповнення</AllowApplyBrush>
    <AllowApplyBrushNegative>Дозволити пензлик негативних значень</AllowApplyBrushNegative>
    <AllowApplyColorNegative>Дозволити колір негативний значень</AllowApplyColorNegative>
    <AllowApplyStyle>Дозволити використовувати стилі</AllowApplyStyle>
    <AllowExpressions>Дозволити вирази</AllowExpressions>
    <AllowHtmlTags>Дозволити Html теги</AllowHtmlTags>
    <AllowSeries>Дозволити ряди</AllowSeries>
    <AllowSeriesElements>Дозволити елементи рядів</AllowSeriesElements>
    <AllowSorting>Сортування</AllowSorting>
    <AllowUseBackColor>Дозволити колір заднього фону</AllowUseBackColor>
    <AllowUseBorder>Дозволити використовувати границі</AllowUseBorder>
    <AllowUseBorderFormatting>Дозволити форматування границь</AllowUseBorderFormatting>
    <AllowUseBorderSides>Дозволити рамки границь</AllowUseBorderSides>
    <AllowUseBorderSidesFromLocation>Дозволити використовувати рамки границі в залежності від розташування</AllowUseBorderSidesFromLocation>
    <AllowUseBrush>Дозволити використовувати пензлик</AllowUseBrush>
    <AllowUseFont>Дозволити використовувати шрифт</AllowUseFont>
    <AllowUseForeColor>Дозволити колір переднього фону</AllowUseForeColor>
    <AllowUseHorAlignment>Дозволити використовувати горизонтальне вирівнювання</AllowUseHorAlignment>
    <AllowUseImage>Дозволити використовувати зображення</AllowUseImage>
    <AllowUserValues>Дозволити значення користувача</AllowUserValues>
    <AllowUseTextBrush>Дозволити використовувати колір тексту</AllowUseTextBrush>
    <AllowUseTextOptions>Дозволити використовувати параметри тексту</AllowUseTextOptions>
    <AllowUseVertAlignment>Дозволити використовувати вертикальне вирівнювання</AllowUseVertAlignment>
    <AlternatingBackColor>Альтернативний колір фону</AlternatingBackColor>
    <Angle>Кут</Angle>
    <Antialiasing>Згладжування</Antialiasing>
    <Area>Область</Area>
    <Argument>Аргумент</Argument>
    <ArgumentDataColumn>Стовпчик даних аргументів</ArgumentDataColumn>
    <ArrowHeight>Висота пера</ArrowHeight>
    <ArrowStyle>Стиль стрілки</ArrowStyle>
    <ArrowWidth>Ширина пера</ArrowWidth>
    <AspectRatio>Відношення координат</AspectRatio>
    <Author>Автор</Author>
    <Auto>Авто</Auto>
    <AutoDataColumns>Автоматичні стовпчики даних</AutoDataColumns>
    <AutoDataRows>Автоматичні рядки даних</AutoDataRows>
    <AutoLocalizeReportOnRun>Автоматична локалізація звіту при завантаженні</AutoLocalizeReportOnRun>
    <AutoRefresh>Автооновлення</AutoRefresh>
    <AutoRotate>Автоповорот</AutoRotate>
    <AutoScale>Автомасштабування</AutoScale>
    <AutoSeriesColorDataColumn>Авторяд Стовпчик Колір</AutoSeriesColorDataColumn>
    <AutoSeriesKeyDataColumn>Авторяд Стовпчик Ключ</AutoSeriesKeyDataColumn>
    <AutoSeriesTitleDataColumn>Авторяд Стовпчик Найменування</AutoSeriesTitleDataColumn>
    <AutoWidth>Автоширина</AutoWidth>
    <AutoWidthType>Тип автоширини</AutoWidthType>
    <AxisValue>Значення вісі</AxisValue>
    <BackColor>Колір фону</BackColor>
    <Background>Фон</Background>
    <BackgroundColor>Колір заднього фону</BackgroundColor>
    <BarCodeType>Тип штрих-коду</BarCodeType>
    <BasicStyleColor>Основний колір стилю</BasicStyleColor>
    <BindingColumn>Колонка прив'язки</BindingColumn>
    <Blend>Змішування</Blend>
    <Bold>Жирний</Bold>
    <Bookmark>Закладка</Bookmark>
    <Border>Границя</Border>
    <BorderColor>Кольори границі</BorderColor>
    <Borders>Границі</Borders>
    <BorderStyle>Стиль границі</BorderStyle>
    <Bottom>Знизу</Bottom>
    <BottomSide>Нижня сторона</BottomSide>
    <BreakIfLessThan>Переривати, якщо менше ніж </BreakIfLessThan>
    <Brush>Пензлик</Brush>
    <BrushNegative>Пензлик негативних значень</BrushNegative>
    <BrushType>Тип пензлика</BrushType>
    <BusinessObject>Бізнес-об'єкт</BusinessObject>
    <CacheAllData>Кешувати всі дані</CacheAllData>
    <CalcInvisible>Обчислювати невидимі</CalcInvisible>
    <CalculatedDataColumn>Розрахунковий стовпчик</CalculatedDataColumn>
    <CalculationMode>Режим обчислень</CalculationMode>
    <CanBreak>Може розриватися</CanBreak>
    <Cancel>Відмінити</Cancel>
    <CanGrow>Може рости</CanGrow>
    <CanShrink>Може стискатися</CanShrink>
    <Categories>Категорії</Categories>
    <Category>Категорія</Category>
    <CategoryConnections>З'єднання</CategoryConnections>
    <CellDockStyle>Стиль стикування</CellDockStyle>
    <CellHeight>Висота клітинки</CellHeight>
    <CellType>Тип клітинки</CellType>
    <CellWidth>Ширина клітинки</CellWidth>
    <ChartType>Тип діаграми</ChartType>
    <Checked>Включено</Checked>
    <CheckOnClick>Включати при натисканні</CheckOnClick>
    <CheckStyle>Стиль прапорця</CheckStyle>
    <CheckStyleForFalse>Стиль значка для False</CheckStyleForFalse>
    <CheckStyleForTrue>Стиль значка для True</CheckStyleForTrue>
    <Checksum>Контрольна сума</Checksum>
    <CheckSum>Контрольна сума</CheckSum>
    <CheckSum1>Контрольна сума1</CheckSum1>
    <CheckSum2>Контрольна сума2</CheckSum2>
    <Child>Дочірній</Child>
    <ChildColumns>Стовпчики підлеглого</ChildColumns>
    <ChildSource>Підлегле джерело даних</ChildSource>
    <ClearFormat>Очищати формат</ClearFormat>
    <CloneContainer>Клонувати контейнер</CloneContainer>
    <Code>Код</Code>
    <CodePage>Кодова сторінка</CodePage>
    <Collapsed>Згорнутий</Collapsed>
    <CollapseGroupFooter>Згортати Підсумок Групи</CollapseGroupFooter>
    <CollapsingEnabled>Згортання увімкнено</CollapsingEnabled>
    <Collate>Сортування сторінок</Collate>
    <CollectionName>Назва колекції</CollectionName>
    <Color>Колір</Color>
    <ColorEach>Колір для кожного</ColorEach>
    <ColorScaleCondition>Кольорова шкала</ColorScaleCondition>
    <ColorScaleType>Тип кольорової шкали</ColorScaleType>
    <Column>Стовпчик</Column>
    <ColumnCount>Кількість колонок</ColumnCount>
    <ColumnDirection>Напрямок стовпчиків</ColumnDirection>
    <ColumnGaps>Відстань між стовпчиками</ColumnGaps>
    <ColumnHeadersVisible>Видимість заголовків</ColumnHeadersVisible>
    <Columns>Стовпчики</Columns>
    <ColumnWidth>Ширина стовпчика</ColumnWidth>
    <CommandTimeout>Граничний час виконання команди</CommandTimeout>
    <ComponentStyle>Стиль компонента</ComponentStyle>
    <Condition>Умова</Condition>
    <ConditionOptions>Параметри умови</ConditionOptions>
    <Conditions>Умови</Conditions>
    <ConnectionString>Рядок з'єднання</ConnectionString>
    <ConnectOnStart>З'єднуватися при запуску</ConnectOnStart>
    <ConstantLines>Константні лінії</ConstantLines>
    <Container>Контейнер</Container>
    <ContinuousText>Безперервний Текст</ContinuousText>
    <ContourColor>Кольори контуру</ContourColor>
    <Converting>Конвертація</Converting>
    <ConvertNulls>Перетворювати Nulls</ConvertNulls>
    <Copies>Копії</Copies>
    <Count>Кількість</Count>
    <CountData>Кількість елементів</CountData>
    <Create>Створення</Create>
    <CreateFieldOnDoubleClick>Створювати поле при подвійному натисканні</CreateFieldOnDoubleClick>
    <CreateLabel>Створити мітку</CreateLabel>
    <Culture>Культура</Culture>
    <CustomFormat>Форматування на вибір</CustomFormat>
    <CutPieList>Список висунутих сегментів</CutPieList>
    <CuttedPieList>Список висунутих сегментів</CuttedPieList>
    <Data>Дані</Data>
    <DataAdapter>Адаптер даних</DataAdapter>
    <DataAdapters>Адаптери даних</DataAdapters>
    <DataBarCondition>Гістограма</DataBarCondition>
    <DataBindings>Зв'язування даних</DataBindings>
    <DataColumn>Стовпчик даних</DataColumn>
    <DataColumns>Стовпчики даних</DataColumns>
    <DataField>Поле даних</DataField>
    <DataRelation>Зв'язок</DataRelation>
    <DataRows>Рядки даних</DataRows>
    <DataSource>Джерело даних</DataSource>
    <DataSources>Джерела даних</DataSources>
    <DataTextField>Поле даних</DataTextField>
    <DataType>Тип даних</DataType>
    <DateInfo>Інформація про дати</DateInfo>
    <DateTimeStep>Крок часу</DateTimeStep>
    <Default>За замовчуванням</Default>
    <DefaultHeightCell>Висота клітинки за замовчуванням</DefaultHeightCell>
    <DefaultNamespace>Простір імен</DefaultNamespace>
    <DependentColumn>Залежний стовпчик</DependentColumn>
    <DependentValue>Залежне значення</DependentValue>
    <Description>Опис</Description>
    <DetectUrls>Автоматично визначати лінки (Url)</DetectUrls>
    <DialogResult>Результат діалогу</DialogResult>
    <Diameter>Діаметр</Diameter>
    <Direction>Напрямок</Direction>
    <DisplayValue>Відображуване значення</DisplayValue>
    <Distance>Дистанція</Distance>
    <DistanceBetweenTabs>Дистанція між</DistanceBetweenTabs>
    <Dock>Стикування</Dock>
    <DockableTable>Стикування таблиці</DockableTable>
    <DockStyle>Стиль стикування</DockStyle>
    <DrawBorder>Малювати границю</DrawBorder>
    <DrawHatch>Штриховка</DrawHatch>
    <DrawLine>Малювати лінію</DrawLine>
    <DrillDown>Деталізація</DrillDown>
    <DrillDownEnabled>Деталізацію увімкнено</DrillDownEnabled>
    <DrillDownMode>Режим деталізації</DrillDownMode>
    <DrillDownPage>Сторінка деталізації</DrillDownPage>
    <DrillDownParameter1>Параметр деталізації 1</DrillDownParameter1>
    <DrillDownParameter2>Параметр деталізації 2</DrillDownParameter2>
    <DrillDownParameter3>Параметр деталізації 3</DrillDownParameter3>
    <DrillDownParameter4>Параметр деталізації 4</DrillDownParameter4>
    <DrillDownParameter5>Параметр деталізації 5</DrillDownParameter5>
    <DrillDownParameters>Параметри</DrillDownParameters>
    <DrillDownReport>Звіт деталізації</DrillDownReport>
    <DropDownAlign>Вирівнювання списку</DropDownAlign>
    <DropDownStyle>Стиль списку</DropDownStyle>
    <DropDownWidth>Ширина списку</DropDownWidth>
    <DropShadow>Показувати тінь</DropShadow>
    <Duplex>Дуплекс</Duplex>
    <Editable>Редагований</Editable>
    <EmptyValue>Порожнє значення</EmptyValue>
    <Enabled>Доступність</Enabled>
    <EnableLog>Включений</EnableLog>
    <EncodingMode>Режим кодувания</EncodingMode>
    <EncodingType>Тип Кодування</EncodingType>
    <EndCap>Тип закінчення</EndCap>
    <EndColor>Кінцевий колір</EndColor>
    <EngineVersion>Версія ядра</EngineVersion>
    <EnumeratorSeparator>Роздільник лічильника</EnumeratorSeparator>
    <EnumeratorType>Тип лічильника</EnumeratorType>
    <ErrorCorrectionLevel>Рівень корекції помилок</ErrorCorrectionLevel>
    <ErrorsCorrectionLevel>Рівень корекції помилок</ErrorsCorrectionLevel>
    <EvenStyle>Стиль парних рядків</EvenStyle>
    <ExcelSheet>Сторінка Excel</ExcelSheet>
    <ExcelValue>Excel значення</ExcelValue>
    <Exponential>Експоненціальна</Exponential>
    <ExportAsImage>Експортувати як зображення</ExportAsImage>
    <Expression>Вираз</Expression>
    <FaqPage>Сторінка Faq</FaqPage>
    <FieldIs>Поле</FieldIs>
    <File>Файл</File>
    <Fill>Заповнення</Fill>
    <Filter>Фільтр</Filter>
    <FilterEngine>Режим фільтрації</FilterEngine>
    <FilterMode>Режим фильтрації</FilterMode>
    <FilterOn>Фільтр включений</FilterOn>
    <Filters>Фільтри</Filters>
    <FirstTabOffset>Позиція першого символу</FirstTabOffset>
    <FixedWidth>Фіксована ширина</FixedWidth>
    <Flat>Плоский</Flat>
    <FlatMode>Плоский режим</FlatMode>
    <Focus>Фокус</Focus>
    <Font>Шрифт</Font>
    <FontBold>Жирний</FontBold>
    <FontItalic>Похилий</FontItalic>
    <FontName>Назва</FontName>
    <FontSize>Розмір</FontSize>
    <FontStrikeout>Закреслений</FontStrikeout>
    <FontSubscript>Нижній текст</FontSubscript>
    <FontSuperscript>Верхній текст</FontSuperscript>
    <FontUnderline>Підкреслений</FontUnderline>
    <FontUnit>Одиниця виміру</FontUnit>
    <FooterCanBreak>Підсумок може розриватися</FooterCanBreak>
    <FooterCanGrow>Підсумок може рости</FooterCanGrow>
    <FooterCanShrink>Підсумок може стискатися</FooterCanShrink>
    <FooterPrintAtBottom>Друкувати підсумок знизу</FooterPrintAtBottom>
    <FooterPrintIfEmpty>Друкувати підсумок якщо немає даних</FooterPrintIfEmpty>
    <FooterPrintOn>Друкувати підсумок на</FooterPrintOn>
    <FooterPrintOnAllPages>Друкувати підсумок на всіх сторінках</FooterPrintOnAllPages>
    <FooterPrintOnEvenOddPages>Друкувати підсумок на парних-непарних сторінках</FooterPrintOnEvenOddPages>
    <FooterRowsCount>Кількість рядків підсумку </FooterRowsCount>
    <Footers>Підсумки</Footers>
    <ForeColor>Колір тексту</ForeColor>
    <Format>Форматування</Format>
    <From>З</From>
    <FullConvertExpression>Повний вираз конвертування</FullConvertExpression>
    <Function>Функція</Function>
    <Functions>Функції</Functions>
    <GlobalizationStrings>Рядки перекладу</GlobalizationStrings>
    <GlobalizedName>Глобалізація</GlobalizedName>
    <GridLineColor>Колір лінії сітки</GridLineColor>
    <GridLinesHor>Горизонтальні лінії сітки</GridLinesHor>
    <GridLinesHorRight>Горизонтальні лінії сітки cправа</GridLinesHorRight>
    <GridLineStyle>Стиль лінії сітки</GridLineStyle>
    <GridLinesVert>Вертикальні лінії сітки</GridLinesVert>
    <GridOutline>Контур таблиці</GridOutline>
    <GrowToHeight>Рости у висоту</GrowToHeight>
    <HeaderBackColor>Колір заголовка</HeaderBackColor>
    <HeaderCanBreak>Заголовок може розриватися</HeaderCanBreak>
    <HeaderCanGrow>Заголовок може рости</HeaderCanGrow>
    <HeaderCanShrink>Заголовок може стискатися</HeaderCanShrink>
    <HeaderFont>Шрифт заголовка</HeaderFont>
    <HeaderForeColor>Колір тексту заголовка</HeaderForeColor>
    <HeaderPrintAtBottom>Друкувати заголовок знизу</HeaderPrintAtBottom>
    <HeaderPrintIfEmpty>Друкувати заголовок якщо немає даних</HeaderPrintIfEmpty>
    <HeaderPrintOn>Друкувати заголовок на</HeaderPrintOn>
    <HeaderPrintOnAllPages>Друкувати заголовок на всіх сторінках</HeaderPrintOnAllPages>
    <HeaderPrintOnEvenOddPages>Друкувати заголовок на парних-непарних сторінках</HeaderPrintOnEvenOddPages>
    <HeaderRowsCount>Кількість рядків заголовку</HeaderRowsCount>
    <Headers>Заголовки</Headers>
    <HeaderText>Текст заголовка</HeaderText>
    <Height>Висота</Height>
    <HideSeriesWithEmptyTitle>Ховати ряди з порожніми заголовками</HideSeriesWithEmptyTitle>
    <HideZeros>Приховувати нульові значення</HideZeros>
    <High>Високе</High>
    <HighlightCondition>Умовне виділення</HighlightCondition>
    <HorAlignment>Горизонтальне вирівнювання</HorAlignment>
    <HorSpacing>Відстань по горизонталі</HorSpacing>
    <HotkeyPrefix>Префікс гарячої клавіші</HotkeyPrefix>
    <HtmlTags>Html теги</HtmlTags>
    <Hyperlink>Гіперпосилання</Hyperlink>
    <HyperlinkDataColumn>Колонка даних гіперпосилань</HyperlinkDataColumn>
    <Icon>Значок</Icon>
    <IconSet>Набір значків</IconSet>
    <IconSetCondition>Набір значків</IconSetCondition>
    <Idents>Ідентифікатори</Idents>
    <Image>Зображення</Image>
    <ImageAlign>Вирівнювання зображення</ImageAlign>
    <ImageAlignment>Вирівнювання зображення</ImageAlignment>
    <ImageData>Вираз зображення</ImageData>
    <ImageHorAlignment>Горизонтальне вирівнювання зображення</ImageHorAlignment>
    <ImageMultipleFactor>Кратний множник зображення</ImageMultipleFactor>
    <ImageRotation>Поворот зображення</ImageRotation>
    <ImageStretch>Розтягування зображення</ImageStretch>
    <ImageTiling>Повтор зображення</ImageTiling>
    <ImageTransparency>Прозорість зображення</ImageTransparency>
    <ImageURL>Гіперпосилання на зображення</ImageURL>
    <ImageVertAlignment>Вертикальне вирівнювання зображення</ImageVertAlignment>
    <ImportRelations>Імпорт зв'язків</ImportRelations>
    <Increment>Збільшення</Increment>
    <Indent>Відступ</Indent>
    <InitBy>Ініціалізувати як</InitBy>
    <Insert>Вставити</Insert>
    <Interaction>Взаємодія</Interaction>
    <InterlacedBrush>Пензлик чергування</InterlacedBrush>
    <InterlacingHor>Горизонтальне чергування</InterlacingHor>
    <InterlacingVert>Вертикальне чергування</InterlacingVert>
    <Interpolation>Інтерполяція</Interpolation>
    <Italic>Похилий</Italic>
    <Item>Елемент</Item>
    <ItemHeight>Висота елемента</ItemHeight>
    <Items>Елементи</Items>
    <KeepChildTogether>Тримати підлеглі разом</KeepChildTogether>
    <KeepCrossTabTogether>Тримати Крос-таблицю разом</KeepCrossTabTogether>
    <KeepDetails>Тримати деталі</KeepDetails>
    <KeepDetailsTogether>Тримати деталі разом</KeepDetailsTogether>
    <KeepFooterTogether>Тримати підвал разом</KeepFooterTogether>
    <KeepGroupFooterTogether>Тримати підсумок групи разом</KeepGroupFooterTogether>
    <KeepGroupHeaderTogether>Тримати заголовок групи разом</KeepGroupHeaderTogether>
    <KeepGroupTogether>Тримати групу разом</KeepGroupTogether>
    <KeepHeaderTogether>Тримати заголовок разом</KeepHeaderTogether>
    <KeepReportSummaryTogether>Тримати підсумок звіту разом</KeepReportSummaryTogether>
    <KeepSubReportTogether>Тримати Вкладений звіт разом</KeepSubReportTogether>
    <Key>Ключ</Key>
    <KeyDataColumn>Ключовий стовпчик даних</KeyDataColumn>
    <Keys>Ключі</Keys>
    <LabelColor>Колір заголовка</LabelColor>
    <Labels>Заголовки</Labels>
    <LabelsColor>Колір заголовків</LabelsColor>
    <LabelsOffset>Зміщення заголовка</LabelsOffset>
    <Language>Мова</Language>
    <LargeHeight>Велика висота</LargeHeight>
    <LargeHeightFactor>Коефіцієнт великої висоти</LargeHeightFactor>
    <Left>Зліва</Left>
    <LeftSide>Ліва сторона</LeftSide>
    <Legend>Легенда</Legend>
    <LegendValueType>Тип значення легенди</LegendValueType>
    <Length>Довжина</Length>
    <LengthUnderLabels>Довжина під підписом</LengthUnderLabels>
    <Lighting>Освітлення</Lighting>
    <Linear>Лінійна</Linear>
    <LineColor>Колір лінії</LineColor>
    <LineColorNegative>Колір лінії негативних значень</LineColorNegative>
    <LineLimit>Обмеження рядка</LineLimit>
    <LineMarker>Маркер лінії</LineMarker>
    <LinesOfUnderline>Лінії підкреслення</LinesOfUnderline>
    <LineStyle>Стиль лінії</LineStyle>
    <LineWidth>Товщина лінії</LineWidth>
    <Linked>Зв'язок</Linked>
    <ListOfArguments>Список аргументів</ListOfArguments>
    <ListOfHyperlinks>Список гіперпосилань</ListOfHyperlinks>
    <ListOfTags>Список тегів</ListOfTags>
    <ListOfToolTips>Список підказок</ListOfToolTips>
    <ListOfValues>Список значень</ListOfValues>
    <ListOfValuesClose>Список значень закриття</ListOfValuesClose>
    <ListOfValuesEnd>Список кінцевих значень</ListOfValuesEnd>
    <ListOfValuesHigh>Список максимумів</ListOfValuesHigh>
    <ListOfValuesLow>Список мінімумів</ListOfValuesLow>
    <ListOfValuesOpen>Список значень відкриття</ListOfValuesOpen>
    <ListOfWeights>Список вагових значень</ListOfWeights>
    <Localizable>Локалізувати</Localizable>
    <Location>Позиція</Location>
    <Locked>Замок</Locked>
    <Logarithmic>Логарифмічна</Logarithmic>
    <LogarithmicScale>Логарифмічна шкала</LogarithmicScale>
    <Low>Низьке</Low>
    <Margins>Поля</Margins>
    <Marker>Маркер</Marker>
    <MarkerAlignment>Вирівнювання маркера</MarkerAlignment>
    <MarkerBorder>Границя маркера</MarkerBorder>
    <MarkerColor>Колір маркера</MarkerColor>
    <MarkerSize>Розмір маркера</MarkerSize>
    <MarkerType>Тип маркера</MarkerType>
    <MarkerVisible>Показувати маркер</MarkerVisible>
    <MasterComponent>Головна компонента</MasterComponent>
    <MasterKeyDataColumn>Стовпчик даних з майстер-ключем</MasterKeyDataColumn>
    <MatrixSize>Розмір Матриці</MatrixSize>
    <MaxDate>Максимальна дата</MaxDate>
    <MaxDropDownItems>Максимальна кількість елементів у списку</MaxDropDownItems>
    <MaxHeight>Макс. висота</MaxHeight>
    <Maximum>Максимальне значення</Maximum>
    <MaxLength>Максимальна довжина</MaxLength>
    <MaxNumberOfLines>Максимальне число рядків</MaxNumberOfLines>
    <MaxSize>Максимальний розмір</MaxSize>
    <MaxValue>Максимальне значення</MaxValue>
    <MaxWidth>Максимальна ширина</MaxWidth>
    <MergeDuplicates>Поєднувати дублікати</MergeDuplicates>
    <MergeHeaders>Об'єднувати заголовки</MergeHeaders>
    <Mid>Середній</Mid>
    <MinDate>Мінімальна дата</MinDate>
    <MinHeight>Мін. висота</MinHeight>
    <Minimum>Мінімальне значення</Minimum>
    <MinimumFontSize>Мінімальний розмір шрифту</MinimumFontSize>
    <MinorColor>Колір проміжних ліній</MinorColor>
    <MinorCount>Кількість проміжних ліній</MinorCount>
    <MinorLength>Довжина проміжних ліній</MinorLength>
    <MinorStyle>Стиль проміжних ліній</MinorStyle>
    <MinorVisible>Показувати проміжні лінії</MinorVisible>
    <MinRowsInColumn>Мінімальна кількість рядків у стовпчику</MinRowsInColumn>
    <MinSize>Мінімальний розмір</MinSize>
    <MinValue>Мінімальне значення</MinValue>
    <MinWidth>Мінімальна ширина</MinWidth>
    <Mode>Режим</Mode>
    <Module>Модуль</Module>
    <Move>Переміщення</Move>
    <Multiline>Багаторядковий</Multiline>
    <MultipleFactor>Кратний множник</MultipleFactor>
    <Name>Назва</Name>
    <NameInSource>Ім'я з джерела</NameInSource>
    <NameParent>Назва головного</NameParent>
    <Namespaces>Простори імен</Namespaces>
    <Negative>Негативний</Negative>
    <NestedLevel>Рівень вкладеності</NestedLevel>
    <NewColumnAfter>Новий стовпчик після</NewColumnAfter>
    <NewColumnBefore>Новий стовпчик перед</NewColumnBefore>
    <NewPageAfter>Нова сторінка після</NewPageAfter>
    <NewPageBefore>Нова сторінка перед</NewPageBefore>
    <NextPage>Наступна сторінка</NextPage>
    <NoIcon>Немає значка</NoIcon>
    <NullText>Нульовий текст</NullText>
    <NumberOfColumns>Кількість стовпчиків</NumberOfColumns>
    <NumberOfCopies>Кількість копій</NumberOfCopies>
    <NumberOfPass>Кількість проходів</NumberOfPass>
    <NumberOfValues>Кількість значень</NumberOfValues>
    <OddStyle>Стиль непарних рядків</OddStyle>
    <OnlyText>Тільки текст</OnlyText>
    <Operation>Операція</Operation>
    <Options>Параметри</Options>
    <Orientation>Орієнтація</Orientation>
    <OthersText>Текст для інших значень</OthersText>
    <PageHeight>Висота</PageHeight>
    <PageNumbers>Номери сторінок</PageNumbers>
    <PageWidth>Ширина</PageWidth>
    <Paper>Папір</Paper>
    <PaperSize>Розмір сторінки</PaperSize>
    <PaperSourceFirstPage>Джерело паперу для першої сторінки</PaperSourceFirstPage>
    <PaperSourceOfFirstPage>Джерело паперу для першої сторінки</PaperSourceOfFirstPage>
    <PaperSourceOfOtherPages>Джерело паперу для інших сторінок</PaperSourceOfOtherPages>
    <PaperSourceOtherPages>Джерело паперу для інших сторінок</PaperSourceOtherPages>
    <Parameter>Параметр</Parameter>
    <Parameters>Параметри</Parameters>
    <ParametersOrientation>Розміщення параметрів</ParametersOrientation>
    <ParentColumns>Стовпчики головного</ParentColumns>
    <ParentSource>Головне джерело даних</ParentSource>
    <ParentValue>Головне значення</ParentValue>
    <PasswordChar>Символ пароля</PasswordChar>
    <Path>Шлях</Path>
    <PathData>Шлях до XML даних</PathData>
    <PathSchema>Шлях до XML схеми</PathSchema>
    <Placement>Розміщення</Placement>
    <PlaceOnToolbox>Розміщувати в інструментарії</PlaceOnToolbox>
    <PointAtCenter>Точка в центрі</PointAtCenter>
    <Position>Позиція</Position>
    <Positive>Позитивний</Positive>
    <PreferredColumnWidth>Найкраща ширина стовпчика</PreferredColumnWidth>
    <PreferredRowHeight>Найкраща висота стовпчика</PreferredRowHeight>
    <PreventIntersection>Уникати перетину</PreventIntersection>
    <PreviewMode>Режим перегляду</PreviewMode>
    <PreviewSettings>Настройка попереднього перегляду</PreviewSettings>
    <Printable>Друкувати</Printable>
    <PrintAtBottom>Друкувати внизу</PrintAtBottom>
    <PrinterName>Назва принтера</PrinterName>
    <PrinterSettings>Настройка принтера</PrinterSettings>
    <PrintHeadersFootersFromPreviousPage>Використати заголовки та підвали з попередньої сторінки</PrintHeadersFootersFromPreviousPage>
    <PrintIfDetailEmpty>Друкувати якщо немає детальних даних</PrintIfDetailEmpty>
    <PrintIfEmpty>Друкувати якщо немає даних</PrintIfEmpty>
    <PrintIfParentDisabled>Друкувати, якщо головний вимкнено</PrintIfParentDisabled>
    <PrintOn>Друкувати на</PrintOn>
    <PrintOnAllPages>Друкувати на всіх сторінках</PrintOnAllPages>
    <PrintOnEvenOddPages>Друкувати на парних-непарних сторінках</PrintOnEvenOddPages>
    <PrintOnPreviousPage>Друкувати на попередній сторінці</PrintOnPreviousPage>
    <PrintTitleOnAllPages>Друкувати заголовок на всіх сторінках</PrintTitleOnAllPages>
    <PrintVerticalBars>Друкувати вертикальні секції</PrintVerticalBars>
    <ProcessAt>Обробити </ProcessAt>
    <ProcessAtEnd>Обробити наприкінці</ProcessAtEnd>
    <ProcessingDuplicates>Обробка дублікатів</ProcessingDuplicates>
    <ProductHomePage>Домашня сторінка</ProductHomePage>
    <RadarStyle>Стиль пелюсток</RadarStyle>
    <Range>Діапазон</Range>
    <RangeFrom>З</RangeFrom>
    <RangeScrollEnabled>Прокрутка діапазону</RangeScrollEnabled>
    <RangeTo>По</RangeTo>
    <Ratio>Співвідношення</Ratio>
    <RatioY>Коефіцієнт Y</RatioY>
    <ReadOnly>Тільки читання</ReadOnly>
    <ReconnectOnEachRow>Обновляти на кожному записі</ReconnectOnEachRow>
    <ReferencedAssemblies>Посилання на збірки</ReferencedAssemblies>
    <Refresh>Обновити</Refresh>
    <Relation>Зв'язок</Relation>
    <RelationName>Назва зв'язку</RelationName>
    <Relations>Зв'язки</Relations>
    <RemoveUnusedDataBeforeStart>Сховати невикористовувані дані перед побудовою</RemoveUnusedDataBeforeStart>
    <RenderTo>Виводити в</RenderTo>
    <ReportAlias>Псевдонім звіту</ReportAlias>
    <ReportAuthor>Автор звіту</ReportAuthor>
    <ReportCacheMode>Режим кешування звіту</ReportCacheMode>
    <ReportDescription>Опис звіту</ReportDescription>
    <ReportName>Назва звіту</ReportName>
    <ReportUnit>Одиниця виміру</ReportUnit>
    <RequestFromUser>Запитати у користувача</RequestFromUser>
    <RequestParameters>Запитувати параметри</RequestParameters>
    <ResetDataSource>Скидання даних</ResetDataSource>
    <ResetPageNumber>Скинути номер сторінок</ResetPageNumber>
    <Resize>Зміна розмірів</Resize>
    <Restrictions>Обмеження</Restrictions>
    <ReturnValue>Значення, що повертається</ReturnValue>
    <ReverseHor>Перевернути по горизонталі</ReverseHor>
    <ReverseVert>Перевернути по вертикалі</ReverseVert>
    <Right>Праворуч</Right>
    <RightSide>Права сторона</RightSide>
    <RightToLeft>Справа наліво</RightToLeft>
    <Rotation>Поворот</Rotation>
    <RotationLabels>Поворот написів</RotationLabels>
    <Round>Округлість</Round>
    <RowCount>Кількість рядків</RowCount>
    <RowHeadersVisible>Видимість заголовків</RowHeadersVisible>
    <RowHeaderWidth>Ширина заголовка рядка</RowHeaderWidth>
    <Scale>Масштаб</Scale>
    <ScaleHor>Масштабування по горизонталі</ScaleHor>
    <ScriptLanguage>Скриптова мова</ScriptLanguage>
    <SegmentPerHeight>Сегментів по висоті</SegmentPerHeight>
    <SegmentPerWidth>Сегментів по ширині</SegmentPerWidth>
    <SelectedIndex>Обраний індекс</SelectedIndex>
    <SelectedItem>Обраний елемент</SelectedItem>
    <SelectedKey>Вибраний ключ</SelectedKey>
    <SelectedValue>Обране значення</SelectedValue>
    <Selection>Вибір</Selection>
    <SelectionBackColor>Колір вибору</SelectionBackColor>
    <SelectionEnabled>Вибір увімкнено</SelectionEnabled>
    <SelectionForeColor>Колір тексту вибору</SelectionForeColor>
    <SelectionMode>Спосіб вибору</SelectionMode>
    <Series>Ряди</Series>
    <SeriesLabels>Заголовки рядів</SeriesLabels>
    <Shadow>Тінь</Shadow>
    <ShadowBrush>Пензлик тіні</ShadowBrush>
    <ShadowColor>Колір тіні</ShadowColor>
    <ShadowSize>Розмір тіні</ShadowSize>
    <ShapeType>Тип геометрії</ShapeType>
    <Shift>Зміщення</Shift>
    <ShiftMode>Режим зміщення</ShiftMode>
    <ShowBehind>Показувати позаду</ShowBehind>
    <ShowDialog>Показувати діалог</ShowDialog>
    <ShowEdgeValues>Показувати крайні значення</ShowEdgeValues>
    <ShowImageBehind>Показувати зображення позаду</ShowImageBehind>
    <ShowInLegend>Показувати в легенді</ShowInLegend>
    <ShowInPercent>Показувати у відсотках</ShowInPercent>
    <ShowLabels>Показувати заголовки</ShowLabels>
    <ShowLabelText>Показувати текст</ShowLabelText>
    <ShowMarker>Показувати маркер</ShowMarker>
    <ShowNulls>Показувати невизначені</ShowNulls>
    <ShowOnZeroValues>Показувати при нульових значеннях</ShowOnZeroValues>
    <ShowOthers>Показувати інші значення</ShowOthers>
    <ShowPercents>Показувати відсотки</ShowPercents>
    <ShowQuietZoneIndicator>Показувати Quiet Zone індикатор</ShowQuietZoneIndicator>
    <ShowQuietZones>Відображати Quiet Zones</ShowQuietZones>
    <ShowScrollBar>Показувати смугу прокручування</ShowScrollBar>
    <ShowSeriesLabels>Показувати заголовки рядів</ShowSeriesLabels>
    <ShowShadow>Показувати тіні</ShowShadow>
    <ShowTotal>Показувати підсумки</ShowTotal>
    <ShowUpDown>Показувати нагору вниз</ShowUpDown>
    <ShowValue>Показувати значення</ShowValue>
    <ShowXAxis>Відображати вісь X</ShowXAxis>
    <ShowYAxis>Показувати вісь Y</ShowYAxis>
    <ShowZeros>Показувати Нулі</ShowZeros>
    <ShrinkFontToFit>Зменшити щоб помістилося</ShrinkFontToFit>
    <ShrinkFontToFitMinimumSize>Зменшити шрифт, щоб втиснути в мінімальний розмір</ShrinkFontToFitMinimumSize>
    <Side>Сторона</Side>
    <Sides>Сторони</Sides>
    <Simple>Простий</Simple>
    <Size>Розмір</Size>
    <SizeMode>Спосіб зміни розміру</SizeMode>
    <SkipFirst>Пропустити першого</SkipFirst>
    <Smoothing>Згладжування</Smoothing>
    <Sort>Сортування</Sort>
    <SortBy>Сортувати по</SortBy>
    <SortDirection>Напрямок сортування</SortDirection>
    <Sorted>Сортувати</Sorted>
    <SortingColumn>Стовпчик для сортування</SortingColumn>
    <SortingEnabled>Сортування увімкнено</SortingEnabled>
    <SortType>Тип сортування</SortType>
    <Space>Пробіл</Space>
    <Spacing>Інтервал</Spacing>
    <SqlCommand>SQL запит</SqlCommand>
    <StartAngle>Початковий кут</StartAngle>
    <StartCap>Тип початку</StartCap>
    <StartColor>Початковий колір</StartColor>
    <StartFromZero>Почати з Нуля</StartFromZero>
    <StartMode>Режим старту</StartMode>
    <StartNewPage>Нова сторінка</StartNewPage>
    <StartNewPageIfLessThan>Нова сторінка якщо менше ніж</StartNewPageIfLessThan>
    <StartPosition>Початкова позиція</StartPosition>
    <Step>Крок</Step>
    <Stop>Зупинити</Stop>
    <StopBeforePage>Зупинитися після сторінки</StopBeforePage>
    <StopBeforePrint>Зупинитися після</StopBeforePrint>
    <StoreImagesInResources>Зберігати зображення в ресурсах</StoreImagesInResources>
    <Stretch>Розтягувати</Stretch>
    <StretchToPrintArea>Розтягнути на область друку</StretchToPrintArea>
    <StripBrush>Пензлик стрічки</StripBrush>
    <Strips>Стрічки</Strips>
    <Style>Стиль</Style>
    <StyleColors>Кольори стилю</StyleColors>
    <Styles>Стилі</Styles>
    <SubReportPage>Сторінка вкладеного звіту</SubReportPage>
    <Summary>Підсумок</Summary>
    <SummaryExpression>Вираз підсумку</SummaryExpression>
    <SummarySortDirection>Напрямок сортування підсумку</SummarySortDirection>
    <SummaryType>Тип підсумку</SummaryType>
    <SummaryValues>Значення підсумку</SummaryValues>
    <SupplementCode>Код доповнення</SupplementCode>
    <SupplementType>Тип доповнення</SupplementType>
    <SystemVariable>Системна змінна</SystemVariable>
    <SystemVariables>Системні змінні</SystemVariables>
    <Table>Таблиця</Table>
    <Tag>Тег</Tag>
    <TagDataColumn>Колонка даних тегів</TagDataColumn>
    <TagValue>Значення тегу</TagValue>
    <Tension>Напруженість</Tension>
    <Text>Текст</Text>
    <TextAfter>Текст після</TextAfter>
    <TextAlign>Вирівнювання тексту</TextAlign>
    <TextAlignment>Вирівнювання тексту</TextAlignment>
    <TextBefore>Текст перед</TextBefore>
    <TextBrush>Текстовий пензлик</TextBrush>
    <TextColor>Колір тексту</TextColor>
    <TextFormat>Форматування</TextFormat>
    <TextOnly>Тільки текст</TextOnly>
    <TextOptions>Параметри тексту</TextOptions>
    <TextQuality>Якість тексту</TextQuality>
    <Ticks>Мітки</Ticks>
    <Title>Заголовок</Title>
    <TitleBeforeHeader>Титул до заголовка</TitleBeforeHeader>
    <TitleColor>Колір заголовка</TitleColor>
    <TitleDirection>Напрямок заголовку</TitleDirection>
    <TitleFont>Шрифт заголовка</TitleFont>
    <TitleVisible>Видимий</TitleVisible>
    <To>По</To>
    <Today>Сьогодні</Today>
    <ToolTip>Підказка</ToolTip>
    <ToolTipDataColumn>Колонка даних підказок</ToolTipDataColumn>
    <Top>Зверху</Top>
    <Topmost>Самий верхній</Topmost>
    <TopmostLine>Лінія зверху</TopmostLine>
    <TopN>Кращі значення</TopN>
    <TopSide>Верхня сторона</TopSide>
    <Total>Підсумок</Total>
    <Totals>Підсумки</Totals>
    <TransparentColor>Колір прозорості</TransparentColor>
    <TrendLine>Лінія тренду</TrendLine>
    <Trimming>Обрізка</Trimming>
    <Type>Тип</Type>
    <TypeName>Назва типу</TypeName>
    <Types>Типи</Types>
    <Underline>Підкреслений</Underline>
    <UndoLimit>Кількість кроків</UndoLimit>
    <Unit>Одиниця виміру</Unit>
    <UnlimitedBreakable>Розривати необмежений</UnlimitedBreakable>
    <UnlimitedHeight>Необмежена висота</UnlimitedHeight>
    <UnlimitedWidth>Необмежена ширина</UnlimitedWidth>
    <UseAliases>Використовувати аліаси</UseAliases>
    <UseExternalReport>Використовувати зовнішній звіт</UseExternalReport>
    <UseParentStyles>Використовувати стилі власника</UseParentStyles>
    <UseRectangularSymbols>Використовувати прямокутні символи</UseRectangularSymbols>
    <UseSeriesColor>Використати кольори рядів</UseSeriesColor>
    <UseStyleOfSummaryInColumnTotal>Використовувати стиль результату в стовпчику підсумку</UseStyleOfSummaryInColumnTotal>
    <UseStyleOfSummaryInRowTotal>Використовувати стиль результату в стрічці підсумку</UseStyleOfSummaryInRowTotal>
    <Value>Значення</Value>
    <ValueClose>Значення закриття</ValueClose>
    <ValueDataColumn>Стовпчик даних значень</ValueDataColumn>
    <ValueDataColumnClose>Стовпчик даних значень закриття</ValueDataColumnClose>
    <ValueDataColumnEnd>Колонка даних кінцевих значень</ValueDataColumnEnd>
    <ValueDataColumnHigh>Стовпчик даних максимумів</ValueDataColumnHigh>
    <ValueDataColumnLow>Стовпчик даних мінімумів</ValueDataColumnLow>
    <ValueDataColumnOpen>Стовпчик даних значень відкриття</ValueDataColumnOpen>
    <ValueEnd>Кінцеве значення</ValueEnd>
    <ValueHigh>Значення максимуму</ValueHigh>
    <ValueLow>Значення мінімуму</ValueLow>
    <ValueOpen>Значення відкриття</ValueOpen>
    <Values>Значення</Values>
    <ValueType>Тип значення</ValueType>
    <ValueTypeSeparator>Тип роздільника значень</ValueTypeSeparator>
    <Variable>Змінна</Variable>
    <Variables>Змінні</Variables>
    <Version>Версія</Version>
    <VertAlignment>Вертикальне вирівнювання</VertAlignment>
    <VertSpacing>Вертикальна відстань</VertSpacing>
    <ViewMode>Вигляд сторінки</ViewMode>
    <Visible>Видимість</Visible>
    <Watermark>Водяний знак</Watermark>
    <Weight>Вага</Weight>
    <WeightDataColumn>Колонка даних значень ваги</WeightDataColumn>
    <Width>Ширина</Width>
    <WindowState>Стан вікна</WindowState>
    <WordWrap>Перенос тексту</WordWrap>
    <Wrap>Перенос</Wrap>
    <WrapGap>Проміжок переносу</WrapGap>
    <XAxis>Вісь X</XAxis>
    <XTopAxis>X Вісь Верхня</XTopAxis>
    <YAxis>Вісь Y</YAxis>
    <YRightAxis>Y Вісь Права</YRightAxis>
    <Zoom>Масштаб</Zoom>
  </PropertyMain>
  <PropertySystemColors>
    <ActiveBorder>Границя активного вікна</ActiveBorder>
    <ActiveCaption>Заголовок активного вікна</ActiveCaption>
    <ActiveCaptionText>Текст заголовка активного вікна</ActiveCaptionText>
    <AppWorkspace>Робоча область додатка</AppWorkspace>
    <Control>Кнопка</Control>
    <ControlDark>Кнопка темна</ControlDark>
    <ControlDarkDark>Кнопка найтемніша</ControlDarkDark>
    <ControlLight>Кнопка світла</ControlLight>
    <ControlLightLight>Кнопка найясніша</ControlLightLight>
    <ControlText>Текст кнопки</ControlText>
    <Desktop>Робочий стіл</Desktop>
    <GrayText>Текст недоступний</GrayText>
    <Highlight>Виділений фон</Highlight>
    <HighlightText>Виділений текст</HighlightText>
    <HotTrack>Підсвічений</HotTrack>
    <InactiveBorder>Границя неактивного вікна</InactiveBorder>
    <InactiveCaption>Заголовок неактивного вікна</InactiveCaption>
    <InactiveCaptionText>Текст заголовка неактивного вікна</InactiveCaptionText>
    <Info>Підказка</Info>
    <InfoText>Текст підказки</InfoText>
    <Menu>Фон меню</Menu>
    <MenuText>Текст меню</MenuText>
    <ScrollBar>Смуга прокручування</ScrollBar>
    <Window>Фон вікна</Window>
    <WindowFrame>Рамка вікна</WindowFrame>
    <WindowText>Текст вікна</WindowText>
  </PropertySystemColors>
  <QueryBuilder>
    <AddObject>Додати об'єкт</AddObject>
    <AddSubQuery>Додати похідну таблицю(SubQuery)</AddSubQuery>
    <AllObjects>(Всі об'єкти)</AllObjects>
    <BadFromObjectExpression>Неправильний вираз FROM об'єкта!</BadFromObjectExpression>
    <BadObjectName>Неправильна назва об'єкта!</BadObjectName>
    <BadSelectStatement>Неправильний вираз SELECT!</BadSelectStatement>
    <CreateLinksFromForeignKeys>Створити зв'язки з зовнішніх ключів</CreateLinksFromForeignKeys>
    <CriteriaAlias>Аліас</CriteriaAlias>
    <CriteriaCriteria>Критерій</CriteriaCriteria>
    <CriteriaExpression>Вираз</CriteriaExpression>
    <CriteriaGroupBy>Сортувати за</CriteriaGroupBy>
    <CriteriaOr>Or...</CriteriaOr>
    <CriteriaOutput>Вивід</CriteriaOutput>
    <CriteriaSortOrder>Порядок сортування</CriteriaSortOrder>
    <CriteriaSortType>Тип сортування</CriteriaSortType>
    <Database>База Даних(БД)</Database>
    <DataSourceProperties>Властивості джерела даних</DataSourceProperties>
    <DialectDontSupportDatabases>Сервер не підтримує запити до об'єктів з різних БД.</DialectDontSupportDatabases>
    <DialectDontSupportSchemas>Сервер не підтримує схеми.</DialectDontSupportSchemas>
    <DialectDontSupportUnions>Сервер не підтримує об'єднання (unions).</DialectDontSupportUnions>
    <DialectDontSupportUnionsBrackets>Сервер не підтримує дужок в об'єднаннях.</DialectDontSupportUnionsBrackets>
    <DialectDontSupportUnionsBracketsInSubQuery>Сервер не підтримує дужок в об'єднаннях в підзапитах (subqueries).</DialectDontSupportUnionsBracketsInSubQuery>
    <DialectDontSupportUnionsInSubQueries>Сервер не підтримує об'єднань (unions) в підзапитах (subqueries).</DialectDontSupportUnionsInSubQueries>
    <Edit>Редагування</Edit>
    <EncloseWithBrackets>Додати дужки</EncloseWithBrackets>
    <Expressions>Вирази</Expressions>
    <InsertEmptyItem>Добавити порожній елемент</InsertEmptyItem>
    <JoinExpression>Добавити вираз (Join Expression)</JoinExpression>
    <LabelAlias>Аліас:</LabelAlias>
    <LabelFilterObjectsBySchemaName>Фільтрувати об'єкти за схемою:</LabelFilterObjectsBySchemaName>
    <LabelJoinExpression>Join Вираз:</LabelJoinExpression>
    <LabelLeftColumn>Лівий стовпчик:</LabelLeftColumn>
    <LabelLeftObject>Лівий об'єкт:</LabelLeftObject>
    <LabelObject>Об'єкт:</LabelObject>
    <LabelRightColumn>Правий стовпчик:</LabelRightColumn>
    <LabelRightObject>Правий об'єкт:</LabelRightObject>
    <LinkProperties>Властивості зв'язку</LinkProperties>
    <MetadataProviderCantExecSQL>&gt;Вибраний провайдер метаданих не може виконувати SQL запити.</MetadataProviderCantExecSQL>
    <MetaProviderCantLoadMetadata>&gt;Вибраний провайдер метаданих не може автоматично завантажити метадані.</MetaProviderCantLoadMetadata>
    <MetaProviderCantLoadMetadataForDatabase>Вибраний провайдер метаданих не може автоматично завантажити метадані з БД: {0}</MetaProviderCantLoadMetadataForDatabase>
    <MoveDown>Перемістити Вниз</MoveDown>
    <MoveUp>Перемістити Вгору</MoveUp>
    <NewUnionSubQuery>Новий підзапит об'єднання</NewUnionSubQuery>
    <NoConnectionObject>Немає об'єкту зв'язку (властивість {0} не задана).</NoConnectionObject>
    <NoTransactionObject>Немає об'єкту транзакції (властивість {0} не задана).</NoTransactionObject>
    <Objects>Об'єкти</Objects>
    <ProcedureParameters>Параметри Процедури</ProcedureParameters>
    <Procedures>Процедури</Procedures>
    <qnSaveChanges>Бажаєте зберегти зміни до запиту?</qnSaveChanges>
    <Query>Запит</Query>
    <QueryBuilder>Конструктор Запитів</QueryBuilder>
    <QueryParameters>Параметри Запиту</QueryParameters>
    <QueryProperties>Властивості Запиту</QueryProperties>
    <Remove>Видалити</Remove>
    <RemoveBrackets>Видалити дужки</RemoveBrackets>
    <RunQueryBuilder>Запустити конструктор запитів</RunQueryBuilder>
    <SelectAllFromLeft>Вибрати все зліва</SelectAllFromLeft>
    <SelectAllFromRight>Вибрати все справа</SelectAllFromRight>
    <SwitchToDerivedTable>Перемкнути на отриману таблицю</SwitchToDerivedTable>
    <Tables>Таблиці</Tables>
    <UnexpectedTokenAt>Неочікуваний знак "{0}" у стрічці {1}, позиція {2}!</UnexpectedTokenAt>
    <Unions>Об'єднання</Unions>
    <UnionSubMenu>Об'єднання</UnionSubMenu>
    <ViewQuery>Перегляд запиту</ViewQuery>
    <Views>Запити</Views>
  </QueryBuilder>
  <Questions>
    <qnConfiguration>Будь ласка, виберіть тип конфігурації для панелі властивостей. Від типу обраної конфігурації залежить кількість відображуваних властивостей та їх складність для розробника звітів. Ви завжди зможете змінити тип конфігурації з контекстного меню панелі властивостей.</qnConfiguration>
    <qnDictionaryNew>Створити новий словник?</qnDictionaryNew>
    <qnLanguageNew>Ви змінили мову звіту, це приведе до генерації нового коду звіту. Ви впевнені, що хочете зберегти нову мову?</qnLanguageNew>
    <qnPageDelete>Видалити сторінку?</qnPageDelete>
    <qnRemove>Видалити?</qnRemove>
    <qnRemoveService>Видалити сервіс?</qnRemoveService>
    <qnRemoveServiceCategory>Видалити категорію?</qnRemoveServiceCategory>
    <qnRemoveUnused>Видалити невикористовуване?</qnRemoveUnused>
    <qnRestoreDefault>Відновити значення за замовчуванням?</qnRestoreDefault>
    <qnSaveChanges>Зберегти зміни в {0}?</qnSaveChanges>
    <qnSaveChangesToPreviewPage>Зберегти зміни поточної сторінки?</qnSaveChangesToPreviewPage>
    <qnSynchronize>Синхронізувати вміст Сховища Даних і вміст Словника?</qnSynchronize>
    <qnSynchronizeServices>Синхронізувати сервіси?</qnSynchronizeServices>
  </Questions>
  <Report>
    <Alphabetical>За алфавітом</Alphabetical>
    <Bands>Бенди</Bands>
    <Basic>Базовий</Basic>
    <BasicConfiguration>Мінімальна кількість властивостей об'єктів, які потрібні для побудови основних типів звітів.</BasicConfiguration>
    <BusinessObjects>Бізнес-об'єкт</BusinessObjects>
    <Categorized>За категоріями</Categorized>
    <Charts>Діаграми</Charts>
    <ClickForMoreDetails>Натисніть для перегляду</ClickForMoreDetails>
    <CollapseAll>Згорнути всі</CollapseAll>
    <Collection>Колекція</Collection>
    <CompilingReport>Компіляція звіту</CompilingReport>
    <Complete>Повний</Complete>
    <Components>Компоненти</Components>
    <ConnectingToData>Під'єднання до Даних</ConnectingToData>
    <CopyOf>Копія</CopyOf>
    <CreateNewReportPageForm>Створити новий звіт, додати сторінки, додати форму</CreateNewReportPageForm>
    <CreatingReport>Створення Звіту</CreatingReport>
    <CrossBands>Крос</CrossBands>
    <Dialogs>Елементи керування</Dialogs>
    <EditStyles>Редагувати стилі</EditStyles>
    <Errors>Помилки</Errors>
    <EventsTab>Події</EventsTab>
    <ExpandAll>Розгорнути всі</ExpandAll>
    <FilterAnd>І</FilterAnd>
    <FilterOr>Або</FilterOr>
    <FinishingReport>Завершення Звіту</FinishingReport>
    <FirstPass>Перший прохід</FirstPass>
    <GenerateNewCode>Генерувати новий код</GenerateNewCode>
    <InfoMessage>{0} - {1} знайдено.</InfoMessage>
    <InformationMessages>Інформаційні повідомлення</InformationMessages>
    <LabelAlias>Псевдонім:</LabelAlias>
    <LabelAuthor>Автор:</LabelAuthor>
    <LabelBackground>Фон:</LabelBackground>
    <LabelCategory>Категорія:</LabelCategory>
    <LabelCentimeters>Сантиметри:</LabelCentimeters>
    <LabelCollectionName>Назва колекції:</LabelCollectionName>
    <LabelColor>Колір:</LabelColor>
    <LabelCountData>Кількість даних:</LabelCountData>
    <LabelDataBand>Дані:</LabelDataBand>
    <LabelDataColumn>Стовпчик з даними:</LabelDataColumn>
    <LabelDefaultValue>За замовчуванням:</LabelDefaultValue>
    <LabelExpression>Вираз:</LabelExpression>
    <LabelFactorLevel>Рівень:</LabelFactorLevel>
    <LabelFontName>Назва шрифту:</LabelFontName>
    <LabelFunction>Функція:</LabelFunction>
    <LabelHundredthsOfInch>Соті дюйма:</LabelHundredthsOfInch>
    <LabelInches>Дюйми:</LabelInches>
    <LabelMillimeters>Міліметри:</LabelMillimeters>
    <LabelName>Назва:</LabelName>
    <LabelNameInSource>Назва в джерелі:</LabelNameInSource>
    <LabelNestedLevel>Рівень вкладеності:</LabelNestedLevel>
    <LabelPassword>Пароль:</LabelPassword>
    <LabelPixels>Пікселі:</LabelPixels>
    <LabelSystemVariable>Системні змінні:</LabelSystemVariable>
    <LabelTotals>Підсумки:</LabelTotals>
    <LabelType>Тип:</LabelType>
    <LabelUserName>Логін:</LabelUserName>
    <LabelValue>Значення:</LabelValue>
    <LoadingReport>Завантаження звіту</LoadingReport>
    <nameAssembly>Збірка</nameAssembly>
    <No>Ні</No>
    <NoIssues>Немає проблем</NoIssues>
    <NotAssigned>Не призначено</NotAssigned>
    <Office2010Back>Назад</Office2010Back>
    <PageNofM>Сторінка {0} із {1}</PageNofM>
    <PreparingReport>Підготовка звіту</PreparingReport>
    <Professional>Професійний</Professional>
    <ProfessionalConfiguration>Всі властивості об'єктів без виключення.</ProfessionalConfiguration>
    <PropertiesTab>Властивості</PropertiesTab>
    <RangeAll>все</RangeAll>
    <RangeCurrentPage>поточна</RangeCurrentPage>
    <RangeInfo>Вкажіть номери або діапазони сторінок, розділені комами. Наприклад: 1, 3, 5-12</RangeInfo>
    <RangePage>Сторінки:</RangePage>
    <RangePages>номери</RangePages>
    <ReportChecker>Перевірка</ReportChecker>
    <ReportRenderingMessages>Повідомлення звіту</ReportRenderingMessages>
    <RestartDesigner>Вам потрібно перезапустити дизайнер звітів</RestartDesigner>
    <SaveReportPagesOrFormsFromReport>Зберегти звіт, сторінки або форми</SaveReportPagesOrFormsFromReport>
    <SavingReport>Збереження звіту</SavingReport>
    <SecondPass>Другий прохід</SecondPass>
    <Shapes>Примітиви</Shapes>
    <Standard>Стандартний</Standard>
    <StandardConfiguration>Основні властивості об'єктів, за виключенням властивостей, що рідко використовуються.</StandardConfiguration>
    <StiEmptyBrush>Немає</StiEmptyBrush>
    <StiGlareBrush>Відблиск</StiGlareBrush>
    <StiGlassBrush>Скло</StiGlassBrush>
    <StiGradientBrush>Градієнт</StiGradientBrush>
    <StiHatchBrush>Текстура</StiHatchBrush>
    <StiSolidBrush>Суцільний</StiSolidBrush>
    <StyleBad>Погано</StyleBad>
    <StyleGood>Добре</StyleGood>
    <StyleNeutral>Нейтрально</StyleNeutral>
    <StyleNormal>Нормально</StyleNormal>
    <StyleNote>Примітки</StyleNote>
    <StyleWarning>Попередження</StyleWarning>
    <Warnings>Попередження</Warnings>
    <When>якщо {0} {1}</When>
    <WhenAnd>якщо {0} {1} та</WhenAnd>
    <WhenValueIs>якщо значення рівне</WhenValueIs>
  </Report>
  <Services>
    <categoryContextTools>Контекстне меню дизайнера</categoryContextTools>
    <categoryDesigner>Дизайнер</categoryDesigner>
    <categoryDictionary>Словник</categoryDictionary>
    <categoryExport>Експорт</categoryExport>
    <categoryLanguages>Мови</categoryLanguages>
    <categoryPanels>Панелі</categoryPanels>
    <categoryRender>Побудова звітів</categoryRender>
    <categoryShapes>Геометрія</categoryShapes>
    <categorySL>Сервіси збереження / завантаження</categorySL>
    <categorySystem>Система</categorySystem>
    <categoryTextFormat>Формат</categoryTextFormat>
  </Services>
  <Shapes>
    <Arrow>Стрілка</Arrow>
    <BasicShapes>Основні фігури</BasicShapes>
    <BentArrow>Зігнута стрілка</BentArrow>
    <BlockArrows>Стрілки</BlockArrows>
    <Chevron>Шеврон</Chevron>
    <ComplexArrow>Подвійна стрілка</ComplexArrow>
    <DiagonalDownLine>Діагональна лінія вниз</DiagonalDownLine>
    <DiagonalUpLine>Діагональна лінія нагору</DiagonalUpLine>
    <Division>Знак ділення</Division>
    <Equal>Знак рівності</Equal>
    <EquationShapes>Примітиви операцій</EquationShapes>
    <FlowchartCard>Блок-схема: Картка</FlowchartCard>
    <FlowchartCollate>Блок-схема: Співставлення</FlowchartCollate>
    <FlowchartDecision>Блок-схема: Рішення</FlowchartDecision>
    <FlowchartManualInput>Блок-схема: Ручне введення</FlowchartManualInput>
    <FlowchartOffPageConnector>Блок-схема: Посилання на іншу сторінку</FlowchartOffPageConnector>
    <FlowchartPreparation>Блок-схема: Підготовка</FlowchartPreparation>
    <FlowchartSort>Блок-схема: Сортування</FlowchartSort>
    <Frame>Рамка</Frame>
    <HorizontalLine>Горизонтальна лінія</HorizontalLine>
    <InsertShapes>Вставити примітив</InsertShapes>
    <LeftAndRightLine>Лінія ліворуч і праворуч</LeftAndRightLine>
    <Lines>Лінії</Lines>
    <Minus>Мінус</Minus>
    <Multiply>Знак множення</Multiply>
    <Oval>Овал</Oval>
    <Parallelogram>Паралелограм</Parallelogram>
    <Plus>Плюс</Plus>
    <Rectangle>Прямокутник</Rectangle>
    <Rectangles>Прямокутники</Rectangles>
    <RegularPentagon>Правильний п'ятикутник</RegularPentagon>
    <RoundedRectangle>Заокруглений прямокутник</RoundedRectangle>
    <ServiceCategory>Геометрія</ServiceCategory>
    <ShapeStyles>Стилі фігур</ShapeStyles>
    <SnipDiagonalSideCornerRectangle />
    <SnipSameSideCornerRectangle>Прямокутник із двома вирізаними протилежними кутами</SnipSameSideCornerRectangle>
    <TopAndBottomLine>Лінія зверху та знизу</TopAndBottomLine>
    <Trapezoid>Трапеція</Trapezoid>
    <Triangle>Трикутник</Triangle>
    <VerticalLine>Вертикальна лінія</VerticalLine>
  </Shapes>
  <SystemVariables>
    <Column>Номер поточного стовпчику (Починається з 1).</Column>
    <GroupLine>Номер поточної групи (Починається з 1).</GroupLine>
    <IsFirstPage>Повертає значення Істина, якщо в цей час друкується перша сторінка звіту.</IsFirstPage>
    <IsFirstPageThrough>Повертає значення Істина, якщо в цей час друкується перша сторінка звіту. При розрахунку змінної, всі параметри, що скидають номер сторінки ігноруються. Розрахунок ведеться з початку звіту.</IsFirstPageThrough>
    <IsLastPage>Повертає значення Істина, якщо в цей час друкується остання сторінка звіту. Для коректного розрахунку змінної, звіт має бути двопрохідним.</IsLastPage>
    <IsLastPageThrough>Повертає значення Істина, якщо в цей час друкується остання сторінка звіту. Для коректного розрахунку змінної, звіт має бути двопрохідним. При розрахунку змінної, всі параметри, що скидають номер сторінки ігноруються. Розрахунок ведеться з початку звіту.</IsLastPageThrough>
    <Line>Номер поточної лінії (Починається з 1).</Line>
    <LineABC>Літерний аналог номеру поточної лінії.</LineABC>
    <LineRoman>Номер поточної лінії, що представлена римськими цифрами.</LineRoman>
    <LineThrough>Номер поточної лінії (Починається з 1). При розрахунку ігноруються всі групи в звіті, та розрахунок ведеться з початку звіту.</LineThrough>
    <PageCopyNumber>Повертає номер поточного копії сторінки (починаючи з 1).</PageCopyNumber>
    <PageNofM>Локалізований рядок, що відображає напис "Сторінка N із M", де N це номер поточної сторінки, а M - це загальна кількість сторінок в звіті.</PageNofM>
    <PageNofMThrough>Локалізований рядок, що відображає напис "Сторінка N із M", де N це номер поточної сторінки, а M - це загальна кількість сторінок в звіті. При розрахунку змінної, всі параметри, що скидають номер сторінки ігноруються. Розрахунок ведеться з початку звіту.</PageNofMThrough>
    <PageNumber>Поточний номер сторінки (Починається з 1).</PageNumber>
    <PageNumberThrough>Поточний номер сторінки (Починається з 1). При розрахунку змінної, всі параметри, що скидають номер сторінки ігноруються. Розрахунок ведеться з початку звіту.</PageNumberThrough>
    <ReportAlias>Псевдонім звіту.</ReportAlias>
    <ReportAuthor>Автор звіту.</ReportAuthor>
    <ReportChanged>Дата, коли звіт було змінено востаннє.</ReportChanged>
    <ReportCreated>Дата, коли звіт було створено.</ReportCreated>
    <ReportDescription>Опис звіту.</ReportDescription>
    <ReportName>Назва звіту.</ReportName>
    <Time>Поточний час.</Time>
    <Today>Поточна дата.</Today>
    <TotalPageCount>Кількість сторінок в звіті.</TotalPageCount>
    <TotalPageCountThrough>Загальна кількість сторінок в звіті. При розрахунку змінної, всі параметри, що скидають номер сторінки ігноруються. Розрахунок ведеться з початку звіту.</TotalPageCountThrough>
  </SystemVariables>
  <TableRibbon>
    <BuiltIn>Вбудовані</BuiltIn>
    <Delete>Видалити</Delete>
    <DeleteColumns>Видалити стовпчики</DeleteColumns>
    <DeleteRows>Видалити рядки</DeleteRows>
    <DeleteTable>Видалити таблицю</DeleteTable>
    <DistributeColumns>Розподілити стовпчики</DistributeColumns>
    <DistributeRows>Розподілити рядки</DistributeRows>
    <InsertAbove>Вставити вище</InsertAbove>
    <InsertBelow>Вставити нижче</InsertBelow>
    <InsertLeft>Вставити ліворуч</InsertLeft>
    <InsertRight>Вставити праворуч</InsertRight>
    <PlainTables>Прості таблиці</PlainTables>
    <ribbonBarRowsColumns>Стовпчики і рядки</ribbonBarRowsColumns>
    <ribbonBarTable>Таблиця</ribbonBarTable>
    <ribbonBarTableStyles>Стилі таблиці</ribbonBarTableStyles>
    <Select>Вибрати</Select>
    <SelectColumn>Вибрати стовпчик</SelectColumn>
    <SelectRow>Вибрати рядок</SelectRow>
    <SelectTable>Вибрати таблицю</SelectTable>
  </TableRibbon>
  <Toolbars>
    <Align>Вирівнювання</Align>
    <AlignBottom>Вирівняти по нижньому краю</AlignBottom>
    <AlignCenter>Вирівняти по горизонталі по центру</AlignCenter>
    <AlignLeft>Вирівняти по лівому краю</AlignLeft>
    <AlignMiddle>Вирівняти по вертикалі по центру</AlignMiddle>
    <AlignRight>Вирівняти по правому краю</AlignRight>
    <AlignToGrid>Вирівняти по вузлах сітки</AlignToGrid>
    <AlignTop>Вирівняти по верхньому краю</AlignTop>
    <AlignWidth>Вирівняти по ширині</AlignWidth>
    <BringToFront>Помістити на передній план</BringToFront>
    <CenterHorizontally>Центрувати по горизонталі</CenterHorizontally>
    <CenterVertically>Центрувати по вертикалі</CenterVertically>
    <Conditions>Умови</Conditions>
    <FontGrow>Збільшити шрифт</FontGrow>
    <FontName>Назва шрифту</FontName>
    <FontShrink>Зменшити шрифт</FontShrink>
    <FontSize>Розмір шрифту</FontSize>
    <FontStyleBold>Жирний шрифт</FontStyleBold>
    <FontStyleItalic>Похилий шрифт</FontStyleItalic>
    <FontStyleUnderline>Підкреслений шрифт</FontStyleUnderline>
    <Link>Зв'язок</Link>
    <Lock>Замок</Lock>
    <MakeHorizontalSpacingEqual>Зробити по горизонталі еквівалентно відстані</MakeHorizontalSpacingEqual>
    <MakeSameHeight>Зробити ту ж висоту, що й в {0}</MakeSameHeight>
    <MakeSameSize>Зробити той же розмір, що й в {0}</MakeSameSize>
    <MakeSameWidth>Зробити ту ж ширину, що й в {0}</MakeSameWidth>
    <MakeVerticalSpacingEqual>Зробити по вертикалі еквівалентно відстані</MakeVerticalSpacingEqual>
    <MoveBackward>Перемістити назад</MoveBackward>
    <MoveForward>Перемістити вперед</MoveForward>
    <Order>Порядок</Order>
    <SendToBack>Помістити на задній план</SendToBack>
    <Size>Розмір</Size>
    <StyleDesigner>Редактор стилів</StyleDesigner>
    <Styles>Список стилів</Styles>
    <TabHome>Домашня</TabHome>
    <TabLayout>Розташування</TabLayout>
    <TabPage>Сторінка</TabPage>
    <TabView>Вигляд</TabView>
    <TextBrush>Пензлик тексту</TextBrush>
    <ToolbarAlignment>Вирівнювання</ToolbarAlignment>
    <ToolbarArrange>Порядок</ToolbarArrange>
    <ToolbarBorders>Границі</ToolbarBorders>
    <ToolbarClipboard>Буфер обміну</ToolbarClipboard>
    <ToolbarDockStyle>Стиль стикування</ToolbarDockStyle>
    <ToolbarFont>Шрифт</ToolbarFont>
    <ToolbarFormatting>Форматування</ToolbarFormatting>
    <ToolbarLayout>Дизайн</ToolbarLayout>
    <ToolbarPageSetup>Настройка сторінки</ToolbarPageSetup>
    <ToolbarStandard>Стандарт</ToolbarStandard>
    <ToolbarStyle>Стилі</ToolbarStyle>
    <ToolbarTextFormat>Формат тексту</ToolbarTextFormat>
    <ToolbarTools>Сервіс</ToolbarTools>
    <ToolbarViewOptions>Параметри перегляду</ToolbarViewOptions>
    <ToolbarWatermarkImage>Водяний знак - Зображення</ToolbarWatermarkImage>
    <ToolbarWatermarkText>Водяний знак - Текст</ToolbarWatermarkText>
  </Toolbars>
  <Toolbox>
    <Create>Створення компонентів</Create>
    <Hand>Рука</Hand>
    <Select>Вибір</Select>
    <Style>Копіювання стилю</Style>
    <TextEditor>Редактор тексту</TextEditor>
    <title>Інструментарій</title>
  </Toolbox>
  <Wizards>
    <BlankReport>Порожній звіт</BlankReport>
    <ButtonBack>&lt; &amp;Назад</ButtonBack>
    <ButtonCancel>Відмінити</ButtonCancel>
    <ButtonFinish>&amp;Готово</ButtonFinish>
    <ButtonNext>&amp;Далі &gt;</ButtonNext>
    <ColumnsOrder>Порядок стовпчиків</ColumnsOrder>
    <Custom>Вибірково</Custom>
    <DataRelation>Зв'язок</DataRelation>
    <DataSource>Джерело даних</DataSource>
    <DataSources>Набори даних</DataSources>
    <DefaultThemes>Вбудовані теми</DefaultThemes>
    <Filters>Фільтри</Filters>
    <FromReportTemplate>З шаблону звіту</FromReportTemplate>
    <groupCreateNewPageOrForm>Створити нову сторінку або форму</groupCreateNewPageOrForm>
    <groupCreateNewReport>Створити новий звіт</groupCreateNewReport>
    <Groups>Групування</Groups>
    <groupTemplates>Шаблони</groupTemplates>
    <groupWizards>Помічники</groupWizards>
    <infoColumnsOrder>Розташуйте стовпчики в необхідному порядку.</infoColumnsOrder>
    <infoDataSource>Виберіть одне джерело даних.</infoDataSource>
    <infoDataSources>Виберіть набір даних з доступних наборів.</infoDataSources>
    <infoFilters>Відфільтруйте дані для вашого звіту</infoFilters>
    <infoGroups>Виберіть стовпчики, по яких необхідно згрупувати дані.</infoGroups>
    <infoLabelSettings>Виберіть настройки етикеток.</infoLabelSettings>
    <infoLayout>Оберіть розташування звіту.</infoLayout>
    <infoRelation>Виберіть один Зв'язок даних з доступних.</infoRelation>
    <infoSelectColumns>Виберіть стовпчики для розміщення у звіті.</infoSelectColumns>
    <infoSort>Налаштуйте сортування даних. Допускається сортування відразу по декількох полях.</infoSort>
    <infoThemes>Оберіть тему оформлення для Вашого звіту.</infoThemes>
    <infoTotals>Додайте підсумкову інформацію у звіт.</infoTotals>
    <LabelDirection>Напрямок:</LabelDirection>
    <LabelHeight>Висота:</LabelHeight>
    <LabelHorizontalGap>Горизонтальний інтервал:</LabelHorizontalGap>
    <LabelLabelType>Тип напису:</LabelLabelType>
    <LabelLeftMargin>Лівий край:</LabelLeftMargin>
    <LabelNumberOfColumns>Кількість стовпчиків:</LabelNumberOfColumns>
    <LabelNumberOfRows>Кількість рядків:</LabelNumberOfRows>
    <LabelPageHeight>Висота сторінки:</LabelPageHeight>
    <LabelPageWidth>Ширина сторінки:</LabelPageWidth>
    <LabelReport>Звіт з етикетками</LabelReport>
    <LabelSettings>Настройка етикеток</LabelSettings>
    <LabelSize>Розмір:</LabelSize>
    <LabelTopMargin>Верхній край:</LabelTopMargin>
    <LabelVerticalGap>Вертикальний інтервал:</LabelVerticalGap>
    <LabelWidth>Ширина:</LabelWidth>
    <Layout>Розташування</Layout>
    <MarkAll>Відмінити &amp;Всі</MarkAll>
    <MasterDetailReport>Master-Detail Звіт</MasterDetailReport>
    <NoFunction>[Немає]</NoFunction>
    <OpenExistingReport>Відкрити існуючий звіт</OpenExistingReport>
    <Preview>Перегляд</Preview>
    <Reset>&amp;Скинути</Reset>
    <Results>Результати</Results>
    <SelectColumns>Вибір стовпчиків</SelectColumns>
    <Sort>Сортування</Sort>
    <StandardReport>Стандартний звіт</StandardReport>
    <Themes>Теми</Themes>
    <title>Новий звіт</title>
    <Totals>Підсумки</Totals>
    <UsingReportWizard>Майстер Звіту</UsingReportWizard>
  </Wizards>
  <Zoom>
    <EmptyValue>Порожнє значення</EmptyValue>
    <MultiplePages>Кілька сторінок</MultiplePages>
    <OnePage>Одна сторінка</OnePage>
    <PageHeight>По висоті сторінки</PageHeight>
    <PageWidth>По ширині сторінки</PageWidth>
    <TwoPages>Дві сторінки</TwoPages>
    <ZoomTo100>Масштаб в 100%</ZoomTo100>
  </Zoom>
</Localization>`;

export default lang;
